(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[722],{

/***/ 5163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ registerComponents; }
});

// UNUSED EXPORTS: awaitBuilderData

// NAMESPACE OBJECT: ./components/business-article-grid/business-article-grid.builder-component.ts
var business_article_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_grid_builder_component_namespaceObject);
__webpack_require__.d(business_article_grid_builder_component_namespaceObject, {
  "BusinessArticleGridBuilderConfig": function() { return business_article_grid_builder_component_BusinessArticleGridBuilderConfig; },
  "default": function() { return business_article_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.builder-component.ts
var business_featured_article_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_featured_article_hero_builder_component_namespaceObject);
__webpack_require__.d(business_featured_article_hero_builder_component_namespaceObject, {
  "FullWidthArticleHeroBuilderConfig": function() { return FullWidthArticleHeroBuilderConfig; },
  "default": function() { return business_featured_article_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-image/business-article-image.builder-component.ts
var business_article_image_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_image_builder_component_namespaceObject);
__webpack_require__.d(business_article_image_builder_component_namespaceObject, {
  "BusinessArticleImageBuilderConfig": function() { return BusinessArticleImageBuilderConfig; },
  "default": function() { return business_article_image_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-quote/business-article-quote-wrap.builder-component.ts
var business_article_quote_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_quote_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_article_quote_wrap_builder_component_namespaceObject, {
  "BusinessArticleQuoteWrapBuilderConfig": function() { return BusinessArticleQuoteWrapBuilderConfig; },
  "default": function() { return business_article_quote_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-button/business-button-wrap.builder-component.ts
var business_button_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_button_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_button_wrap_builder_component_namespaceObject, {
  "BusinessButtonWrapBuilderConfig": function() { return BusinessButtonWrapBuilderConfig; },
  "default": function() { return business_button_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-emphasized-text/business-emphasized-text.builder-component.ts
var business_emphasized_text_builder_component_namespaceObject = {};
__webpack_require__.r(business_emphasized_text_builder_component_namespaceObject);
__webpack_require__.d(business_emphasized_text_builder_component_namespaceObject, {
  "BusinessEmphasizedTextBuilderConfig": function() { return BusinessEmphasizedTextBuilderConfig; },
  "default": function() { return business_emphasized_text_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-framed-info-block/business-framed-info-block.builder-component.ts
var business_framed_info_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_framed_info_block_builder_component_namespaceObject);
__webpack_require__.d(business_framed_info_block_builder_component_namespaceObject, {
  "BusinessFramedInfoBlockBuilderConfig": function() { return BusinessFramedInfoBlockBuilderConfig; },
  "default": function() { return business_framed_info_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-headlining-latest-articles/business-headlining-latest-articles.builder-component.ts
var business_headlining_latest_articles_builder_component_namespaceObject = {};
__webpack_require__.r(business_headlining_latest_articles_builder_component_namespaceObject);
__webpack_require__.d(business_headlining_latest_articles_builder_component_namespaceObject, {
  "HeadliningLatestArticlesBuilderConfig": function() { return business_headlining_latest_articles_builder_component_HeadliningLatestArticlesBuilderConfig; },
  "default": function() { return business_headlining_latest_articles_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-all-button/business-resource-download-all-button.builder-component.ts
var business_resource_download_all_button_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_all_button_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_all_button_builder_component_namespaceObject, {
  "default": function() { return business_resource_download_all_button_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-grid/business-resource-grid.builder-component.ts
var business_resource_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_grid_builder_component_namespaceObject);
__webpack_require__.d(business_resource_grid_builder_component_namespaceObject, {
  "default": function() { return business_resource_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-container/business-resource-asset-container.builder-component.ts
var business_resource_asset_container_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_container_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_container_builder_component_namespaceObject, {
  "default": function() { return business_resource_asset_container_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-library/business-resource-asset-library.builder-component.ts
var business_resource_asset_library_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_library_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_library_builder_component_namespaceObject, {
  "BusinessResourceAssetBuilderConfig": function() { return BusinessResourceAssetBuilderConfig; },
  "default": function() { return business_resource_asset_library_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.builder-component.ts
var business_resource_background_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_background_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_resource_background_text_wrap_builder_component_namespaceObject, {
  "BusinessResourceBackgroundTextWrapBuilderConfig": function() { return BusinessResourceBackgroundTextWrapBuilderConfig; },
  "default": function() { return business_resource_background_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-banner-carousel/business-resource-asset.builder-component.ts
var business_resource_asset_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_builder_component_namespaceObject, {
  "BusinessResourceBannerCarouselBuilderConfig": function() { return BusinessResourceBannerCarouselBuilderConfig; },
  "default": function() { return business_resource_asset_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-banners/business-resource-banners.builder-component.ts
var business_resource_banners_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_banners_builder_component_namespaceObject);
__webpack_require__.d(business_resource_banners_builder_component_namespaceObject, {
  "BusinessResourceBannersBuilderConfig": function() { return BusinessResourceBannersBuilderConfig; },
  "default": function() { return business_resource_banners_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-card/business-resource-card.builder-component.ts
var business_resource_card_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_card_builder_component_namespaceObject);
__webpack_require__.d(business_resource_card_builder_component_namespaceObject, {
  "BusinessResourceCardBuilderConfig": function() { return BusinessResourceCardBuilderConfig; },
  "default": function() { return business_resource_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-centre-hero/business-resource-centre-hero.builder-component.ts
var business_resource_centre_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_centre_hero_builder_component_namespaceObject);
__webpack_require__.d(business_resource_centre_hero_builder_component_namespaceObject, {
  "BusinessResourceCentreHeroBuilderConfig": function() { return BusinessResourceCentreHeroBuilderConfig; },
  "default": function() { return business_resource_centre_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-colour-palette/business-resource-colour-palette.builder-component.ts
var business_resource_colour_palette_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_colour_palette_builder_component_namespaceObject);
__webpack_require__.d(business_resource_colour_palette_builder_component_namespaceObject, {
  "BusinessResourceColourPaletteBuilderConfig": function() { return BusinessResourceColourPaletteBuilderConfig; },
  "default": function() { return business_resource_colour_palette_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-divider/business-resource-divider.builder-component.ts
var business_resource_divider_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_divider_builder_component_namespaceObject);
__webpack_require__.d(business_resource_divider_builder_component_namespaceObject, {
  "BusinessResourceDividerBuilderConfig": function() { return BusinessResourceDividerBuilderConfig; },
  "default": function() { return business_resource_divider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-card/business-resource-download-card.builder-component.ts
var business_resource_download_card_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_card_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_card_builder_component_namespaceObject, {
  "BusinessResourceDownloadCardBuilderConfig": function() { return BusinessResourceDownloadCardBuilderConfig; },
  "default": function() { return business_resource_download_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-grid/business-resource-download-grid.builder-component.ts
var business_resource_download_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_grid_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_grid_builder_component_namespaceObject, {
  "BusinessResourceDownloadGridBuilderConfig": function() { return BusinessResourceDownloadGridBuilderConfig; },
  "default": function() { return business_resource_download_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-faq/business-resource-faq.builder-component.ts
var business_resource_faq_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_faq_builder_component_namespaceObject);
__webpack_require__.d(business_resource_faq_builder_component_namespaceObject, {
  "BusinessResourceFAQBuilderConfig": function() { return BusinessResourceFAQBuilderConfig; },
  "default": function() { return business_resource_faq_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-hero-sub/business-resource-hero-sub.builder-component.ts
var business_resource_hero_sub_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_hero_sub_builder_component_namespaceObject);
__webpack_require__.d(business_resource_hero_sub_builder_component_namespaceObject, {
  "BusinessResourceHeroSubBuilderConfig": function() { return BusinessResourceHeroSubBuilderConfig; },
  "default": function() { return business_resource_hero_sub_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-hiws/business-resource-hiws.builder-component.ts
var business_resource_hiws_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_hiws_builder_component_namespaceObject);
__webpack_require__.d(business_resource_hiws_builder_component_namespaceObject, {
  "BusinessResourceHIWsBuilderConfig": function() { return BusinessResourceHIWsBuilderConfig; },
  "default": function() { return business_resource_hiws_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-image-carousel/business-resource-image-carousel.builder-component.ts
var business_resource_image_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_image_carousel_builder_component_namespaceObject);
__webpack_require__.d(business_resource_image_carousel_builder_component_namespaceObject, {
  "BusinessResourceImageCarouselConfig": function() { return BusinessResourceImageCarouselConfig; },
  "default": function() { return business_resource_image_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.builder-component.ts
var business_resource_image_comparison_slider_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_image_comparison_slider_builder_component_namespaceObject);
__webpack_require__.d(business_resource_image_comparison_slider_builder_component_namespaceObject, {
  "BusinessResourceImageComparisonSliderBuilderConfig": function() { return BusinessResourceImageComparisonSliderBuilderConfig; },
  "default": function() { return business_resource_image_comparison_slider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-in-situ/business-resource-in-situ.builder-component.ts
var business_resource_in_situ_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_in_situ_builder_component_namespaceObject);
__webpack_require__.d(business_resource_in_situ_builder_component_namespaceObject, {
  "default": function() { return business_resource_in_situ_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-lightbox/business-resource-lightbox.builder-component.ts
var business_resource_lightbox_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_lightbox_builder_component_namespaceObject);
__webpack_require__.d(business_resource_lightbox_builder_component_namespaceObject, {
  "BusinessResourceLightboxBuilderConfig": function() { return BusinessResourceLightboxBuilderConfig; },
  "default": function() { return business_resource_lightbox_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-logo-usage/business-resource-logo-usage.builder-component.ts
var business_resource_logo_usage_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_logo_usage_builder_component_namespaceObject);
__webpack_require__.d(business_resource_logo_usage_builder_component_namespaceObject, {
  "BusinessResourceLogoUsageBuilderConfig": function() { return BusinessResourceLogoUsageBuilderConfig; },
  "default": function() { return business_resource_logo_usage_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-logos/business-resource-logos.builder-component.ts
var business_resource_logos_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_logos_builder_component_namespaceObject);
__webpack_require__.d(business_resource_logos_builder_component_namespaceObject, {
  "BusinessResourceLogosBuilderConfig": function() { return BusinessResourceLogosBuilderConfig; },
  "default": function() { return business_resource_logos_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-messaging/business-resource-messaging.builder-component.ts
var business_resource_messaging_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_messaging_builder_component_namespaceObject);
__webpack_require__.d(business_resource_messaging_builder_component_namespaceObject, {
  "BusinessResourceMessagingBuilderConfig": function() { return BusinessResourceMessagingBuilderConfig; },
  "default": function() { return business_resource_messaging_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-page-title/business-resource-page-title.builder-component.ts
var business_resource_page_title_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_page_title_builder_component_namespaceObject);
__webpack_require__.d(business_resource_page_title_builder_component_namespaceObject, {
  "BusinessResourcePageTitleBuilderConfig": function() { return BusinessResourcePageTitleBuilderConfig; },
  "default": function() { return business_resource_page_title_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-price-breakdown/business-resource-price-breakdown.builder-component.ts
var business_resource_price_breakdown_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_price_breakdown_builder_component_namespaceObject);
__webpack_require__.d(business_resource_price_breakdown_builder_component_namespaceObject, {
  "BusinessResourcePriceBreakdownBuilderConfig": function() { return BusinessResourcePriceBreakdownBuilderConfig; },
  "default": function() { return business_resource_price_breakdown_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-related/business-image-grid-slider.builder-component.ts
var business_image_grid_slider_builder_component_namespaceObject = {};
__webpack_require__.r(business_image_grid_slider_builder_component_namespaceObject);
__webpack_require__.d(business_image_grid_slider_builder_component_namespaceObject, {
  "ImageGridSliderBuilderConfig": function() { return ImageGridSliderBuilderConfig; },
  "default": function() { return business_image_grid_slider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-super-text/business-resource-super-text.builder-component.ts
var business_resource_super_text_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_super_text_builder_component_namespaceObject);
__webpack_require__.d(business_resource_super_text_builder_component_namespaceObject, {
  "BusinessResourceTextHighlightBuilderConfig": function() { return BusinessResourceTextHighlightBuilderConfig; },
  "default": function() { return business_resource_super_text_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-hightlight/business-resource-text-highlight.builder-component.ts
var business_resource_text_highlight_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_highlight_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_highlight_builder_component_namespaceObject, {
  "BusinessResourceTextHighlightBuilderConfig": function() { return business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig; },
  "default": function() { return business_resource_text_highlight_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-list/business-resource-text-list.builder-component.ts
var business_resource_text_list_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_list_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_list_builder_component_namespaceObject, {
  "BusinessResourceTextListBuilderConfig": function() { return BusinessResourceTextListBuilderConfig; },
  "default": function() { return business_resource_text_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-wrap/business-resource-text-wrap.builder-component.ts
var business_resource_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_wrap_builder_component_namespaceObject, {
  "BusinessResourceTextWrapBuilderConfig": function() { return BusinessResourceTextWrapBuilderConfig; },
  "default": function() { return business_resource_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-top-strips/business-resource-top-strips.builder-component.ts
var business_resource_top_strips_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_top_strips_builder_component_namespaceObject);
__webpack_require__.d(business_resource_top_strips_builder_component_namespaceObject, {
  "BusinessResourceTopStripsBuilderConfig": function() { return BusinessResourceTopStripsBuilderConfig; },
  "default": function() { return business_resource_top_strips_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-training-block/business-resource-training-block.builder-component.ts
var business_resource_training_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_training_block_builder_component_namespaceObject);
__webpack_require__.d(business_resource_training_block_builder_component_namespaceObject, {
  "ResourceTrainingBlockBuilderConfig": function() { return ResourceTrainingBlockBuilderConfig; },
  "default": function() { return business_resource_training_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-typography-review/business-resource-typography-review.builder-component.ts
var business_resource_typography_review_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_typography_review_builder_component_namespaceObject);
__webpack_require__.d(business_resource_typography_review_builder_component_namespaceObject, {
  "BusinessResourceTypographyReviewBuilderConfig": function() { return BusinessResourceTypographyReviewBuilderConfig; },
  "default": function() { return business_resource_typography_review_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-value-block/business-resource-value-block.builder-component.ts
var business_resource_value_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_value_block_builder_component_namespaceObject);
__webpack_require__.d(business_resource_value_block_builder_component_namespaceObject, {
  "BusinessResourceValueBlockBuilderConfig": function() { return BusinessResourceValueBlockBuilderConfig; },
  "default": function() { return business_resource_value_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-video-list/business-resource-video-list.builder-component.ts
var business_resource_video_list_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_video_list_builder_component_namespaceObject);
__webpack_require__.d(business_resource_video_list_builder_component_namespaceObject, {
  "BusinessVideoListBuilderConfig": function() { return BusinessVideoListBuilderConfig; },
  "default": function() { return business_resource_video_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-text-caption/business-text-caption.builder-component.ts
var business_text_caption_builder_component_namespaceObject = {};
__webpack_require__.r(business_text_caption_builder_component_namespaceObject);
__webpack_require__.d(business_text_caption_builder_component_namespaceObject, {
  "BusinessTextWrapBuilderConfig": function() { return BusinessTextWrapBuilderConfig; },
  "default": function() { return business_text_caption_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-text-wrap/business-text-wrap.builder-component.ts
var business_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_text_wrap_builder_component_namespaceObject, {
  "BusinessTextWrapBuilderConfig": function() { return business_text_wrap_builder_component_BusinessTextWrapBuilderConfig; },
  "default": function() { return business_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-trending-topics/business-trending-topics.builder-component.ts
var business_trending_topics_builder_component_namespaceObject = {};
__webpack_require__.r(business_trending_topics_builder_component_namespaceObject);
__webpack_require__.d(business_trending_topics_builder_component_namespaceObject, {
  "BusinessTrendingTopicsBuilderConfig": function() { return business_trending_topics_builder_component_BusinessTrendingTopicsBuilderConfig; },
  "default": function() { return business_trending_topics_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-vimeo-embed/business-vimeo-embed-wrap.builder-component.ts
var business_vimeo_embed_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_vimeo_embed_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_vimeo_embed_wrap_builder_component_namespaceObject, {
  "BusinessVimeoEmbedWrapBuilderConfig": function() { return BusinessVimeoEmbedWrapBuilderConfig; },
  "default": function() { return business_vimeo_embed_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-youtube-embed/business-youtube-embed.builder-component.ts
var business_youtube_embed_builder_component_namespaceObject = {};
__webpack_require__.r(business_youtube_embed_builder_component_namespaceObject);
__webpack_require__.d(business_youtube_embed_builder_component_namespaceObject, {
  "BusinessYoutubeEmbedWrapBuilderConfig": function() { return BusinessYoutubeEmbedWrapBuilderConfig; },
  "default": function() { return business_youtube_embed_builder_component; }
});

// NAMESPACE OBJECT: ./components/bussines-video-player/business-video-player.builder-component.ts
var business_video_player_builder_component_namespaceObject = {};
__webpack_require__.r(business_video_player_builder_component_namespaceObject);
__webpack_require__.d(business_video_player_builder_component_namespaceObject, {
  "BusinessVideoPlayerWrapBuilderConfig": function() { return BusinessVideoPlayerWrapBuilderConfig; },
  "default": function() { return business_video_player_builder_component; }
});

// NAMESPACE OBJECT: ./components/category-feature/category-feature.builder-component.ts
var category_feature_builder_component_namespaceObject = {};
__webpack_require__.r(category_feature_builder_component_namespaceObject);
__webpack_require__.d(category_feature_builder_component_namespaceObject, {
  "CategoryFeatureBuilderConfig": function() { return category_feature_builder_component_CategoryFeatureBuilderConfig; },
  "default": function() { return category_feature_builder_component; }
});

// NAMESPACE OBJECT: ./components/category-hero/category-hero.builder-component.ts
var category_hero_builder_component_namespaceObject = {};
__webpack_require__.r(category_hero_builder_component_namespaceObject);
__webpack_require__.d(category_hero_builder_component_namespaceObject, {
  "CategoryHeroBuilderConfig": function() { return CategoryHeroBuilderConfig; },
  "default": function() { return category_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/learning-series-block/learning-series-block.builder-component.ts
var learning_series_block_builder_component_namespaceObject = {};
__webpack_require__.r(learning_series_block_builder_component_namespaceObject);
__webpack_require__.d(learning_series_block_builder_component_namespaceObject, {
  "LearningSeriesBlockPropsBuilderConfig": function() { return learning_series_block_builder_component_LearningSeriesBlockPropsBuilderConfig; },
  "default": function() { return learning_series_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/numerical-highlight-list/numerical-highlight-list.builder-component.ts
var numerical_highlight_list_builder_component_namespaceObject = {};
__webpack_require__.r(numerical_highlight_list_builder_component_namespaceObject);
__webpack_require__.d(numerical_highlight_list_builder_component_namespaceObject, {
  "NumericalHighlightListBuilderConfig": function() { return NumericalHighlightListBuilderConfig; },
  "default": function() { return numerical_highlight_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/series-collection-article-block/series-collection-articles-block.builder-component.ts
var series_collection_articles_block_builder_component_namespaceObject = {};
__webpack_require__.r(series_collection_articles_block_builder_component_namespaceObject);
__webpack_require__.d(series_collection_articles_block_builder_component_namespaceObject, {
  "SeriesCollectionArticlesBuilderConfig": function() { return series_collection_articles_block_builder_component_SeriesCollectionArticlesBuilderConfig; },
  "default": function() { return series_collection_articles_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/trustpilot-widget/trustpilot-widget.builder-component.ts
var trustpilot_widget_builder_component_namespaceObject = {};
__webpack_require__.r(trustpilot_widget_builder_component_namespaceObject);
__webpack_require__.d(trustpilot_widget_builder_component_namespaceObject, {
  "TrustpilotWidgetBuilderConfig": function() { return TrustpilotWidgetBuilderConfig; },
  "default": function() { return trustpilot_widget_builder_component; }
});

// NAMESPACE OBJECT: ./components/unordered-highlight-list/unordered-highlight-list.builder-component.ts
var unordered_highlight_list_builder_component_namespaceObject = {};
__webpack_require__.r(unordered_highlight_list_builder_component_namespaceObject);
__webpack_require__.d(unordered_highlight_list_builder_component_namespaceObject, {
  "UnorderedHighlightListBuilderConfig": function() { return UnorderedHighlightListBuilderConfig; },
  "default": function() { return unordered_highlight_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-card-section/video-card-section.builder-component.ts
var video_card_section_builder_component_namespaceObject = {};
__webpack_require__.r(video_card_section_builder_component_namespaceObject);
__webpack_require__.d(video_card_section_builder_component_namespaceObject, {
  "VideoCardSectionBuilderConfig": function() { return VideoCardSectionBuilderConfig; },
  "default": function() { return video_card_section_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-card/video-card.builder-component.ts
var video_card_builder_component_namespaceObject = {};
__webpack_require__.r(video_card_builder_component_namespaceObject);
__webpack_require__.d(video_card_builder_component_namespaceObject, {
  "VideoCardBuilderConfig": function() { return VideoCardBuilderConfig; },
  "default": function() { return video_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-carousel/video-carousel.builder-component.ts
var video_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(video_carousel_builder_component_namespaceObject);
__webpack_require__.d(video_carousel_builder_component_namespaceObject, {
  "VideoCarouselBuilderConfig": function() { return VideoCarouselBuilderConfig; },
  "default": function() { return video_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-hero/video-hero.builder-component.ts
var video_hero_builder_component_namespaceObject = {};
__webpack_require__.r(video_hero_builder_component_namespaceObject);
__webpack_require__.d(video_hero_builder_component_namespaceObject, {
  "VideoHeroBuilderConfig": function() { return VideoHeroBuilderConfig; },
  "default": function() { return video_hero_builder_component; }
});

// EXTERNAL MODULE: ./node_modules/@builder.io/sdk/dist/index.esm.js
var index_esm = __webpack_require__(1183);
// EXTERNAL MODULE: ./node_modules/@builder.io/utils/dist/index.js
var dist = __webpack_require__(1258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(1198);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./components/article-grid/article-grid.tsx + 1 modules
var article_grid = __webpack_require__(1834);
;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.tsx





const BusinessArticleGrid = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _initialArticles;
    const [articles, setArticles] = (0,react.useState)((_initialArticles = props.initialArticles) !== null && _initialArticles !== void 0 ? _initialArticles : []);
    const [offset, setOffsetArticle] = (0,react.useState)(props.offset);
    const [isLoadingMoreArticles, setIsLoadingMoreArticles] = (0,react.useState)(false);
    const getUniqueArticles = (newArticles)=>{
        let mapper = {};
        newArticles.forEach((article)=>{
            mapper[article.builderModel.id] = article;
        });
        return Object.values(mapper);
    };
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (offset !== props.offset) {
            setIsLoadingMoreArticles(true);
            (0,BuilderHelper/* getLatestArticles */.gg)({
                locale,
                offset,
                limit: props.offset !== offset ? 10 : 9
            }).then((newArticles)=>{
                if (!cancelled && newArticles) {
                    setArticles((oldArticles)=>getUniqueArticles([
                            ...oldArticles,
                            ...newArticles
                        ]));
                }
            }).finally(()=>{
                if (!cancelled) {
                    setIsLoadingMoreArticles(false);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        offset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid/* default */.Z, {
        articles: articles,
        isLoadingMoreArticles: isLoadingMoreArticles,
        setOffsetArticle: setOffsetArticle,
        offsetArticle: offset
    });
};

;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.constants.ts
var ArticleGridSource;
(function(ArticleGridSource) {
    ArticleGridSource["Latest"] = "latest";
    ArticleGridSource["Standard"] = "standard";
})(ArticleGridSource || (ArticleGridSource = {}));
const ALL_ARTICLE_GRID_TYPES = Object.values(ArticleGridSource);

;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.builder-component.ts


const business_article_grid_builder_component_BusinessArticleGridBuilderConfig = {
    name: "Article Grid",
    inputs: [
        {
            name: "offset",
            type: "number",
            default: 0
        },
        {
            name: "articleSource",
            type: "text",
            enum: ALL_ARTICLE_GRID_TYPES
        }
    ]
};
const builderConfig = {
    component: BusinessArticleGrid,
    config: business_article_grid_builder_component_BusinessArticleGridBuilderConfig
};
/* harmony default export */ var business_article_grid_builder_component = (builderConfig);

// EXTERNAL MODULE: ./contexts/DefaultLayoutContext.tsx
var DefaultLayoutContext = __webpack_require__(1683);
// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero.tsx + 1 modules
var business_article_single_hero = __webpack_require__(2379);
;// CONCATENATED MODULE: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.tsx




const FeaturedArticleHero = (props)=>{
    const defaultContext = (0,react.useContext)(DefaultLayoutContext/* DefaultLayoutContext */.V);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!props.article && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_article_single_hero/* default */.Z, {
            article: props.article,
            isMarginLower: true,
            breadcrumbs: defaultContext.breadcrumbs,
            isShowReadMore: true,
            isFeaturedBlock: true
        })
    });
};

;// CONCATENATED MODULE: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.builder-component.ts

const FullWidthArticleHeroBuilderConfig = {
    name: "Full Width Featured Article Hero",
    inputs: []
};
const business_featured_article_hero_builder_component_builderConfig = {
    component: FeaturedArticleHero,
    config: FullWidthArticleHeroBuilderConfig
};
/* harmony default export */ var business_featured_article_hero_builder_component = (business_featured_article_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-article-image/business-article-image.module.scss
var business_article_image_module = __webpack_require__(6697);
var business_article_image_module_default = /*#__PURE__*/__webpack_require__.n(business_article_image_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/business-article-image/business-article-image.tsx




const BusinessArticleImage = (props)=>{
    const { image , autoHeight , autoWidth , squared  } = props;
    const [imageBoxStyle, setImageBoxStyle] = (0,react.useState)({});
    const [articleImageWrapperStyle, setArticleImageWrapperStyle] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const img = new Image();
        img.onload = function() {
            if (autoWidth) {
                setArticleImageWrapperStyle({
                    maxWidth: Math.min(872, img.width),
                    width: "100%"
                });
            } else {
                setArticleImageWrapperStyle({});
            }
            if (autoHeight) {
                setImageBoxStyle({
                    paddingTop: "".concat(img.height / img.width * 100, "%")
                });
            } else {
                setImageBoxStyle({
                    paddingTop: "".concat(581 / 872 * 100, "%")
                });
            }
        };
        img.src = image;
    }, [
        autoHeight,
        image,
        autoWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_article_image_module_default()).businessArticleImageContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_article_image_module_default()).businessArticleImageWrapper,
            style: articleImageWrapperStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_article_image_module_default()).businessArticleImageBox, {
                    [(business_article_image_module_default()).squared]: squared
                }),
                style: imageBoxStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_article_image_module_default()).businessArticleImage,
                    style: {
                        backgroundImage: "url('".concat(image, "')")
                    }
                })
            })
        })
    });
};
/* harmony default export */ var business_article_image = (BusinessArticleImage);

;// CONCATENATED MODULE: ./components/business-article-image/business-article-image.builder-component.ts

const BusinessArticleImageBuilderConfig = {
    name: "Article Image",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "autoHeight",
            type: "boolean"
        },
        {
            name: "autoWidth",
            type: "boolean"
        },
        {
            name: "squared",
            type: "boolean"
        }
    ]
};
const business_article_image_builder_component_builderConfig = {
    component: business_article_image,
    config: BusinessArticleImageBuilderConfig
};
/* harmony default export */ var business_article_image_builder_component = (business_article_image_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote.constants.ts
const BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum"
};
const WIDTHS = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    FULL: "full"
};

// EXTERNAL MODULE: ./components/business-article-quote/business-article-quote.module.scss
var business_article_quote_module = __webpack_require__(9891);
var business_article_quote_module_default = /*#__PURE__*/__webpack_require__.n(business_article_quote_module);
;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote.tsx






const BusinessArticleQuoteWrap = (props)=>{
    const { text , authorName , backgroundColor =BACKGROUND_COLORS.MINT , width =WIDTHS.MEDIUM  } = props;
    const defaultLayoutContext = (0,react.useContext)(DefaultLayoutContext/* DefaultLayoutContext */.V);
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [BACKGROUND_COLORS.MINT]: "#b2fce4",
            [BACKGROUND_COLORS.PLUM]: "#EADDF2"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_article_quote_module_default()).businessArticleQuoteContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_article_quote_module_default()).businessArticleQuoteBox, (business_article_quote_module_default())[defaultLayoutContext.type || ""]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_article_quote_module_default()).businessArticleQuote,
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    }),
                    authorName && authorName !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (business_article_quote_module_default()).businessArticleAuthorName,
                        children: "- " + authorName
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundColor: getBackgroundColor()
                },
                className: (business_article_quote_module_default()).businessArticleQuoteBackground + " " + (business_article_quote_module_default())[width]
            })
        ]
    });
};
/* harmony default export */ var business_article_quote = (BusinessArticleQuoteWrap);

;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote-wrap.builder-component.ts


const BusinessArticleQuoteWrapBuilderConfig = {
    name: "Article Quote",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "authorName",
            type: "string",
            defaultValue: ""
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(BACKGROUND_COLORS),
            defaultValue: BACKGROUND_COLORS.PLUM
        },
        {
            name: "width",
            type: "string",
            enum: Object.values(WIDTHS),
            defaultValue: WIDTHS.MEDIUM
        }
    ]
};
const business_article_quote_wrap_builder_component_builderConfig = {
    component: business_article_quote,
    config: BusinessArticleQuoteWrapBuilderConfig
};
/* harmony default export */ var business_article_quote_wrap_builder_component = (business_article_quote_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-button/business-button.tsx
var business_button = __webpack_require__(2955);
// EXTERNAL MODULE: ./components/business-button/business-button.constants.ts
var business_button_constants = __webpack_require__(9892);
;// CONCATENATED MODULE: ./components/business-button/business-button-wrap.builder-component.ts


const BusinessButtonWrapBuilderConfig = {
    name: "Button",
    inputs: [
        {
            name: "buttonText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "color",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        },
        {
            name: "size",
            type: "string",
            enum: Object.values(business_button_constants/* SIZES */.zf),
            defaultValue: business_button_constants/* SIZES.NORMAL */.zf.NORMAL
        },
        {
            name: "icon",
            type: "string",
            enum: Object.values(business_button_constants/* ICONS */.UZ),
            defaultValue: business_button_constants/* ICONS.ArrowBack */.UZ.ArrowBack
        },
        {
            name: "link",
            type: "url",
            defaultValue: ""
        },
        {
            name: "square",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "position",
            type: "string",
            enum: Object.values(business_button_constants/* POSITION */.Vr),
            defaultValue: business_button_constants/* POSITION.CENTER */.Vr.CENTER
        }
    ]
};
const business_button_wrap_builder_component_builderConfig = {
    component: business_button/* default */.Z,
    config: BusinessButtonWrapBuilderConfig
};
/* harmony default export */ var business_button_wrap_builder_component = (business_button_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-emphasized-text/business-emphasized-text.module.scss
var business_emphasized_text_module = __webpack_require__(7926);
var business_emphasized_text_module_default = /*#__PURE__*/__webpack_require__.n(business_emphasized_text_module);
;// CONCATENATED MODULE: ./components/business-emphasized-text/business-emphasized-text.tsx





const BusinessEmphasizedText = (props)=>{
    const { text  } = props;
    const defaultLayoutContext = (0,react.useContext)(DefaultLayoutContext/* DefaultLayoutContext */.V);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_emphasized_text_module_default()).businessEmphasizedTextContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((business_emphasized_text_module_default()).businessEmphasizedText, (business_emphasized_text_module_default())[defaultLayoutContext.type || ""]),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_emphasized_text = (BusinessEmphasizedText);

;// CONCATENATED MODULE: ./components/business-emphasized-text/business-emphasized-text.builder-component.ts

const BusinessEmphasizedTextBuilderConfig = {
    name: "Emphasized Text",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        }
    ]
};
const business_emphasized_text_builder_component_builderConfig = {
    component: business_emphasized_text,
    config: BusinessEmphasizedTextBuilderConfig
};
/* harmony default export */ var business_emphasized_text_builder_component = (business_emphasized_text_builder_component_builderConfig);

;// CONCATENATED MODULE: ./helpers/ColourMap.ts
const DEFAULT_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum",
    ORCA: "orca",
    ORCA_PASTEL: "orcaPastel",
    BLACK: "black",
    WHITE: "white"
};
const mapNameToColour = (color)=>{
    switch(color){
        case "mint":
            return "#B2FCE4";
        case "plum":
            return "#EADDF2";
        case "orca":
            return "#3375C9";
        case "orcaPastel":
            return "#EFF4FB";
        case "black":
            return "#000000";
        case "white":
            return "#FFFFFF";
    }
};
const hexToRgb = (hex)=>{
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
const rgbToHex = (r, g, b)=>{
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const isWhite = (color)=>{
    if (!color) return false;
    return !!color.match(/^(?:white|#fff(?:fff)?|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*1\s*)?\))$/i);
};

// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/lazy-background-image/lazy-background-image.tsx
var lazy_background_image = __webpack_require__(204);
// EXTERNAL MODULE: ./components/image-zoom/image-zoom.module.scss
var image_zoom_module = __webpack_require__(8278);
var image_zoom_module_default = /*#__PURE__*/__webpack_require__.n(image_zoom_module);
;// CONCATENATED MODULE: ./components/image-zoom/image-zoom.tsx





const ImageZoom = (param)=>{
    let { src , ratio =[] , className ="" , children  } = param;
    const [ratioWidth, ratioHeight] = ratio;
    let imageBoxStyle = {};
    if (ratioWidth && ratioHeight) {
        const boxPaddingTop = ratioHeight / ratioWidth * 100;
        imageBoxStyle = {
            paddingTop: "".concat(boxPaddingTop, "%")
        };
    }
    const classNameImageZoom = classnames_default()(className, {
        "image-zoom": true
    });
    const classNameImageMain = classnames_default()((image_zoom_module_default())["image-main"], {
        "image-hover-zoom": true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image_zoom_module_default())["c-background-zoom"] + " " + "".concat(classNameImageZoom),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (image_zoom_module_default())["image-box"],
            style: imageBoxStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_background_image/* LazyBackgroundImage */.I, {
                imageUrl: src,
                className: classNameImageMain,
                imageWidth: ratio[0],
                children: children
            })
        })
    });
};
/* harmony default export */ var image_zoom = (ImageZoom);

;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.constants.ts
const IMAGE_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/business-framed-info-block/business-framed-info-block.module.scss
var business_framed_info_block_module = __webpack_require__(7882);
var business_framed_info_block_module_default = /*#__PURE__*/__webpack_require__.n(business_framed_info_block_module);
;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.tsx








const FramedInfoBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { borderColor =DEFAULT_BACKGROUND_COLORS.MINT , image , title , description , mediaPosition ="left" , ctaText , ctaIcon  } = props;
    var _url;
    let url = (0,LangHelper/* replaceOrAddLocale */.yM)((_url = props.url) !== null && _url !== void 0 ? _url : "", locale);
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((business_framed_info_block_module_default()).businessResourceBlockMediaContainer, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_framed_info_block_module_default()).businessResourceBlockMedia,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((business_framed_info_block_module_default()).mediaImageWrapper, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_framed_info_block_module_default()).mediaImageBox,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_framed_info_block_module_default()).mediaImageMain,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                                    src: image
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((business_framed_info_block_module_default()).mediaBackground, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
                        style: {
                            backgroundColor: mapNameToColour(borderColor)
                        }
                    })
                ]
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((business_framed_info_block_module_default()).businessResourceBlockInfo, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_framed_info_block_module_default()).infoTitle,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_framed_info_block_module_default()).infoDescription,
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: url,
                    className: (business_framed_info_block_module_default()).infoCTA,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: ctaText !== null && ctaText !== void 0 ? ctaText : "Download"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.Download */.T.Download
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_framed_info_block_module_default()).businessResourceBlockContainer,
        children: [
            mediaPosition === IMAGE_POSITIONS.LEFT ? mediaBlock() : null,
            infoBlock(),
            mediaPosition === IMAGE_POSITIONS.RIGHT ? mediaBlock() : null
        ]
    });
};
/* harmony default export */ var business_framed_info_block = (FramedInfoBlock);

;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.builder-component.ts




const BusinessFramedInfoBlockBuilderConfig = {
    name: "Framed Info Block",
    inputs: [
        {
            name: "borderColor",
            type: "string",
            enum: Object.values(DEFAULT_BACKGROUND_COLORS),
            defaultValue: DEFAULT_BACKGROUND_COLORS.MINT
        },
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "url",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(IMAGE_POSITIONS),
            defaultValue: IMAGE_POSITIONS.LEFT
        }
    ]
};
const business_framed_info_block_builder_component_builderConfig = {
    component: business_framed_info_block,
    config: BusinessFramedInfoBlockBuilderConfig
};
/* harmony default export */ var business_framed_info_block_builder_component = (business_framed_info_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(5008);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/lazy/lazy.js
var lazy = __webpack_require__(8470);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(7883);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(298);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var react_swiper = __webpack_require__(7);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(8766);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(2790);
// EXTERNAL MODULE: ./components/learning-card/learning-card.module.scss
var learning_card_module = __webpack_require__(853);
var learning_card_module_default = /*#__PURE__*/__webpack_require__.n(learning_card_module);
;// CONCATENATED MODULE: ./components/learning-card/learning-card.tsx







const LearningCard = (props)=>{
    const { learningSeries  } = props;
    const [quantityArticle, setQuantityArticle] = (0,react.useState)(null);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const category = learningSeries.category;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!learningSeries) return;
        if (learningSeries.articleCount) {
            setQuantityArticle(learningSeries.articleCount);
        } else {
            (0,BuilderHelper/* getAllArticles */.zC)(locale, {
                categoryIds: [
                    category.id
                ],
                limit: 30
            }).then((article)=>{
                if (!cancelled) {
                    setQuantityArticle(article.length);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        learningSeries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (learning_card_module_default()).learningCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                src: (category === null || category === void 0 ? void 0 : category.image) || "",
                ratio: [
                    424,
                    540
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (learning_card_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (learning_card_module_default()).learningCardContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_card_module_default()).quantity,
                        children: [
                            quantityArticle,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: quantityArticle && quantityArticle > 1 ? " ARTICLES" : " ARTICLE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((learning_card_module_default()).title, " ").concat((learning_card_module_default()).threeLinesLimit),
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((learning_card_module_default()).description, " ").concat((learning_card_module_default()).threeLinesLimit),
                        children: category.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_card_module_default()).btnReadAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Read all"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (learning_card_module_default()).learningUrl,
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(category.categoryUrl || "", locale),
                rel: "noreferrer"
            })
        ]
    });
};
/* harmony default export */ var learning_card = (LearningCard);

// EXTERNAL MODULE: ./components/sign-up-card/sign-up-card.tsx + 1 modules
var sign_up_card = __webpack_require__(5338);
;// CONCATENATED MODULE: ./components/headlining-articles-block/headlining-articles-block.constants.ts
const TYPES_OF_CARD = {
    ARTICLE: "article",
    LEARNING: "learning"
};

// EXTERNAL MODULE: ./components/headlining-articles-block/headlining-articles-block.module.scss
var headlining_articles_block_module = __webpack_require__(8313);
var headlining_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(headlining_articles_block_module);
;// CONCATENATED MODULE: ./components/headlining-articles-block/headlining-articles-block.tsx














core_class/* default.use */.Z.use([
    lazy/* default */.Z,
    navigation/* default */.Z
]);
const HeadliningArticlesBlock = (props)=>{
    const { cardData , showSignupCard =true , typeOfCard =TYPES_OF_CARD.ARTICLE , includeLargeCard  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 768 ? true : false;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const navigationConfig = {
        prevEl: prevRef.current ? prevRef.current : undefined,
        nextEl: nextRef.current ? nextRef.current : undefined
    };
    // Because layout breaks if you try to populate the DOM before slider is initalised, we debounce it with state, Only set data after swiper is initialised
    const [swiperCardList, setSwiperCardList] = (0,react.useState)(props.debounce ? [] : cardData);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    const swiperOption = {
        navigation: navigationConfig,
        slidesPerView: "auto",
        spaceBetween: isMobile ? 8 : 24,
        centeredSlides: isMobile,
        centeredSlidesBounds: true,
        watchOverflow: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
        },
        updateOnWindowResize: true,
        init: false
    };
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
            setSwiperCardList(cardData);
        }
    }, [
        swiper,
        inView,
        cardData
    ]);
    const cardTemplate = [
        article_card/* ArticleCardType.Large */._.Large,
        article_card/* ArticleCardType.Small */._.Small,
        article_card/* ArticleCardType.Small */._.Small
    ];
    const getCard = (item, cardSize)=>{
        switch(typeOfCard){
            case TYPES_OF_CARD.ARTICLE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
            case TYPES_OF_CARD.LEARNING:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_card, {
                    learningSeries: item
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
        }
    };
    const renderArticleItem = (item, index)=>{
        let cardSize = article_card/* ArticleCardType.Small */._.Small;
        if (includeLargeCard && !isMobile) {
            cardSize = cardTemplate[index % cardTemplate.length];
        }
        if (index === cardData.length - 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                className: classnames_default()((headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                    [(headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
                }),
                children: showSignupCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sign_up_card/* default */.Z, {}) : getCard(item, cardSize)
            }, "card_slide_key_".concat(index));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            className: classnames_default()((headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                [(headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
            }),
            children: getCard(item, cardSize)
        }, "card_slide_key_".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (headlining_articles_block_module_default()).headliningArticlesBlock,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (headlining_articles_block_module_default()).swiperButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (headlining_articles_block_module_default()).swiperButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                ...swiperOption,
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.update();
                },
                onSwiper: (sw)=>{
                    setSwiper(sw);
                },
                className: (headlining_articles_block_module_default()).headliningArticlesSlider,
                children: (swiperCardList || []).map((item, index)=>renderArticleItem(item, index))
            })
        ]
    });
};
/* harmony default export */ var headlining_articles_block = (HeadliningArticlesBlock);

;// CONCATENATED MODULE: ./components/business-headlining-latest-articles/business-headlining-latest-articles.tsx





const BusinessHeadliningLatestArticles = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)(props.articles);
    const [isFirstLoad, setIsFirstLoad] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        // Return on first load since articles would be populated via getStaticProps
        if (isFirstLoad && featuredArticles.length) {
            setIsFirstLoad(true);
            return;
        }
        setIsFirstLoad(false);
        var _offset;
        (0,BuilderHelper/* getLatestArticles */.gg)({
            locale,
            offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
            limit: 3
        }).then((articles)=>{
            if (!cancelled) {
                setFeaturedArticles(articles);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        props.offset
    ]);
    var _showSignupForAfterpay;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
        cardData: featuredArticles,
        showSignupCard: (_showSignupForAfterpay = props.showSignupForAfterpay) !== null && _showSignupForAfterpay !== void 0 ? _showSignupForAfterpay : false
    });
};

;// CONCATENATED MODULE: ./components/business-headlining-latest-articles/business-headlining-latest-articles.builder-component.ts

const business_headlining_latest_articles_builder_component_HeadliningLatestArticlesBuilderConfig = {
    name: "Headlining Latest Articles",
    inputs: [
        {
            name: "offset",
            type: "text",
            default: "1"
        },
        {
            name: "showSignupForAfterpay",
            type: "boolean",
            default: true
        }
    ]
};
const business_headlining_latest_articles_builder_component_builderConfig = {
    component: BusinessHeadliningLatestArticles,
    config: business_headlining_latest_articles_builder_component_HeadliningLatestArticlesBuilderConfig
};
/* harmony default export */ var business_headlining_latest_articles_builder_component = (business_headlining_latest_articles_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(1882);
// EXTERNAL MODULE: ./components/business-resource-download-button/business-resource-download-button.module.scss
var business_resource_download_button_module = __webpack_require__(762);
var business_resource_download_button_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_button_module);
;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-tooltip/business-resource-download-tooltip.tsx




const BusinessResourceDownloadTooltip = (props, ref)=>{
    const { arrowRef , item , onVariantClick , popperStyles , attributes , disabled , allOption =true  } = props;
    if (!item) return null;
    const handleVariantClick = (event, variant)=>{
        if (disabled) return;
        event.preventDefault();
        event.stopPropagation();
        onVariantClick === null || onVariantClick === void 0 ? void 0 : onVariantClick(variant);
    };
    if (!item.variants || item.variants.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (business_resource_download_button_module_default()).tooltip,
        style: popperStyles.popper,
        ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
        children: [
            allOption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: disabled,
                type: "button",
                className: (business_resource_download_button_module_default()).button,
                onClick: (e)=>handleVariantClick(e, "ALL"),
                children: "ALL"
            }) : null,
            item.variants.map((variant)=>{
                if (variant.variantName) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: disabled,
                        type: "button",
                        className: (business_resource_download_button_module_default()).button,
                        onClick: (e)=>handleVariantClick(e, variant),
                        children: variant.variantName
                    }, "".concat(Math.random()));
                }
                return null;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_download_button_module_default()).tooltipArrow, {
                    [(business_resource_download_button_module_default()).visible]: !!arrowRef
                }),
                ref: arrowRef,
                style: popperStyles.arrow
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_tooltip = (/*#__PURE__*/(0,react.forwardRef)(BusinessResourceDownloadTooltip));

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-button.tsx






const BussinessResourceDownloadButton = (props)=>{
    const { children , item , type , onVariantClick , className , containerClass , disabled , allOption , directlyDownload =false , mobileFullWidth , ...buttonProps } = props;
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_download_button_module_default()).container, containerClass, {
            [(business_resource_download_button_module_default()).mobileFullWidth]: mobileFullWidth
        }),
        children: [
            !directlyDownload && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_tooltip, {
                ref: setPopperElement,
                arrowRef: setArrowElement,
                attributes: attributes,
                popperStyles: popperStyles,
                item: item,
                onVariantClick: onVariantClick,
                disabled: disabled,
                allOption: allOption
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: disabled,
                ref: setReferenceElement,
                type: "button",
                className: classnames_default()((business_resource_download_button_module_default()).download, {
                    [(business_resource_download_button_module_default()).mobileFullWidth]: mobileFullWidth,
                    [(business_resource_download_button_module_default()).icon]: type === "icon"
                }, className),
                ...buttonProps,
                children: children
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_button = (BussinessResourceDownloadButton);

// EXTERNAL MODULE: ./types/Resource.ts
var Resource = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(7043);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
;// CONCATENATED MODULE: ./helpers/ResourceHelper.ts


const RESOURCE_CREATE_ZIP_API = "".concat("https://m7q46igbwl.execute-api.ap-southeast-2.amazonaws.com/production", "/api/zip/create");
const RESOURCE_PULL_ZIP_API = "https://afterpay-adhoc-api-media-production-bucket.s3.ap-southeast-2.amazonaws.com";
const assetTypeToRequest = (assets, rootFolderName)=>{
    const result = {
        name: rootFolderName,
        variants: []
    };
    const assetNameCheck = overlapCheckHof();
    assets.filter((param)=>{
        let { skipDownload  } = param;
        return !skipDownload;
    }).forEach((asset, i)=>{
        const assetName = assetNameCheck("asset", asset.name);
        const filenameCheck = overlapCheckHof();
        asset.variants.forEach((variant, j)=>{
            const filename = filenameCheck("variant", getFileNameWithExtension(variant));
            result.variants.push({
                downloadUrl: variant.downloadUrl,
                filename,
                extension: "",
                path: assetName
            });
        });
    });
    return result;
};
const resourceTypeToRequest = (resources, rootFolderName)=>{
    const result = {
        name: rootFolderName,
        variants: []
    };
    const typeCheck = overlapCheckHof();
    resources === null || resources === void 0 ? void 0 : resources.forEach((param, k)=>{
        let { assets , type , title  } = param;
        const typeName = typeCheck("resource", title || type);
        const assetNameCheck = overlapCheckHof();
        assets === null || assets === void 0 ? void 0 : assets.filter((param)=>{
            let { skipDownload  } = param;
            return !skipDownload;
        }).forEach((asset, i)=>{
            const assetName = assetNameCheck("asset", asset.name);
            const variantNameCheck = overlapCheckHof();
            asset.variants.forEach((variant, j)=>{
                const variantName = variantNameCheck("variant", getFileNameWithExtension(variant));
                result.variants.push({
                    downloadUrl: variant.downloadUrl,
                    filename: variantName,
                    extension: "",
                    path: path_browserify_default().join(typeName, assetName)
                });
            });
        });
    });
    return result;
};
const downloadAsset = async (assets, rootFolderName)=>{
    if (!assets || !assets.length) {
        console.warn("No variant to download");
        return;
    }
    const body = assetTypeToRequest(assets, rootFolderName);
    await baseDownloadAsset(body);
};
const baseDownloadAsset = async (body)=>{
    if (!body) {
        console.warn("No request body");
        return;
    }
    const data = await fetch(RESOURCE_CREATE_ZIP_API, {
        method: "POST",
        body: JSON.stringify(body)
    });
    if (data.headers.get("Content-Disposition")) {
        await downloadFromResponse(data);
        return;
    }
    const key = (await data.json()).key;
    if (!key) {
        console.error("Invalid key", data);
        return;
    }
    for(let count = 0; count < 150; count++){
        const pullResult = await pullAsset(key);
        if (pullResult) {
            break;
        }
        await new Promise((resolve)=>setTimeout(()=>{
                resolve(true);
            }, 6000));
    }
};
const overlapCheckHof = ()=>{
    let index = 1;
    const typeNames = [];
    return (initialDefaultName, name)=>{
        let typeName = name || initialDefaultName;
        if (typeNames.includes(typeName)) {
            typeName = "".concat(typeName, "_").concat(index);
            index += 1;
        }
        typeNames.push(typeName);
        return typeName;
    };
};
const getColorCode = function(colorName) {
    let hash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!colorName) return;
    const mapping = {
        [Resource/* COLORS.Mint */.D.Mint]: "B2FCE4",
        [Resource/* COLORS.Black */.D.Black]: "000",
        [Resource/* COLORS.White */.D.White]: "FFF",
        [Resource/* COLORS.Grey */.D.Grey]: "969696"
    };
    const code = mapping[colorName];
    if (!code) return;
    return "".concat(hash ? "#" : "").concat(code);
};
const getFileNameWithExtension = (variant)=>{
    return "".concat(variant.fileName || "").concat(variant.extension ? "." + variant.extension : "");
};
const pullAsset = async (key)=>{
    try {
        const response = await fetch("".concat(RESOURCE_PULL_ZIP_API, "/").concat(key));
        if (response.ok) {
            const filename = response.headers.get("x-amz-meta-name") || undefined;
            await downloadFromResponse(response, filename);
            return true;
        }
        return false;
    } catch (ex) {
        console.log(ex);
        return false;
    }
};
const downloadFromResponse = async (data, filename)=>{
    const downloadElement = document.createElement("a");
    const url = window.URL.createObjectURL(await data.blob());
    downloadElement.href = url;
    downloadElement.download = filename || "";
    if (!filename) {
        const disposition = data.headers.get("Content-Disposition");
        let filename1 = "assets";
        if (disposition) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename1 = matches[1].replace(/['"]/g, "");
            }
            downloadElement.download = filename1;
        }
    }
    downloadElement.click();
    window.URL.revokeObjectURL(url);
};

;// CONCATENATED MODULE: ./hook/useDownloadResource.ts


const useDownloadResource = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadResources = async (resources, rootFolderName)=>{
        setLoading(true);
        try {
            const body = resourceTypeToRequest(resources, rootFolderName);
            await baseDownloadAsset(body);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadResources
    };
};
/* harmony default export */ var hook_useDownloadResource = (useDownloadResource);

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-resources-button-container.tsx




const BusinessResourceDownloadResourcesButtonContainer = (param)=>{
    let { onClick , disabled , resources , rootContainerName , ...props } = param;
    const { loading , downloadResources  } = hook_useDownloadResource();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        onClick: async (e)=>{
            await downloadResources(resources, rootContainerName);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        disabled: loading || disabled,
        ...props
    });
};
/* harmony default export */ var business_resource_download_resources_button_container = (BusinessResourceDownloadResourcesButtonContainer);

// EXTERNAL MODULE: ./components/icons/Icons/Download.tsx
var Download = __webpack_require__(7763);
;// CONCATENATED MODULE: ./components/business-resource-download-all-button/business-resource-download-all-button.tsx




const BusinessResourceDownloadAllButton = (param)=>{
    let { text , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
        ...props,
        children: [
            text,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var business_resource_download_all_button = (BusinessResourceDownloadAllButton);

;// CONCATENATED MODULE: ./components/business-resource-download-all-button/business-resource-download-all-button.builder-component.ts

const BusinessResourceWebsiteConfig = {
    name: "Resource Download All Button",
    inputs: [
        {
            name: "text",
            type: "string"
        },
        {
            name: "rootContainerName",
            type: "string"
        },
        {
            name: "mobileFullWidth",
            type: "boolean"
        }
    ]
};
const business_resource_download_all_button_builder_component_builderConfig = {
    component: business_resource_download_all_button,
    config: BusinessResourceWebsiteConfig
};
/* harmony default export */ var business_resource_download_all_button_builder_component = (business_resource_download_all_button_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-link-button/business-resource-link-button.module.scss
var business_resource_link_button_module = __webpack_require__(9901);
var business_resource_link_button_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_link_button_module);
;// CONCATENATED MODULE: ./components/business-resource-link-button/business-resource-link-button.tsx




const BusinessResourceLinkButton = (param)=>{
    let { disabled , className , children , icon , strong , onClick , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: classnames_default()((business_resource_link_button_module_default()).root, {
            [(business_resource_link_button_module_default()).disabled]: disabled
        }, className),
        onClick: (e)=>{
            if (disabled) {
                e.preventDefault();
            } else onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((business_resource_link_button_module_default()).text, {
                    [(business_resource_link_button_module_default()).strong]: strong
                }),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (business_resource_link_button_module_default()).icon,
                children: icon
            })
        ]
    });
};
/* harmony default export */ var business_resource_link_button = (BusinessResourceLinkButton);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightXSmall.tsx


const ArrowRightXSmall = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9999 8L1.33325 8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66675 2.66668L12.0001 8.00001L6.66675 13.3333",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightXSmall = (ArrowRightXSmall);

// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(9546);
// EXTERNAL MODULE: ./components/asset-card/asset-card.module.scss
var asset_card_module = __webpack_require__(4179);
var asset_card_module_default = /*#__PURE__*/__webpack_require__.n(asset_card_module);
// EXTERNAL MODULE: ./components/ratio-image/ratio-image.module.scss
var ratio_image_module = __webpack_require__(7270);
var ratio_image_module_default = /*#__PURE__*/__webpack_require__.n(ratio_image_module);
;// CONCATENATED MODULE: ./components/ratio-image/ratio-image.tsx



const RatioImage = (param)=>{
    let { image , ratio ="auto" , maxHeight , maxWidth , minHeight  } = param;
    const [imageBoxStyle, setImageBoxStyle] = (0,react.useState)(typeof ratio === "number" ? {
        paddingTop: "".concat(ratio * 100, "%")
    } : {});
    const [imageStyle, setImageStyle] = (0,react.useState)({
        maxHeight,
        maxWidth,
        minHeight
    });
    (0,react.useEffect)(()=>{
        if (image) {
            const img = new Image();
            img.onload = function() {
                if (ratio === "auto") {
                    setImageBoxStyle({
                        ...imageBoxStyle,
                        paddingTop: "".concat(img.height / img.width * 100, "%")
                    });
                }
                if (maxHeight || maxWidth) {
                    setImageStyle({
                        ...imageStyle,
                        maxWidth: maxWidth ? maxWidth : maxHeight && maxHeight * (img.width / img.height),
                        maxHeight: maxHeight ? maxHeight : maxWidth && maxWidth * (img.height / img.width)
                    });
                }
            };
            img.src = image;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ratio_image_module_default()).root,
        style: imageStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ratio_image_module_default()).imageContainer,
            style: imageBoxStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (ratio_image_module_default()).image,
                src: image
            })
        })
    });
};
/* harmony default export */ var ratio_image = (RatioImage);

;// CONCATENATED MODULE: ./components/asset-card/asset-card.tsx








core_class/* default.use */.Z.use([
    pagination/* default */.Z
]);
const AssetCard = (param)=>{
    let { asset: { variants  } , children , RatioImageProps ={}  } = param;
    const filteredVariants = (variants || []).filter((param)=>{
        let { hide , colors  } = param;
        return !hide;
    });
    const [backgroundColor, setBackgroundColor] = (0,react.useState)(undefined);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (asset_card_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                onSlideChange: (swiper)=>{
                    const realIndex = swiper.realIndex;
                    const currentSlide = filteredVariants[realIndex];
                    setBackgroundColor(currentSlide.backgroundColor);
                },
                loop: true,
                className: (asset_card_module_default()).swiperContainer,
                slidesPerView: 1,
                navigation: false,
                pagination: {
                    clickable: true,
                    renderBullet: (index)=>{
                        var ref, ref1;
                        if (!filteredVariants) {
                            return "";
                        }
                        const { colors  } = filteredVariants[index];
                        return "<div style='background-color: ".concat(getColorCode(colors === null || colors === void 0 ? void 0 : (ref = colors[0]) === null || ref === void 0 ? void 0 : ref.color, true), "; ").concat((colors === null || colors === void 0 ? void 0 : (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.color) === Resource/* COLORS.White */.D.White ? "border-color: #000" : "", "' class='swiper-pagination-bullet'></div>");
                    }
                },
                children: filteredVariants.map((param, index)=>/*#__PURE__*/ {
                    let { previewUrl  } = param;
                    return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor
                            },
                            className: (asset_card_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ratio_image, {
                                image: previewUrl,
                                ...RatioImageProps
                            })
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (asset_card_module_default()).checkbox,
                children: children
            })
        ]
    });
};
/* harmony default export */ var asset_card = (AssetCard);

;// CONCATENATED MODULE: ./hook/useDownloadVariant.ts


const useDownloadVariant = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadVariant = async (asset, variant, defaultFolderName)=>{
        setLoading(true);
        try {
            await downloadAsset(variant === "ALL" ? [
                asset
            ] : [
                {
                    ...asset,
                    variants: [
                        variant
                    ]
                }
            ], asset.name || defaultFolderName || "asset");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadVariant
    };
};
/* harmony default export */ var hook_useDownloadVariant = (useDownloadVariant);

;// CONCATENATED MODULE: ./hook/useDownloadAssets.ts


const useDownloadAssets = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadAssetWrapper = async (assets, rootFolderName)=>{
        setLoading(true);
        try {
            await downloadAsset(assets, rootFolderName);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadAssets: downloadAssetWrapper
    };
};
/* harmony default export */ var hook_useDownloadAssets = (useDownloadAssets);

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-variant-button-container.tsx






const BusinessResourceDownloadVariantButtonContainer = (param)=>{
    let { defaultFolderName , disabled , item , onVariantClick , directlyDownload , ...props } = param;
    const { loading , downloadVariant  } = hook_useDownloadVariant();
    const { loading: assetLoading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        disabled: loading || assetLoading || disabled,
        item: item,
        onClick: async ()=>{
            if (directlyDownload) {
                if (item) downloadAssets([
                    item
                ], (item === null || item === void 0 ? void 0 : item.name) || defaultFolderName || "assets");
            }
        },
        onVariantClick: async (variant)=>{
            if (!directlyDownload) {
                onVariantClick === null || onVariantClick === void 0 ? void 0 : onVariantClick(variant);
                if (item) {
                    await downloadVariant(item, variant, defaultFolderName);
                }
            }
        },
        directlyDownload: directlyDownload,
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
            type: icons/* IconType.Download */.T.Download
        })
    });
};
/* harmony default export */ var business_resource_download_variant_button_container = (BusinessResourceDownloadVariantButtonContainer);

;// CONCATENATED MODULE: ./components/asset-card/download-asset-card.tsx





core_class/* default.use */.Z.use([
    pagination/* default */.Z
]);
const DownloadAssetCard = (param)=>{
    let { asset , AssetCardProps ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card, {
        asset: asset,
        ...AssetCardProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_variant_button_container, {
            type: "icon",
            directlyDownload: true,
            item: asset
        })
    });
};
/* harmony default export */ var download_asset_card = (DownloadAssetCard);

// EXTERNAL MODULE: ./components/business-resource-asset-grid/business-resource-asset-grid.module.scss
var business_resource_asset_grid_module = __webpack_require__(6414);
var business_resource_asset_grid_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_grid_module);
;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-assets-button-container.tsx




const BusinessResourceDownloadAssetsButtonContainer = (param)=>{
    let { onClick , disabled , assets , rootContainerName , ...props } = param;
    const { loading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        onClick: async (e)=>{
            await downloadAssets(assets, rootContainerName);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        disabled: loading || disabled,
        ...props
    });
};
/* harmony default export */ var business_resource_download_assets_button_container = (BusinessResourceDownloadAssetsButtonContainer);

// EXTERNAL MODULE: ./components/business-resource-divider/business-resource-divider.module.scss
var business_resource_divider_module = __webpack_require__(8874);
var business_resource_divider_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_divider_module);
;// CONCATENATED MODULE: ./components/business-resource-divider/business-resource-divider.tsx


const BusinessResourceDivider = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_divider_module_default()).container
    });
};
/* harmony default export */ var business_resource_divider = (BusinessResourceDivider);

;// CONCATENATED MODULE: ./components/business-resource-asset-grid/business-resource-asset-grid.tsx










const BusinessResourceAssetGrid = (param)=>{
    let { resources , limitRows =2 , columns =2 , showDownloadButton =false , showDivider , renderAssetCard  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const [show, setShow] = (0,react.useState)(false);
    if (!resources || !resources[0]) return null;
    const hasShowMore = !!((ref = resources[0].assets) === null || ref === void 0 ? void 0 : ref.slice(limitRows * columns).length);
    const renderDefaultAssetCard = (asset, index)=>{
        return (renderAssetCard === null || renderAssetCard === void 0 ? void 0 : renderAssetCard(asset)) || /*#__PURE__*/ (0,jsx_runtime.jsx)(download_asset_card, {
            asset: asset,
            AssetCardProps: {
                RatioImageProps: {
                    maxHeight: 216,
                    minHeight: 120
                }
            }
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_resource_asset_grid_module_default()).root, {
                    [(business_resource_asset_grid_module_default()).hasShowMore]: hasShowMore,
                    [(business_resource_asset_grid_module_default()).showDivider]: showDivider
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_asset_grid_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_asset_grid_module_default()).title,
                                children: (ref1 = resources[0]) === null || ref1 === void 0 ? void 0 : ref1.title
                            }),
                            (resources === null || resources === void 0 ? void 0 : (ref2 = resources[0]) === null || ref2 === void 0 ? void 0 : ref2.assets) && (resources === null || resources === void 0 ? void 0 : (ref3 = resources[0]) === null || ref3 === void 0 ? void 0 : ref3.assets.length) && showDownloadButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_asset_grid_module_default()).downloadButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                                    mobileFullWidth: true,
                                    assets: (resources === null || resources === void 0 ? void 0 : (ref4 = resources[0]) === null || ref4 === void 0 ? void 0 : ref4.assets) || [],
                                    rootContainerName: ((ref5 = resources[0]) === null || ref5 === void 0 ? void 0 : ref5.title) || ((ref6 = resources[0]) === null || ref6 === void 0 ? void 0 : ref6.type) || "afterpay asset",
                                    children: [
                                        "Download ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    ((ref7 = resources[0]) === null || ref7 === void 0 ? void 0 : ref7.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: (ref8 = resources[0]) === null || ref8 === void 0 ? void 0 : ref8.description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).resourceContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                gridTemplateColumns: "repeat(".concat(columns, ", minmax(0, 1fr))")
                            },
                            className: (business_resource_asset_grid_module_default()).resource,
                            children: [
                                (ref9 = resources[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.assets) === null || ref10 === void 0 ? void 0 : ref10.slice(0, limitRows * columns).filter((param)=>{
                                    let { hide  } = param;
                                    return !hide;
                                }).map(renderDefaultAssetCard),
                                hasShowMore && show && ((ref11 = resources[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.assets) === null || ref12 === void 0 ? void 0 : ref12.slice(limitRows * columns).filter((param)=>{
                                    let { hide  } = param;
                                    return !hide;
                                }).map(renderDefaultAssetCard))
                            ]
                        })
                    }),
                    hasShowMore && !show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_link_button, {
                            strong: true,
                            onClick: ()=>setShow(true),
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightXSmall, {}),
                            children: "View more"
                        })
                    })
                ]
            }),
            showDivider && resources.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetGrid, {
                resources: resources.slice(1),
                limitRows: limitRows,
                showDownloadButton: showDownloadButton,
                columns: columns,
                showDivider: showDivider,
                renderAssetCard: renderAssetCard
            })
        ]
    });
};
/* harmony default export */ var business_resource_asset_grid = (BusinessResourceAssetGrid);

;// CONCATENATED MODULE: ./components/business-resource-asset-grid/business-resource-grid.builder-component.ts

const config = {
    name: "Resource Asset Grid",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "columns",
            type: "number"
        },
        {
            name: "limitRows",
            type: "number"
        }
    ]
};
const business_resource_grid_builder_component_builderConfig = {
    component: business_resource_asset_grid,
    config
};
/* harmony default export */ var business_resource_grid_builder_component = (business_resource_grid_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-asset-container/business-resource-asset-container.tsx




const passableComponents = [
    business_resource_grid_builder_component,
    business_resource_download_all_button_builder_component
];
const passableComponentNames = passableComponents.map((param)=>{
    let { config: { name  }  } = param;
    return name;
});
const BusinessResourceAssetContainer = (param)=>{
    let { resources , children  } = param;
    const recursivePassResourcesProp = (block)=>{
        var ref;
        if (block.children) {
            return {
                ...block,
                children: block.children.map(recursivePassResourcesProp)
            };
        }
        if (((ref = block.component) === null || ref === void 0 ? void 0 : ref.name) && passableComponentNames.includes(block.component.name)) return {
            ...block,
            component: {
                ...block.component,
                options: {
                    ...block.component.options,
                    resources
                }
            }
        };
        return block;
    };
    const passResourcesProp = ()=>react.Children.map(children, (c)=>{
            if (!/*#__PURE__*/ react.isValidElement(c)) return c;
            return /*#__PURE__*/ react.cloneElement(c, {
                block: recursivePassResourcesProp(c.props.block)
            });
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children && passResourcesProp()
    });
};
/* harmony default export */ var business_resource_asset_container = (BusinessResourceAssetContainer);

// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(5102);
;// CONCATENATED MODULE: ./components/business-resource-asset-container/business-resource-asset-container.builder-component.ts



const business_resource_asset_container_builder_component_BusinessResourceWebsiteConfig = {
    name: "Resource Asset Container",
    inputs: [
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_asset_container_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(business_resource_asset_container),
    config: business_resource_asset_container_builder_component_BusinessResourceWebsiteConfig
};
/* harmony default export */ var business_resource_asset_container_builder_component = (business_resource_asset_container_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-asset-library/business-resource-asset-library.module.scss
var business_resource_asset_library_module = __webpack_require__(7974);
var business_resource_asset_library_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_library_module);
// EXTERNAL MODULE: ./components/outlined-button/outlined-button.module.scss
var outlined_button_module = __webpack_require__(8133);
var outlined_button_module_default = /*#__PURE__*/__webpack_require__.n(outlined_button_module);
;// CONCATENATED MODULE: ./components/outlined-button/outlined-button.tsx




const OutlinedButton = (param, ref)=>{
    let { children , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: classnames_default()((outlined_button_module_default()).root, className),
        ...props,
        children: children
    });
};
/* harmony default export */ var outlined_button = (/*#__PURE__*/(0,react.forwardRef)(OutlinedButton));

// EXTERNAL MODULE: ./components/modal/modal.module.scss
var modal_module = __webpack_require__(3171);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(5883);
;// CONCATENATED MODULE: ./components/react-portal/react-portal.tsx


const ReactPortal = (param)=>{
    let { children , wrapperId ="react-portal-wrapper" , onClick  } = param;
    const [wrapperElement, setWrapperElement] = (0,react.useState)(null);
    (0,react.useLayoutEffect)(()=>{
        let element = document.getElementById(wrapperId);
        let systemCreated = false;
        if (!element) {
            systemCreated = true;
            element = createWrapperAndAppendToBody(wrapperId);
        }
        element.onclick = function(e) {
            if (onClick) {
                onClick(e);
            }
        };
        setWrapperElement(element);
        return ()=>{
            if (systemCreated && element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        };
    }, [
        wrapperId
    ]);
    if (wrapperElement === null) return null;
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, wrapperElement);
};
function createWrapperAndAppendToBody(wrapperId) {
    const wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}
/* harmony default export */ var react_portal = (ReactPortal);

;// CONCATENATED MODULE: ./components/icons/Icons/Cross.tsx


const Cross = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
            fill: "#B2B2B2"
        })
    });
};
/* harmony default export */ var Icons_Cross = (Cross);

;// CONCATENATED MODULE: ./components/modal/modal.tsx





const Modal = (param)=>{
    let { children , title ="" , open =false , onEscape , onOutsideClick , onCloseClick , actions  } = param;
    (0,react.useEffect)(()=>{
        const closeOnEscapeKey = (e)=>e.key === "Escape" ? onEscape && onEscape() : null;
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return ()=>{
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [
        onEscape
    ]);
    const modalRef = (0,react.useRef)(null);
    if (!open) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_portal, {
        onClick: (e)=>{
            var ref;
            if (!((ref = modalRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                onOutsideClick && onOutsideClick();
            }
        },
        wrapperId: "react-portal-modal-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (modal_module_default()).modal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: modalRef,
                className: (modal_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (modal_module_default()).header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (modal_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: (e)=>{
                                    onCloseClick && onCloseClick(e);
                                },
                                className: (modal_module_default()).closeButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Cross, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (modal_module_default()).footer,
                        children: actions
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var modal = (Modal);

// EXTERNAL MODULE: ./components/checkbox/checkbox.module.scss
var checkbox_module = __webpack_require__(2594);
var checkbox_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_module);
;// CONCATENATED MODULE: ./components/checkbox/checkbox.tsx




const Checkbox = (param)=>{
    let { children , onChange , checked , id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: id,
        className: (checkbox_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classnames_default()((checkbox_module_default()).checkbox, {
                    [(checkbox_module_default()).checked]: checked
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        checked: checked,
                        onChange: onChange,
                        type: "checkbox",
                        className: (checkbox_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (checkbox_module_default()).inner
                    })
                ]
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var checkbox_checkbox = (Checkbox);

// EXTERNAL MODULE: ./components/business-resource-asset-library/components/filter-panel-container/filter-panel-container.module.scss
var filter_panel_container_module = __webpack_require__(3129);
var filter_panel_container_module_default = /*#__PURE__*/__webpack_require__.n(filter_panel_container_module);
;// CONCATENATED MODULE: ./components/business-resource-asset-library/context.tsx

const BusinessResourceAssetLibraryContext = /*#__PURE__*/ react.createContext({
    resources: [],
    getDownloadAssetResources: ()=>[],
    getDownloadAssets: ()=>[],
    getFilteredResources: ()=>[],
    colors: [],
    keyMessages: [],
    themedAssets: [],
    assetTypes: [],
    assets: []
});
const BusinessResourceAssetLibraryProvider = BusinessResourceAssetLibraryContext.Provider;

;// CONCATENATED MODULE: ./components/business-resource-asset-library/utils.ts
const onSelect = (newValue, selectedValues, options)=>{
    if (newValue === "All") {
        if (selectedValues.includes("All")) {
            return [];
        } else {
            return options;
        }
    } else {
        const index = selectedValues.findIndex((o)=>o === newValue);
        let newValues;
        if (index >= 0) {
            // Remove
            newValues = selectedValues.slice(0, index).concat(selectedValues.slice(index + 1));
            const allIndex = newValues.findIndex((v)=>v === "All");
            if (allIndex >= 0) {
                newValues = newValues.slice(0, allIndex).concat(newValues.slice(allIndex + 1));
            }
        } else {
            // Add
            newValues = selectedValues.concat([
                newValue
            ]);
            if (newValues.length === options.length - 1) {
                newValues = newValues.concat([
                    "All"
                ]);
            }
        }
        return newValues;
    }
};
const onMultiSelect = (newValue, selectedValues, idName)=>{
    const index = selectedValues.findIndex((o)=>o[idName] === newValue[idName]);
    let newValues;
    if (index >= 0) {
        // Remove
        newValues = selectedValues.slice(0, index).concat(selectedValues.slice(index + 1));
    } else {
        // Add
        newValues = selectedValues.concat([
            newValue
        ]);
    }
    return newValues;
};

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/filter-panel-container/filter-panel-container.tsx






const FilterPanelContainer = ()=>{
    const { resources , colors , setColors , keyMessages , setKeyMessages , themedAssets , setThemedAssets , assetTypes , setAssetTypes  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const getColors = ()=>{
        const colors = new Set();
        resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>{
            var ref;
            (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.forEach((asset)=>{
                var ref;
                (ref = asset.variants) === null || ref === void 0 ? void 0 : ref.forEach((variant)=>{
                    var ref;
                    (ref = variant.colors) === null || ref === void 0 ? void 0 : ref.forEach((param)=>{
                        let { color  } = param;
                        return color && colors.add(color);
                    });
                });
            });
        });
        return Array.from(colors);
    };
    const getAttributes = (attrName)=>{
        const attrs = new Set();
        resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>{
            var ref;
            (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.forEach((asset)=>{
                var ref;
                (ref = asset[attrName]) === null || ref === void 0 ? void 0 : ref.forEach(attrs.add, attrs);
            });
        });
        return Array.from(attrs);
    };
    const alphabetSort = (array)=>array.sort((a, b)=>a.localeCompare(b));
    const getAssetTypes = ()=>{
        return resources === null || resources === void 0 ? void 0 : resources.map((param)=>{
            let { type  } = param;
            return type;
        }).filter(Boolean);
    };
    const onChangeHof = (value, values, setVales)=>{
        return (e)=>{
            const index = values.findIndex((c)=>c === value);
            if (index >= 0) {
                setVales === null || setVales === void 0 ? void 0 : setVales(values.slice(0, index).concat(values.slice(index + 1)));
            } else {
                setVales === null || setVales === void 0 ? void 0 : setVales(values.concat([
                    value
                ]));
            }
        };
    };
    const isChecked = (value, values)=>{
        return values.includes(value);
    };
    const onReset = (setState)=>{
        return ()=>{
            setState === null || setState === void 0 ? void 0 : setState([]);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (filter_panel_container_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Colour",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setColors),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: getColors().map((color)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(color, colors),
                                onChange: onChangeHof(color, colors, setColors),
                                children: color
                            }, color))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Asset Type",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setAssetTypes),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: getAssetTypes().map((v)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(v, assetTypes),
                                onChange: ()=>{
                                    const newValues = onSelect(v, assetTypes, getAssetTypes());
                                    setAssetTypes === null || setAssetTypes === void 0 ? void 0 : setAssetTypes(newValues);
                                },
                                children: v
                            }, v);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (filter_panel_container_module_default()).keyMessages,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Key Messages",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setKeyMessages),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: alphabetSort(getAttributes("keyMessages")).map((v)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(v, keyMessages),
                                onChange: onChangeHof(v, keyMessages, setKeyMessages),
                                children: v
                            }, v))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filter_panel_container = (FilterPanelContainer);

// EXTERNAL MODULE: ./components/icons/Icons/ArrowRightMedium.tsx
var ArrowRightMedium = __webpack_require__(3145);
;// CONCATENATED MODULE: ./components/icons/Icons/BusinessResourceFilter.tsx


const BusinessResourceFilter = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 12L7.99996 12M2.66663 12L5.33329 12",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 8L7.99996 8M2.66663 8L5.33329 8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 4L10.6666 4M2.66663 4L7.99996 4",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6666 5.33317V2.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.33337 9.33317V6.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 13.3332V10.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_BusinessResourceFilter = (BusinessResourceFilter);

// EXTERNAL MODULE: ./components/inlined-multi-select/button/button.module.scss
var button_module = __webpack_require__(2016);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
;// CONCATENATED MODULE: ./components/inlined-multi-select/button/button.tsx




const Button = (param)=>{
    let { children , selected =false , onClick , id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((button_module_default()).root, {
            [(button_module_default()).selected]: selected
        }),
        onClick: (e)=>{
            if (onClick) {
                onClick(e, id);
            }
        },
        children: children
    });
};
/* harmony default export */ var button_button = (Button);

// EXTERNAL MODULE: ./components/inlined-multi-select/inlined-multi-select.module.scss
var inlined_multi_select_module = __webpack_require__(4722);
var inlined_multi_select_module_default = /*#__PURE__*/__webpack_require__.n(inlined_multi_select_module);
;// CONCATENATED MODULE: ./components/inlined-multi-select/inlined-multi-select.tsx





const InlinedMultiSelect = (param)=>{
    let { value =[] , onClick , options =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (inlined_multi_select_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
            spaceBetween: 8,
            slidesPerGroup: 1,
            slidesPerView: "auto",
            className: (inlined_multi_select_module_default()).swiperContainer,
            children: options.map((option)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    style: {
                        width: "auto"
                    },
                    onClick: (e)=>{
                        return onClick === null || onClick === void 0 ? void 0 : onClick(e, option);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button, {
                        selected: value === null || value === void 0 ? void 0 : value.includes(option),
                        id: option,
                        children: option
                    })
                }, option);
            })
        })
    });
};
/* harmony default export */ var inlined_multi_select = (InlinedMultiSelect);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/inlined-multi-select-container/inlined-multi-select-container.tsx





const InlinedMultiSelectContainer = ()=>{
    const { resources , assetTypes , setAssetTypes  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const options = [
        "All"
    ].concat(resources === null || resources === void 0 ? void 0 : resources.map((param)=>{
        let { type  } = param;
        return type;
    }).filter(Boolean));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(inlined_multi_select, {
            value: assetTypes,
            onClick: (e, value)=>{
                const newValues = onSelect(value, assetTypes, options);
                setAssetTypes === null || setAssetTypes === void 0 ? void 0 : setAssetTypes(newValues);
            },
            options: options
        })
    });
};
/* harmony default export */ var inlined_multi_select_container = (InlinedMultiSelectContainer);

// EXTERNAL MODULE: ./components/chip/chip.module.scss
var chip_module = __webpack_require__(2923);
var chip_module_default = /*#__PURE__*/__webpack_require__.n(chip_module);
;// CONCATENATED MODULE: ./components/icons/Icons/SquaredClose.tsx


const SquaredClose = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 3.66663L3.66663 13",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 13L3.66663 3.66663",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SquaredClose = (SquaredClose);

;// CONCATENATED MODULE: ./components/chip/chip.tsx




const Chip = (param)=>{
    let { children , onCloseClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (chip_module_default()).root,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: onCloseClick,
                className: (chip_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SquaredClose, {})
            })
        ]
    });
};
/* harmony default export */ var chip = (Chip);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/chips-container/chips-container.tsx





const ChipsContainer = ()=>{
    const context = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const renderChips = (key, setState)=>{
        return context[key].map((v)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chip, {
                onCloseClick: ()=>{
                    const newValues = onSelect(v, context[key], []);
                    setState === null || setState === void 0 ? void 0 : setState(newValues);
                },
                children: v
            }, v);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderChips("colors", context.setColors),
            renderChips("assetTypes", context.setAssetTypes),
            renderChips("keyMessages", context.setKeyMessages),
            renderChips("themedAssets", context.setThemedAssets)
        ]
    });
};
/* harmony default export */ var chips_container = (ChipsContainer);

// EXTERNAL MODULE: ./components/asset-card/checkbox-asset-card.module.scss
var checkbox_asset_card_module = __webpack_require__(1773);
var checkbox_asset_card_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_asset_card_module);
;// CONCATENATED MODULE: ./components/asset-card/checkbox-asset-card.tsx






core_class/* default.use */.Z.use([
    pagination/* default */.Z
]);
const CheckboxAssetCard = (param)=>{
    let { asset , onChange , checked , CheckboxProps , AssetCardProps ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        className: (checkbox_asset_card_module_default()).root,
        htmlFor: asset.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card, {
            asset: asset,
            ...AssetCardProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                id: asset.id,
                checked: checked,
                onChange: onChange,
                ...CheckboxProps
            })
        })
    });
};
/* harmony default export */ var checkbox_asset_card = (CheckboxAssetCard);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/asset-card-container/asset-card-container.tsx





const AssetCardContainer = (param)=>{
    let { asset  } = param;
    const { assets , setAssets  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_asset_card, {
        checked: assets.some((param)=>{
            let { id  } = param;
            return id === asset.id;
        }),
        onChange: ()=>{
            const newAssets = onMultiSelect(asset, assets, "id");
            setAssets === null || setAssets === void 0 ? void 0 : setAssets(newAssets);
        },
        asset: asset,
        AssetCardProps: {
            RatioImageProps: {
                maxHeight: 216,
                minHeight: 120
            }
        }
    });
};
/* harmony default export */ var asset_card_container = (AssetCardContainer);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/business-resource-asset-library.tsx


















const BusinessResourceAssetLibrary = (param)=>{
    let { showDownloadButton , columns , limitRows  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    const [dropdownValue, setDropdownValue] = (0,react.useState)(1);
    const { getFilteredResources , assets , getDownloadAssetResources  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const buttonContainerRef = (0,react.useRef)(null);
    const [lock, setLock] = (0,react.useState)(false);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const onScroll = (0,react.useCallback)((e)=>{
        if (width && width <= 768) {
            if (buttonContainerRef.current) {
                const { height , y  } = buttonContainerRef.current.getBoundingClientRect();
                const botPosition = height + y;
                if (botPosition <= 0) {
                    setLock(true);
                } else {
                    setLock(false);
                }
            }
        } else {
            setLock(false);
        }
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_asset_library_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, {
                actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                    onClick: ()=>setOpen(false),
                    children: [
                        "Show me what I need ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {})
                    ]
                }),
                onCloseClick: ()=>setOpen(false),
                onEscape: ()=>setOpen(false),
                onOutsideClick: ()=>setOpen(false),
                open: open,
                title: "I'm not sure what I need",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_panel_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_asset_library_module_default()).action,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_library_module_default()).leftAction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(outlined_button, {
                            className: (business_resource_asset_library_module_default()).buttonResponsive,
                            onClick: ()=>setOpen(true),
                            children: [
                                "I'm not sure what I need",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BusinessResourceFilter, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_library_module_default()).buttonContainer,
                        id: "container",
                        ref: buttonContainerRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()({
                                [(business_resource_asset_library_module_default()).lock]: lock && assets.length
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
                                resources: getDownloadAssetResources(),
                                rootContainerName: "asset-library",
                                disabled: !assets.length,
                                containerClass: (business_resource_asset_library_module_default()).buttonResponsive,
                                className: classnames_default()((business_resource_asset_library_module_default()).buttonResponsive, {
                                    [(business_resource_asset_library_module_default()).lockedButton]: lock
                                }),
                                mobileFullWidth: true,
                                children: [
                                    "Download Selected ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_library_module_default()).tab,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(inlined_multi_select_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_library_module_default()).chip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chips_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_asset_grid, {
                renderAssetCard: (asset)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card_container, {
                        asset: asset
                    }),
                resources: getFilteredResources(),
                columns: columns,
                showDownloadButton: showDownloadButton,
                limitRows: limitRows,
                showDivider: true
            })
        ]
    });
};
const BusinessResourceAssetLibraryContextWrapper = (param)=>{
    let { resources: initResources = [] , ...props } = param;
    const [colors, setColors] = (0,react.useState)([]);
    const [keyMessages, setKeyMessages] = (0,react.useState)([]);
    const [themedAssets, setThemedAssets] = (0,react.useState)([]);
    const [assetTypes, setAssetTypes] = (0,react.useState)([]);
    const [assets, setAssets] = (0,react.useState)([]);
    const resources = (0,react.useMemo)(()=>{
        return initResources === null || initResources === void 0 ? void 0 : initResources.map((resource)=>{
            var ref;
            return {
                ...resource,
                id: Math.random().toString(8),
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.map((asset)=>({
                        ...asset,
                        id: Math.random().toString(8)
                    }))
            };
        });
    }, []);
    const getDownloadAssetResources = ()=>{
        return getFilteredResources().map((resource)=>{
            var ref;
            return {
                ...resource,
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>assets.some((param)=>{
                        let { id  } = param;
                        return id === asset.id;
                    }))
            };
        });
    };
    const getDownloadAssets = (resourceId)=>{
        var ref;
        const resource = resources.find((param)=>{
            let { id  } = param;
            return id === resourceId;
        });
        if (!resource) return [];
        return ((ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>assets.some((param)=>{
                let { id  } = param;
                return id === asset.id;
            }))) || [];
    };
    const getFilteredResources = ()=>{
        return (resources || []).filter((param)=>{
            let { type  } = param;
            return !type || !assetTypes.length || assetTypes.includes(type);
        }).map((resource)=>{
            var ref;
            return {
                ...resource,
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>!keyMessages.length || keyMessages.some((k)=>asset.keyMessages && asset.keyMessages.includes(k))).filter((asset)=>!themedAssets.length || themedAssets.some((k)=>asset.themedAssets && asset.themedAssets.includes(k))).map((asset)=>{
                    return {
                        ...asset,
                        variants: asset.variants.filter((variant)=>{
                            return !colors.length || colors.some((color)=>{
                                var ref, ref1;
                                return ((ref = variant.colors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.color) === color;
                            });
                        })
                    };
                }).filter((param)=>{
                    let { variants  } = param;
                    return variants.length;
                })
            };
        }).filter((param)=>{
            let { assets  } = param;
            return assets === null || assets === void 0 ? void 0 : assets.length;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetLibraryProvider, {
        value: {
            resources,
            colors,
            setColors,
            keyMessages,
            setKeyMessages,
            themedAssets,
            setThemedAssets,
            assetTypes,
            setAssetTypes,
            assets,
            setAssets,
            getDownloadAssetResources,
            getDownloadAssets,
            getFilteredResources
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetLibrary, {
            ...props
        })
    });
};
/* harmony default export */ var business_resource_asset_library = (BusinessResourceAssetLibraryContextWrapper);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/business-resource-asset-library.builder-component.ts


const BusinessResourceAssetBuilderConfig = {
    name: "Resource Asset Library",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "columns",
            type: "number"
        },
        {
            name: "limitRows",
            type: "number"
        },
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_asset_library_builder_component_builderConfig = {
    component: business_resource_asset_library,
    config: BusinessResourceAssetBuilderConfig
};
/* harmony default export */ var business_resource_asset_library_builder_component = (business_resource_asset_library_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.module.scss
var business_resource_background_text_wrap_module = __webpack_require__(8032);
var business_resource_background_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_background_text_wrap_module);
// EXTERNAL MODULE: ./components/copy-button/copy-button.module.scss
var copy_button_module = __webpack_require__(2876);
var copy_button_module_default = /*#__PURE__*/__webpack_require__.n(copy_button_module);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(5630);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/copy-button/copy-button.tsx







const CopyButton = (param)=>{
    let { content  } = param;
    const [isCopied, setIsCopied] = (0,react.useState)(false);
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                ref: setPopperElement,
                className: classnames_default()((copy_button_module_default()).tooltip, {
                    [(copy_button_module_default()).visible]: isCopied
                }),
                style: popperStyles.popper,
                ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
                children: [
                    "Copied!",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: setArrowElement,
                        className: (copy_button_module_default()).tooltipArrow,
                        style: popperStyles.arrow
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: content,
                onCopy: ()=>{
                    setIsCopied(true);
                    setTimeout(()=>{
                        setIsCopied(false);
                    }, 2000);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: setReferenceElement,
                    className: (copy_button_module_default()).copyIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Copy */.T.Copy
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var copy_button = (CopyButton);

;// CONCATENATED MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.tsx




const BusinessResourceBackgroundTextWrap = (param)=>{
    let { text , copyableText  } = param;
    if (!text) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_background_text_wrap_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_background_text_wrap_module_default()).text,
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }),
            copyableText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_background_text_wrap_module_default()).copyButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copy_button, {
                    content: copyableText
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_background_text_wrap = (BusinessResourceBackgroundTextWrap);

;// CONCATENATED MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.builder-component.ts

const BusinessResourceBackgroundTextWrapBuilderConfig = {
    name: "Resource Background Text Wrap",
    inputs: [
        {
            name: "text",
            type: "richText"
        },
        {
            name: "copyableText",
            type: "longText"
        }
    ]
};
const business_resource_background_text_wrap_builder_component_builderConfig = {
    component: business_resource_background_text_wrap,
    config: BusinessResourceBackgroundTextWrapBuilderConfig
};
/* harmony default export */ var business_resource_background_text_wrap_builder_component = (business_resource_background_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-banner-carousel/business-resource-banner-carousel.module.scss
var business_resource_banner_carousel_module = __webpack_require__(3202);
var business_resource_banner_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_banner_carousel_module);
;// CONCATENATED MODULE: ./components/business-resource-banner-carousel/business-resource-banner-carousel.tsx








const options = {
    slidesPerView: "auto",
    spaceBetween: 45,
    allowTouchMove: true
};
const BusinessResourceBannerCarousel = (props)=>{
    const { banners =[] , ctaText  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadURLs = [];
    banners.map((banner)=>{
        if (banner.downloadUrl) {
            downloadURLs.push(banner.downloadUrl);
        }
    });
    const onDownloadAll = async ()=>{
        setLoading(true);
        try {
            const items = {
                name: "afterpay-banners",
                type: "banner",
                variants: banners.filter((banner)=>!!banner.downloadUrl).map((banner)=>{
                    return {
                        downloadUrl: banner.downloadUrl,
                        extension: banner.extension,
                        variantName: banner.bannerName
                    };
                })
            };
            await downloadAsset([
                items
            ], "afterpay-banners");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_resource_banner_carousel_module_default()).container, {
            [(business_resource_banner_carousel_module_default()).withDownloadButton]: (downloadURLs === null || downloadURLs === void 0 ? void 0 : downloadURLs.length) > 0
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_banner_carousel_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                    ...options,
                    children: banners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (business_resource_banner_carousel_module_default()).bannerPreview,
                                src: banner.preview,
                                alt: ""
                            })
                        }, index))
                }),
                (downloadURLs === null || downloadURLs === void 0 ? void 0 : downloadURLs.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_banner_carousel_module_default()).download,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                        disabled: loading,
                        onClick: onDownloadAll,
                        children: [
                            ctaText || "Download All Banners",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.Download */.T.Download
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var business_resource_banner_carousel = (BusinessResourceBannerCarousel);

;// CONCATENATED MODULE: ./components/business-resource-banner-carousel/business-resource-asset.builder-component.ts

const BusinessResourceBannerCarouselBuilderConfig = {
    name: "Resource Banner Carousel",
    inputs: [
        {
            name: "banners",
            type: "list",
            subFields: [
                {
                    name: "bannerName",
                    type: "string"
                },
                {
                    name: "extension",
                    type: "string"
                },
                {
                    name: "preview",
                    type: "file"
                },
                {
                    name: "downloadUrl",
                    type: "url"
                }
            ]
        },
        {
            name: "ctaText",
            type: "string"
        }
    ]
};
const business_resource_asset_builder_component_builderConfig = {
    component: business_resource_banner_carousel,
    config: BusinessResourceBannerCarouselBuilderConfig
};
/* harmony default export */ var business_resource_asset_builder_component = (business_resource_asset_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-banners/business-resource-banners.module.scss
var business_resource_banners_module = __webpack_require__(8328);
var business_resource_banners_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_banners_module);
// EXTERNAL MODULE: ./components/business-resource-asset-single-variant/business-resource-asset-single-variant.module.scss
var business_resource_asset_single_variant_module = __webpack_require__(1280);
var business_resource_asset_single_variant_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_single_variant_module);
;// CONCATENATED MODULE: ./components/business-resource-asset-single-variant/business-resource-single-asset-variant.tsx






const BusinessResourceSingleAssetVariant = (param)=>{
    let { asset , clickable , onClick , downloadPlacement , ButtonProps ={}  } = param;
    var ref;
    const firstVariant = asset === null || asset === void 0 ? void 0 : (ref = asset.variants) === null || ref === void 0 ? void 0 : ref[0];
    if (!firstVariant) return null;
    const getPlacementClass = ()=>{
        if (downloadPlacement === "center") {
            return (business_resource_asset_single_variant_module_default()).alignCentger;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_asset_single_variant_module_default()).root, getPlacementClass()),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_single_variant_module_default()).item,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                    item: asset,
                    type: "icon",
                    ...ButtonProps,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_asset_single_variant_module_default()).item, (business_resource_asset_single_variant_module_default()).imageCol, {
                    [(business_resource_asset_single_variant_module_default()).clickable]: clickable
                }),
                onClick: (e)=>{
                    return onClick === null || onClick === void 0 ? void 0 : onClick(asset, e);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_asset_single_variant_module_default()).image,
                    src: firstVariant.previewUrl,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_single_asset_variant = (BusinessResourceSingleAssetVariant);

;// CONCATENATED MODULE: ./components/business-resource-asset-single-variant/business-resource-single-asset-variant-container.tsx




const BusinessResourceSingleAssetVariantContainer = (param)=>{
    let { asset , ...props } = param;
    const { loading , downloadVariant  } = hook_useDownloadVariant();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant, {
        ButtonProps: {
            disabled: loading,
            onVariantClick: (variant)=>{
                downloadVariant(asset, variant, "asset");
            }
        },
        asset: asset,
        ...props
    });
};
/* harmony default export */ var business_resource_single_asset_variant_container = (BusinessResourceSingleAssetVariantContainer);

// EXTERNAL MODULE: ./components/business-resource-group-label/business-resource-group-label.module.scss
var business_resource_group_label_module = __webpack_require__(9218);
var business_resource_group_label_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_group_label_module);
;// CONCATENATED MODULE: ./components/business-resource-group-label/business-resource-group-label.tsx




const BusinessResourceGroupLabel = (param)=>{
    let { children , DownloadButtonProps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_group_label_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_group_label_module_default()).title,
                children: children
            }),
            DownloadButtonProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                ...DownloadButtonProps
            })
        ]
    });
};
/* harmony default export */ var business_resource_group_label = (BusinessResourceGroupLabel);

;// CONCATENATED MODULE: ./components/business-resource-group-label/business-resource-group-label-container.tsx




const BusinessResourceGroupLabelContainer = (param)=>{
    let { assets , rootFolderName , DownloadButtonProps ={} , ...props } = param;
    const { loading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_group_label, {
        DownloadButtonProps: {
            disabled: loading || (DownloadButtonProps === null || DownloadButtonProps === void 0 ? void 0 : DownloadButtonProps.disabled),
            onClick: (e)=>{
                var ref;
                DownloadButtonProps === null || DownloadButtonProps === void 0 ? void 0 : (ref = DownloadButtonProps.onClick) === null || ref === void 0 ? void 0 : ref.call(DownloadButtonProps, e);
                downloadAssets(assets, rootFolderName);
            },
            ...DownloadButtonProps
        },
        ...props
    });
};
/* harmony default export */ var business_resource_group_label_container = (BusinessResourceGroupLabelContainer);

;// CONCATENATED MODULE: ./components/business-resource-banners/business-resource-banners.tsx








const BusinessResourceBanners = (param)=>{
    let { resources  } = param;
    var ref, ref1, ref2, ref3;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((resources === null || resources === void 0 ? void 0 : (ref = resources[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_banners_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
                resources: resources || [],
                rootContainerName: "banners",
                children: [
                    "Download All Banners ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_banners_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref2 = selectedAsset.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.pagePreviewImage,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: resources === null || resources === void 0 ? void 0 : resources.map((resource, index)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_group_label_container, {
                                assets: resource.assets || [],
                                rootFolderName: resource.title || "banner",
                                DownloadButtonProps: {
                                    children: "Download All"
                                },
                                children: resource === null || resource === void 0 ? void 0 : resource.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_banners_module_default()).resourceContainer,
                                children: resource === null || resource === void 0 ? void 0 : (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                                        asset: asset,
                                        clickable: true,
                                        onClick: (asset)=>setSelectedAsset(asset)
                                    }, index))
                            }),
                            index !== (resources === null || resources === void 0 ? void 0 : resources.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_banners = (BusinessResourceBanners);

;// CONCATENATED MODULE: ./components/business-resource-banners/business-resource-banners.builder-component.ts

const BusinessResourceBannersBuilderConfig = {
    name: "Resource Banners",
    inputs: [
        {
            name: "resources",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "assets",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "keyMessages",
                            type: "Tags"
                        },
                        {
                            name: "themedAssets",
                            type: "Tags"
                        },
                        {
                            name: "variants",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "variantName",
                                    type: "string"
                                },
                                {
                                    name: "color",
                                    type: "color"
                                },
                                {
                                    name: "backgroundColor",
                                    type: "color"
                                },
                                {
                                    name: "previewUrl",
                                    type: "url"
                                },
                                {
                                    name: "downloadUrl",
                                    type: "url"
                                },
                                {
                                    name: "extension",
                                    type: "string"
                                },
                                {
                                    name: "pagePreviewImage",
                                    type: "file"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_banners_builder_component_builderConfig = {
    component: business_resource_banners,
    config: BusinessResourceBannersBuilderConfig
};
/* harmony default export */ var business_resource_banners_builder_component = (business_resource_banners_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-card/business-resource-card.module.scss
var business_resource_card_module = __webpack_require__(9890);
var business_resource_card_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_card_module);
;// CONCATENATED MODULE: ./components/business-resource-card/business-resource-card.tsx





const ResourceCard = (props)=>{
    const { image , title , description , replaceLocalesOnLink  } = props;
    let url = props.url;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    if (replaceLocalesOnLink) {
        if ((0,LangHelper/* doesContainLocale */.RO)(url)) {
            url = (0,LangHelper/* replaceLocale */.mC)(url, locale);
        } else {
            url = "/".concat(locale).concat(url);
        }
        url = (0,LangHelper/* localifyLink */.Bj)(url, locale);
    }
    var _buttonLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_card_module_default()).businessResourceCardWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_card_module_default()).businessResourceCardBackgroundWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_card_module_default()).businessResourceCardBackgroundBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardBackground,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_card_module_default()).businessResourceCardOverlayWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardOverlayTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardOverlayDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_card_module_default()).businessResourceCardOverlayCTA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (_buttonLabel = props.buttonLabel) !== null && _buttonLabel !== void 0 ? _buttonLabel : "Read more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightSmall */.T.ArrowRightSmall
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_card = (ResourceCard);

;// CONCATENATED MODULE: ./components/business-resource-card/business-resource-card.builder-component.ts

const BusinessResourceCardBuilderConfig = {
    name: "Resource Card",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: "",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "buttonLabel",
            type: "string",
            defaultValue: "Read more"
        },
        {
            name: "url",
            type: "url"
        },
        {
            name: "replaceLocalesOnLink",
            type: "boolean",
            defaultValue: false
        }
    ]
};
const business_resource_card_builder_component_builderConfig = {
    component: business_resource_card,
    config: BusinessResourceCardBuilderConfig
};
/* harmony default export */ var business_resource_card_builder_component = (business_resource_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.module.scss
var business_resource_centre_hero_module = __webpack_require__(7625);
var business_resource_centre_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_centre_hero_module);
;// CONCATENATED MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.tsx




const BusinessResourceCentreHero = (props)=>{
    const { title  } = props;
    const Element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_centre_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_centre_hero_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_centre_hero_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_centre_hero_module_default()).title,
                    children: title
                })
            })
        ]
    });
    (0,react.useEffect)(()=>{
        const container = document.getElementById("resource-centre-hero-container");
        if (!container) return;
        container.style.display = "block";
        react_dom.render(Element, container);
        return ()=>{
            container.style.display = "none";
        };
    }, []);
    return null;
};
/* harmony default export */ var business_resource_centre_hero = (BusinessResourceCentreHero);

;// CONCATENATED MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.builder-component.ts

const BusinessResourceCentreHeroBuilderConfig = {
    name: "Resource Centre Hero",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "filterTilte",
            type: "string",
            defaultValue: ""
        }
    ]
};
const business_resource_centre_hero_builder_component_builderConfig = {
    component: business_resource_centre_hero,
    config: BusinessResourceCentreHeroBuilderConfig
};
/* harmony default export */ var business_resource_centre_hero_builder_component = (business_resource_centre_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-colour-palette/colour-card/colour-card.module.scss
var colour_card_module = __webpack_require__(8315);
var colour_card_module_default = /*#__PURE__*/__webpack_require__.n(colour_card_module);
;// CONCATENATED MODULE: ./components/business-resource-colour-palette/colour-card/colour-card.tsx







const ColourCard = (props)=>{
    const { colour , name , description , textColor  } = props;
    const [rgbCopied, setRgbCopied] = (0,react.useState)(false);
    const [hexCopied, setHexCopied] = (0,react.useState)(false);
    if (!colour) return null;
    let rgbColor = hexToRgb(colour);
    if (!rgbColor) {
        const rgb = colour.replace(/[^\d,]/g, "").split(",");
        rgbColor = {};
        rgbColor.r = Number.parseInt(rgb[0], 10);
        rgbColor.g = Number.parseInt(rgb[1], 10);
        rgbColor.b = Number.parseInt(rgb[2], 10);
    }
    const hex = rgbToHex(rgbColor.r, rgbColor.g, rgbColor.b);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((colour_card_module_default()).container, {
            [(colour_card_module_default()).bordered]: isWhite(colour)
        }),
        style: {
            backgroundColor: colour
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (colour_card_module_default()).content,
            style: {
                color: textColor
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (colour_card_module_default()).name,
                    children: name
                }),
                description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (colour_card_module_default()).description,
                    children: description
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((colour_card_module_default()).colorCode, {
                        [(colour_card_module_default()).copied]: rgbCopied
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                        text: colour,
                        onCopy: ()=>{
                            setRgbCopied(true);
                            setTimeout(()=>{
                                setRgbCopied(false);
                            }, 3000);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (colour_card_module_default()).copyIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Copy */.T.Copy
                                    })
                                }),
                                rgbCopied ? "Copied!" : "RGB ".concat(rgbColor.r, " ").concat(rgbColor.g, " ").concat(rgbColor.b)
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((colour_card_module_default()).colorCode, {
                        [(colour_card_module_default()).copied]: hexCopied
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                        text: hex,
                        onCopy: ()=>{
                            setHexCopied(true);
                            setTimeout(()=>{
                                setHexCopied(false);
                            }, 3000);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (colour_card_module_default()).copyIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Copy */.T.Copy
                                    })
                                }),
                                hexCopied ? "Copied!" : "HEX ".concat(hex)
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var colour_card = (ColourCard);

// EXTERNAL MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.module.scss
var business_resource_colour_palette_module = __webpack_require__(1951);
var business_resource_colour_palette_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_colour_palette_module);
;// CONCATENATED MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.tsx




const BusinessResourceColourPalette = (props)=>{
    const { layout ="primary" , colours  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_resource_colour_palette_module_default()).container, (business_resource_colour_palette_module_default())[layout]),
        children: colours === null || colours === void 0 ? void 0 : colours.map((colour, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(colour_card, {
                ...colour
            }, index))
    });
};
/* harmony default export */ var business_resource_colour_palette = (BusinessResourceColourPalette);

;// CONCATENATED MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.builder-component.ts

const BusinessResourceColourPaletteBuilderConfig = {
    name: "Resource Colour Palette",
    inputs: [
        {
            name: "layout",
            type: "string",
            defaultValue: "primary",
            enum: [
                "primary",
                "secondary"
            ]
        },
        {
            name: "colours",
            type: "list",
            subFields: [
                {
                    name: "colour",
                    type: "color",
                    required: true
                },
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "textColor",
                    type: "color",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_colour_palette_builder_component_builderConfig = {
    component: business_resource_colour_palette,
    config: BusinessResourceColourPaletteBuilderConfig
};
/* harmony default export */ var business_resource_colour_palette_builder_component = (business_resource_colour_palette_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-divider/business-resource-divider.builder-component.ts

const BusinessResourceDividerBuilderConfig = {
    name: "Resource Divider",
    inputs: []
};
const business_resource_divider_builder_component_builderConfig = {
    component: business_resource_divider,
    config: BusinessResourceDividerBuilderConfig
};
/* harmony default export */ var business_resource_divider_builder_component = (business_resource_divider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-download-card/business-resource-download-card.module.scss
var business_resource_download_card_module = __webpack_require__(6703);
var business_resource_download_card_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_card_module);
;// CONCATENATED MODULE: ./components/business-resource-download-card/business-resource-download-card.tsx








const BusinessResourceDownloadCard = (props)=>{
    var ref;
    const { item , type  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    if (!item) return null;
    const showingVariant = (ref = item.variants) === null || ref === void 0 ? void 0 : ref[0];
    if (!showingVariant) return null;
    const onClick = async (variant)=>{
        setLoading(true);
        try {
            let asset = item;
            let name;
            if (variant === "ALL") {
                name = "".concat(item.name ? "".concat(item.name) : "") || "afterpay-assets";
            } else {
                name = "".concat(variant.variantName).toLowerCase() || "afterpay-assets";
                asset = {
                    ...item,
                    variants: [
                        variant
                    ]
                };
            }
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_download_card_module_default()).container, type && (business_resource_download_card_module_default())[type], {
            [(business_resource_download_card_module_default()).bordered]: isWhite(showingVariant.backgroundColor)
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_card_module_default()).downloadContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_download_card_module_default()).download,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                        disabled: loading,
                        type: "icon",
                        item: item,
                        onVariantClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_card_module_default()).box,
                style: {
                    background: showingVariant.backgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: showingVariant.previewUrl,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_card = (BusinessResourceDownloadCard);

;// CONCATENATED MODULE: ./components/business-resource-download-card/business-resource-download-card.builder-component.ts

const BusinessResourceDownloadCardBuilderConfig = {
    name: "Resource Download Card",
    inputs: [
        {
            name: "type",
            type: "string",
            defaultValue: "default",
            enum: [
                "large",
                "default"
            ]
        },
        {
            name: "item",
            type: "object",
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "color"
                        },
                        {
                            name: "backgroundColor",
                            type: "color",
                            helperText: "Background in the UI. Default is white",
                            defaultValue: "#ffffff"
                        },
                        {
                            name: "extension",
                            helperText: "Example: svg, png, ai, eps,...",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_download_card_builder_component_builderConfig = {
    component: business_resource_download_card,
    config: BusinessResourceDownloadCardBuilderConfig
};
/* harmony default export */ var business_resource_download_card_builder_component = (business_resource_download_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-download-grid/business-resource-download-grid.module.scss
var business_resource_download_grid_module = __webpack_require__(7820);
var business_resource_download_grid_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_grid_module);
;// CONCATENATED MODULE: ./components/business-resource-download-grid/business-resource-download-grid.tsx







const BusinessResourceDownloadGrid = (props)=>{
    const { name , items  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    if (!items) return null;
    const onDownloadAll = async ()=>{
        setLoading(true);
        try {
            await downloadAsset(items, name || "afterpay-assets");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_download_grid_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_grid_module_default()).box,
                children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_card, {
                        item: item
                    }, "".concat(item.name, "_").concat(item.type, "_").concat(Math.random())))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                containerClass: (business_resource_download_grid_module_default()).downloadButton,
                disabled: loading,
                onClick: onDownloadAll,
                children: [
                    "Download All Versions ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Download */.T.Download
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_grid = (BusinessResourceDownloadGrid);

;// CONCATENATED MODULE: ./components/business-resource-download-grid/business-resource-download-grid.builder-component.ts

const BusinessResourceDownloadGridBuilderConfig = {
    name: "Resource Download Grid",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "color"
                        },
                        {
                            name: "backgroundColor",
                            type: "color",
                            helperText: "Background in the UI. Default is white",
                            defaultValue: "#ffffff"
                        },
                        {
                            name: "extension",
                            helperText: "Example: svg, png, ai, eps,...",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_download_grid_builder_component_builderConfig = {
    component: business_resource_download_grid,
    config: BusinessResourceDownloadGridBuilderConfig
};
/* harmony default export */ var business_resource_download_grid_builder_component = (business_resource_download_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-faq/business-resource-faq.module.scss
var business_resource_faq_module = __webpack_require__(5355);
var business_resource_faq_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_faq_module);
;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq-item.tsx



const FAQItem = (props)=>{
    const { item  } = props;
    const id = (0,react.useMemo)(()=>"".concat(Math.random()), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_faq_module_default()).itemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (business_resource_faq_module_default()).question,
                htmlFor: id,
                children: item.question
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_faq_module_default()).answer,
                dangerouslySetInnerHTML: {
                    __html: item.answer
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_faq_item = (FAQItem);

;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq.tsx



const BusinessResourceFAQ = (props)=>{
    const { faqs  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_faq_module_default()).container,
        children: faqs === null || faqs === void 0 ? void 0 : faqs.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_faq_item, {
                item: faq
            }, index))
    });
};
/* harmony default export */ var business_resource_faq = (BusinessResourceFAQ);

;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq.builder-component.ts

const BusinessResourceFAQBuilderConfig = {
    name: "Resource FAQ",
    inputs: [
        {
            name: "faqs",
            type: "list",
            subFields: [
                {
                    name: "question",
                    type: "string"
                },
                {
                    name: "answer",
                    type: "richText"
                }
            ]
        }
    ]
};
const business_resource_faq_builder_component_builderConfig = {
    component: business_resource_faq,
    config: BusinessResourceFAQBuilderConfig
};
/* harmony default export */ var business_resource_faq_builder_component = (business_resource_faq_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(3431);
// EXTERNAL MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.module.scss
var business_resource_hero_sub_module = __webpack_require__(3042);
var business_resource_hero_sub_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_hero_sub_module);
;// CONCATENATED MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.tsx






const ResourceHeroSub = (props)=>{
    const { image , title , description , breadcrumbs  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_hero_sub_module_default()).businessResourceHeroSubWrapper, {
            [(business_resource_hero_sub_module_default()).breadcrumb]: breadcrumbs && breadcrumbs.length
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubBackgroundWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_hero_sub_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            breadcrumbs && breadcrumbs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubBreadcrumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    breadcrumbs: breadcrumbs,
                    type: width > 768 ? "dark" : "light"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_hero_sub = (ResourceHeroSub);

;// CONCATENATED MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.builder-component.ts

const BusinessResourceHeroSubBuilderConfig = {
    name: "Resource Hero - Tight",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: "",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "buttonLabel",
            type: "string",
            defaultValue: "Read more"
        },
        {
            name: "breadcrumbs",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_resource_hero_sub_builder_component_builderConfig = {
    component: business_resource_hero_sub,
    config: BusinessResourceHeroSubBuilderConfig
};
/* harmony default export */ var business_resource_hero_sub_builder_component = (business_resource_hero_sub_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-hiws/business-resource-hiws.module.scss
var business_resource_hiws_module = __webpack_require__(5636);
var business_resource_hiws_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_hiws_module);
;// CONCATENATED MODULE: ./components/business-resource-hiws/business-resource-hiws.tsx






const BusinessResourceHiws = (param)=>{
    let { rows  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((rows === null || rows === void 0 ? void 0 : (ref = rows[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_hiws_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: (rows === null || rows === void 0 ? void 0 : rows.reduce((result, param)=>{
                    let { assets  } = param;
                    return result.concat(assets || []);
                }, [])) || [],
                rootContainerName: "how-it-works",
                children: [
                    "Download All How It Works ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            rows === null || rows === void 0 ? void 0 : (ref2 = rows.map) === null || ref2 === void 0 ? void 0 : ref2.call(rows, (row, index)=>{
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_hiws_module_default()).resourceContainer,
                    children: row === null || row === void 0 ? void 0 : (ref = row.assets) === null || ref === void 0 ? void 0 : ref.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                            asset: asset,
                            clickable: true,
                            onClick: (asset)=>setSelectedAsset(asset)
                        }, index))
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_hiws_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref3 = selectedAsset.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.pagePreviewImage,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_hiws = (BusinessResourceHiws);

;// CONCATENATED MODULE: ./components/business-resource-hiws/business-resource-hiws.builder-component.ts

const BusinessResourceHIWsBuilderConfig = {
    name: "Resource How It Works",
    inputs: [
        {
            name: "rows",
            type: "list",
            subFields: [
                {
                    name: "assets",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "variants",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "variantName",
                                    type: "string"
                                },
                                {
                                    name: "previewUrl",
                                    type: "url"
                                },
                                {
                                    name: "downloadUrl",
                                    type: "url"
                                },
                                {
                                    name: "extension",
                                    type: "string"
                                },
                                {
                                    name: "pagePreviewImage",
                                    type: "file"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_hiws_builder_component_builderConfig = {
    component: business_resource_hiws,
    config: BusinessResourceHIWsBuilderConfig
};
/* harmony default export */ var business_resource_hiws_builder_component = (business_resource_hiws_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.module.scss
var business_resource_image_carousel_module = __webpack_require__(4083);
var business_resource_image_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_image_carousel_module);
;// CONCATENATED MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.tsx






const getDefaultString = (defaultValue, value)=>{
    if (!value) return defaultValue;
    return value;
};
const getDefaultNumber = (defaultValue, value)=>{
    if (typeof value === "number") {
        return value;
    }
    return defaultValue;
};
const BusinessResourceImageCarousel = (param)=>{
    let { images =[] , spaceBetween: rawSpaceBetween , itemWidth: rawItemWidth , responsive =[]  } = param;
    let itemWidth = getDefaultString("auto", rawItemWidth);
    const spaceBetween = getDefaultNumber(undefined, rawSpaceBetween);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    const getWidth = ()=>{
        let w = itemWidth;
        let currentBreakpoint = 0;
        responsive === null || responsive === void 0 ? void 0 : responsive.forEach((param)=>{
            let { breakpoint: rawBreakPoint , itemWidth  } = param;
            const breakpoint = getDefaultNumber(0, rawBreakPoint);
            if (width >= breakpoint && breakpoint >= currentBreakpoint && itemWidth) {
                currentBreakpoint = breakpoint;
                w = itemWidth;
            }
        });
        return w;
    };
    const getBreakpoints = ()=>{
        if (!responsive) return undefined;
        return responsive.reduce((result, param)=>{
            let { breakpoint , spaceBetween  } = param;
            if (!breakpoint) return result;
            result[breakpoint] = result[breakpoint] || {};
            if (spaceBetween !== undefined) {
                result[breakpoint].spaceBetween = spaceBetween;
            }
            return result;
        }, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_image_carousel_module_default()).root,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
            breakpoints: getBreakpoints(),
            spaceBetween: spaceBetween,
            slidesPerView: "auto",
            init: false,
            onSwiper: (sw)=>{
                setSwiper(sw);
            },
            children: images === null || images === void 0 ? void 0 : images.map((param, index)=>/*#__PURE__*/ {
                let { image  } = param;
                return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    style: {
                        width: getWidth()
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (business_resource_image_carousel_module_default()).image,
                        src: image
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var business_resource_image_carousel = (BusinessResourceImageCarousel);

;// CONCATENATED MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.builder-component.ts

const sliderConfig = [
    {
        name: "itemWidth",
        type: "string",
        helperText: 'Should be number or "auto"'
    },
    {
        name: "spaceBetween",
        type: "number"
    }
];
const BusinessResourceImageCarouselConfig = {
    name: "Resource Image Carousel",
    inputs: [
        {
            name: "images",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "image",
                    type: "file"
                }
            ]
        },
        ...sliderConfig,
        {
            name: "responsive",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "breakpoint",
                    type: "number"
                },
                ...sliderConfig
            ]
        }
    ]
};
const business_resource_image_carousel_builder_component_builderConfig = {
    component: business_resource_image_carousel,
    config: BusinessResourceImageCarouselConfig
};
/* harmony default export */ var business_resource_image_carousel_builder_component = (business_resource_image_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.module.scss
var business_resource_image_comparison_slider_module = __webpack_require__(5765);
var business_resource_image_comparison_slider_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_image_comparison_slider_module);
;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/image-comparison-slider.utils.ts
function compareImages(img, sliderId, sliderClassName) {
    let slider;
    // let img;
    let clicked = 0;
    let w;
    let h;
    /* Get the width and height of the img element */ w = img.offsetWidth;
    h = img.offsetHeight;
    console.log("w", w);
    /* Set the width of the img element to 50%: */ img.style.width = w / 2 + "px";
    /* Create slider: */ slider = document.getElementById(sliderId);
    if (slider) {
        slider.remove();
    }
    slider = document.createElement("div");
    slider.appendChild(document.createElement("div"));
    slider.setAttribute("class", sliderClassName);
    slider.setAttribute("id", sliderId);
    /* Insert slider */ img.parentElement.insertBefore(slider, img);
    /* Position the slider in the middle: */ slider.style.top = h / 2 - slider.offsetHeight / 2 + "px";
    slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";
    /* Execute a function when the mouse button is pressed: */ slider.addEventListener("mousedown", slideReady);
    /* And another function when the mouse button is released: */ window.addEventListener("mouseup", slideFinish);
    /* Or touched (for touch screens: */ slider.addEventListener("touchstart", slideReady);
    /* And released (for touch screens: */ window.addEventListener("touchend", slideFinish);
    function slideReady(e) {
        /* Prevent any other actions that may occur when moving over the image: */ e.preventDefault();
        /* The slider is now clicked and ready to move: */ clicked = 1;
        /* Execute a function when the slider is moved: */ window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
    }
    function slideFinish() {
        /* The slider is no longer clicked: */ clicked = 0;
    }
    function slideMove(e) {
        var pos;
        /* If the slider is no longer clicked, exit this function: */ if (clicked == 0) return false;
        /* Get the cursor's x position: */ pos = getCursorPos(e);
        /* Prevent the slider from being positioned outside the image: */ if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        /* Execute a function that will resize the overlay image according to the cursor: */ slide(pos);
    }
    function getCursorPos(e) {
        var a, x = 0;
        e = e.changedTouches ? e.changedTouches[0] : e;
        /* Get the x positions of the image: */ a = img.getBoundingClientRect();
        /* Calculate the cursor's x coordinate, relative to the image: */ x = e.pageX - a.left;
        /* Consider any page scrolling: */ x = x - window.pageXOffset;
        return x;
    }
    function slide(x) {
        /* Resize the image: */ img.style.width = x + "px";
        /* Position the slider: */ slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
    }
}

;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.tsx






const BusinessResourceImageComparisonSlider = (props)=>{
    var ref;
    const { title , leftImage , rightImage  } = props;
    const containerRef = (0,react.useRef)(null);
    const containerWidth = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().width;
    const imgCompSliderId = (0,react.useMemo)(()=>"".concat(Math.random()), []);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const lastWindowWidth = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (!containerRef.current) return;
        const elemements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByClassName((business_resource_image_comparison_slider_module_default()).imgCompOverlay);
        (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.getElementsByClassName;
        const isWindowResize = lastWindowWidth.current !== undefined && width !== undefined && lastWindowWidth.current !== width;
        for(let i = 0; i < elemements.length; i++){
            const imgElement = elemements[i];
            if (isWindowResize) {
                imgElement.style.width = containerWidth + "px";
            }
            compareImages(imgElement, imgCompSliderId, (business_resource_image_comparison_slider_module_default()).imgCompSlider);
        }
        lastWindowWidth.current = width;
        return ()=>{
            var ref;
            (ref = document.getElementById(imgCompSliderId)) === null || ref === void 0 ? void 0 : ref.remove();
        };
    }, [
        containerWidth,
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (business_resource_image_comparison_slider_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_image_comparison_slider_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_image_comparison_slider_module_default()).sliderContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_image_comparison_slider_module_default()).img,
                        style: {
                            width: containerWidth
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).mask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: rightImage,
                                style: {
                                    width: containerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default())["do"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Do"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((business_resource_image_comparison_slider_module_default()).img, (business_resource_image_comparison_slider_module_default()).imgCompOverlay),
                        style: {
                            width: containerWidth
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).mask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: leftImage,
                                style: {
                                    width: containerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).dont,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Don't"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_image_comparison_slider = (BusinessResourceImageComparisonSlider);

;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.builder-component.ts

const BusinessResourceImageComparisonSliderBuilderConfig = {
    name: "Resource Image Comparison Slider",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "leftImage",
            type: "file",
            required: true
        },
        {
            name: "rightImage",
            type: "file",
            required: true
        }
    ]
};
const business_resource_image_comparison_slider_builder_component_builderConfig = {
    component: business_resource_image_comparison_slider,
    config: BusinessResourceImageComparisonSliderBuilderConfig
};
/* harmony default export */ var business_resource_image_comparison_slider_builder_component = (business_resource_image_comparison_slider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-in-situ/business-resource-in-situ.module.scss
var business_resource_in_situ_module = __webpack_require__(4993);
var business_resource_in_situ_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_in_situ_module);
;// CONCATENATED MODULE: ./components/business-resource-in-situ/business-resource-in-situ.tsx








const BusinessResourceInSitu = (param)=>{
    let { sections =[]  } = param;
    const showDownloadButton = (downloadButton)=>{
        return !!(downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.assets) && !!downloadButton.assets.length;
    };
    const showViewMoreButton = (moreButton)=>{
        return !!(moreButton === null || moreButton === void 0 ? void 0 : moreButton.url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_in_situ_module_default()).root,
        children: sections === null || sections === void 0 ? void 0 : sections.map((param, index)=>{
            let { title , previewPages =[] , downloadButton , moreButton  } = param;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_in_situ_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_in_situ_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_in_situ_module_default()).previewContainer,
                                children: previewPages === null || previewPages === void 0 ? void 0 : previewPages.map((param, index)=>/*#__PURE__*/ {
                                    let { previewImage , name  } = param;
                                    return (0,jsx_runtime.jsxs)("div", {
                                        className: (business_resource_in_situ_module_default()).previewBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_resource_in_situ_module_default()).previewTitle,
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (business_resource_in_situ_module_default()).previewImage,
                                                src: previewImage
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            (showDownloadButton(downloadButton) || showViewMoreButton(moreButton)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_resource_in_situ_module_default()).action,
                                children: [
                                    showDownloadButton(downloadButton) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                                        assets: (downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.assets) || [],
                                        rootContainerName: title || "in-situ",
                                        containerClass: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        className: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        children: [
                                            downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.text,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                        ]
                                    }),
                                    showViewMoreButton(moreButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_link_button, {
                                        className: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        strong: true,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {}),
                                        children: moreButton === null || moreButton === void 0 ? void 0 : moreButton.text
                                    })
                                ]
                            })
                        ]
                    }, index),
                    index !== (sections === null || sections === void 0 ? void 0 : sections.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {})
                ]
            });
        })
    });
};
/* harmony default export */ var business_resource_in_situ = (BusinessResourceInSitu);

;// CONCATENATED MODULE: ./components/business-resource-in-situ/business-resource-in-situ.builder-component.ts

const BusinessResourceInSituConfig = {
    name: "Resource In Situ",
    inputs: [
        {
            name: "sections",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "previewPages",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "previewImage",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "downloadButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "assets",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "name",
                                    type: "string"
                                },
                                // {
                                //     name: 'keyMessages',
                                //     type: 'Tags',
                                // },
                                // {
                                //     name: 'themedAssets',
                                //     type: 'Tags',
                                // },
                                {
                                    name: "variants",
                                    type: "list",
                                    copyOnAdd: false,
                                    subFields: [
                                        {
                                            name: "variantName",
                                            type: "string"
                                        },
                                        // {
                                        //     name: 'color',
                                        //     type: 'color',
                                        // },
                                        // {
                                        //     name: 'backgroundColor',
                                        //     type: 'color',
                                        // },
                                        // {
                                        //     name: 'previewUrl',
                                        //     type: 'url',
                                        // },
                                        {
                                            name: "downloadUrl",
                                            type: "url"
                                        },
                                        {
                                            name: "extension",
                                            type: "string"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: "moreButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "url",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_in_situ_builder_component_builderConfig = {
    component: business_resource_in_situ,
    config: BusinessResourceInSituConfig
};
/* harmony default export */ var business_resource_in_situ_builder_component = (business_resource_in_situ_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-lightbox/business-resource-lightbox.module.scss
var business_resource_lightbox_module = __webpack_require__(4405);
var business_resource_lightbox_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_lightbox_module);
;// CONCATENATED MODULE: ./components/business-resource-lightbox/business-resource-lightbox.tsx






const BusinessResourceLightbox = (param)=>{
    let { assets  } = param;
    var ref, ref1;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((assets === null || assets === void 0 ? void 0 : assets[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_lightbox_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: assets || [],
                rootContainerName: "lightbox",
                children: [
                    "Download All Lightbox ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_lightbox_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref = selectedAsset.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.pagePreviewImage,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_lightbox_module_default()).resourceContainer,
                children: assets === null || assets === void 0 ? void 0 : assets.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                        asset: asset,
                        clickable: true,
                        onClick: (asset)=>setSelectedAsset(asset)
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var business_resource_lightbox = (BusinessResourceLightbox);

;// CONCATENATED MODULE: ./components/business-resource-lightbox/business-resource-lightbox.builder-component.ts

const BusinessResourceLightboxBuilderConfig = {
    name: "Resource Lightbox",
    inputs: [
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "pagePreviewImage",
                            type: "file"
                        },
                        {
                            name: "extension",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_lightbox_builder_component_builderConfig = {
    component: business_resource_lightbox,
    config: BusinessResourceLightboxBuilderConfig
};
/* harmony default export */ var business_resource_lightbox_builder_component = (business_resource_lightbox_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.module.scss
var business_resource_logo_usage_module = __webpack_require__(1073);
var business_resource_logo_usage_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_logo_usage_module);
// EXTERNAL MODULE: ./components/business-resource-logo-usage/logo-usage-card/logo-usage-card.module.scss
var logo_usage_card_module = __webpack_require__(955);
var logo_usage_card_module_default = /*#__PURE__*/__webpack_require__.n(logo_usage_card_module);
;// CONCATENATED MODULE: ./components/business-resource-logo-usage/logo-usage-card/logo-usage-card.tsx


const LogoUsageCard = (param)=>{
    let { item  } = param;
    const { title , image  } = item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (logo_usage_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (logo_usage_card_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (logo_usage_card_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var logo_usage_card = (LogoUsageCard);

;// CONCATENATED MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.tsx



const BusinessResourceLogoUsage = (param)=>{
    let { items  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_logo_usage_module_default()).container,
        children: items === null || items === void 0 ? void 0 : items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(logo_usage_card, {
                item: item
            }, item.image))
    });
};
/* harmony default export */ var business_resource_logo_usage = (BusinessResourceLogoUsage);

;// CONCATENATED MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.builder-component.ts

const BusinessResourceLogoUsageBuilderConfig = {
    name: "Resource Logo Usage",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_logo_usage_builder_component_builderConfig = {
    component: business_resource_logo_usage,
    config: BusinessResourceLogoUsageBuilderConfig
};
/* harmony default export */ var business_resource_logo_usage_builder_component = (business_resource_logo_usage_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.module.scss
var business_resource_text_wrap_module = __webpack_require__(4709);
var business_resource_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_wrap_module);
;// CONCATENATED MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.tsx




const BusinessResourceTextWrap = (param)=>{
    let { caption , content , row  } = param;
    if (!caption && !content) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_text_wrap_module_default()).root, {
            [(business_resource_text_wrap_module_default()).row]: row
        }),
        children: [
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_wrap_module_default()).caption,
                dangerouslySetInnerHTML: {
                    __html: caption
                }
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_wrap_module_default()).content,
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_wrap = (BusinessResourceTextWrap);

// EXTERNAL MODULE: ./components/business-resource-logos/business-resource-logos.module.scss
var business_resource_logos_module = __webpack_require__(7080);
var business_resource_logos_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_logos_module);
;// CONCATENATED MODULE: ./components/business-resource-logos/business-resource-logos.tsx











const BusinessResourceLogos = (props)=>{
    const { downloadAllText ="Download logos" , resources  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const handleDownloadAll = async ()=>{
        setLoading(true);
        try {
            const assets = [];
            resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>assets.push(...resource.assets || []));
            if (assets.length > 0) {
                await downloadAsset(assets, "Logos");
            }
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                containerClass: (business_resource_logos_module_default()).downloadButton,
                onClick: handleDownloadAll,
                disabled: loading,
                children: [
                    downloadAllText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Download */.T.Download
                    })
                ]
            }),
            width > 768 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null,
            resources === null || resources === void 0 ? void 0 : resources.map((resource, index)=>{
                const { id , title , description , description2 , assets  } = resource;
                const largeAsset = assets === null || assets === void 0 ? void 0 : assets[0];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        width > 768 && index !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                            caption: title,
                            content: description
                        }),
                        largeAsset ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_card, {
                            item: largeAsset,
                            type: "large"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                            content: description2
                        }),
                        (assets === null || assets === void 0 ? void 0 : assets.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_grid, {
                            name: resource.type,
                            items: assets.slice(1, assets.length)
                        }) : null
                    ]
                }, id || Math.random());
            })
        ]
    });
};
/* harmony default export */ var business_resource_logos = (BusinessResourceLogos);

;// CONCATENATED MODULE: ./components/business-resource-logos/business-resource-logos.builder-component.ts


const BusinessResourceLogosBuilderConfig = {
    name: "Resource Logos",
    inputs: [
        {
            name: "downloadAllText",
            type: "string",
            defaultValue: "Download logos"
        },
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_logos_builder_component_builderConfig = {
    component: business_resource_logos,
    config: BusinessResourceLogosBuilderConfig
};
/* harmony default export */ var business_resource_logos_builder_component = (business_resource_logos_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-messaging/business-resource-messaging.module.scss
var business_resource_messaging_module = __webpack_require__(8861);
var business_resource_messaging_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_messaging_module);
;// CONCATENATED MODULE: ./components/business-resource-messaging/business-resource-messaging.tsx







const BusinessResourceMessaging = (props)=>{
    const { content  } = props;
    const [isCopied, setIsCopied] = (0,react.useState)(false);
    const [plainText, setPlainText] = (0,react.useState)("");
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    (0,react.useEffect)(()=>{
        const tempDivElement = document.createElement("div");
        tempDivElement.innerHTML = content;
        setPlainText(tempDivElement.textContent || tempDivElement.innerText || "");
    }, [
        content
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        text: plainText,
        onCopy: ()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_messaging_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    ref: setPopperElement,
                    className: classnames_default()((business_resource_messaging_module_default()).tooltip, {
                        [(business_resource_messaging_module_default()).visible]: isCopied
                    }),
                    style: popperStyles.popper,
                    ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
                    children: [
                        "Copied!",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: setArrowElement,
                            className: (business_resource_messaging_module_default()).tooltipArrow,
                            style: popperStyles.arrow
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: setReferenceElement,
                    className: (business_resource_messaging_module_default()).copyIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Copy */.T.Copy
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_resource_messaging = (BusinessResourceMessaging);

;// CONCATENATED MODULE: ./components/business-resource-messaging/business-resource-messaging.builder-component.ts

const BusinessResourceMessagingBuilderConfig = {
    name: "Resource Messaging",
    inputs: [
        {
            name: "content",
            type: "richText"
        }
    ]
};
const business_resource_messaging_builder_component_builderConfig = {
    component: business_resource_messaging,
    config: BusinessResourceMessagingBuilderConfig
};
/* harmony default export */ var business_resource_messaging_builder_component = (business_resource_messaging_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-page-title/business-resource-page-title.module.scss
var business_resource_page_title_module = __webpack_require__(7739);
var business_resource_page_title_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_page_title_module);
;// CONCATENATED MODULE: ./components/business-resource-page-title/business-resource-page-title.tsx




const BusinessResourcePageTitle = (param)=>{
    let { title , introduction , responsive  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_page_title_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_page_title_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_page_title_module_default()).introduction, {
                    [(business_resource_page_title_module_default()).responsive]: responsive
                }),
                dangerouslySetInnerHTML: {
                    __html: introduction
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_page_title = (BusinessResourcePageTitle);

;// CONCATENATED MODULE: ./components/business-resource-page-title/business-resource-page-title.builder-component.ts

const BusinessResourcePageTitleBuilderConfig = {
    name: "Resource Page Title",
    inputs: [
        {
            name: "responsive",
            type: "boolean"
        },
        {
            name: "title",
            type: "richText"
        },
        {
            name: "introduction",
            type: "richText"
        }
    ]
};
const business_resource_page_title_builder_component_builderConfig = {
    component: business_resource_page_title,
    config: BusinessResourcePageTitleBuilderConfig
};
/* harmony default export */ var business_resource_page_title_builder_component = (business_resource_page_title_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.module.scss
var business_resource_price_breakdown_module = __webpack_require__(9421);
var business_resource_price_breakdown_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_price_breakdown_module);
;// CONCATENATED MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.tsx




const BusinessResourcePriceBreakdown = (props)=>{
    const { priceText , position  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_price_breakdown_module_default()).container, {
            [(business_resource_price_breakdown_module_default()).reversed]: position === "right"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_price_breakdown_module_default()).priceText,
                children: priceText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_price_breakdown_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.AfterpayBadge */.T.AfterpayBadge
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_price_breakdown = (BusinessResourcePriceBreakdown);

;// CONCATENATED MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.builder-component.ts

const BusinessResourcePriceBreakdownBuilderConfig = {
    name: "Resource Price Breakdown",
    inputs: [
        {
            name: "priceText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "position",
            type: "string",
            defaultValue: "left",
            enum: [
                "left",
                "right"
            ]
        }
    ]
};
const business_resource_price_breakdown_builder_component_builderConfig = {
    component: business_resource_price_breakdown,
    config: BusinessResourcePriceBreakdownBuilderConfig
};
/* harmony default export */ var business_resource_price_breakdown_builder_component = (business_resource_price_breakdown_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-related/business-resource-related-item/business-resource-related-item.module.scss
var business_resource_related_item_module = __webpack_require__(7663);
var business_resource_related_item_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_related_item_module);
;// CONCATENATED MODULE: ./components/business-resource-related/business-resource-related-item/business-image-grid-slider-item.tsx





const ImageGridSliderItem = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { image , title  } = props;
    let url = (0,LangHelper/* replaceOrAddLocale */.yM)(props.url, locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_related_item_module_default()).businessResourceRelatedItemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_related_item_module_default()).businessResourceRelatedItemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_related_item_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_related_item_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_related_item_module_default()).businessResourceRelatedItemContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_related_item_module_default()).contentTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_related_item_module_default()).contentCTA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Read more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightSmall */.T.ArrowRightSmall
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_image_grid_slider_item = (ImageGridSliderItem);

// EXTERNAL MODULE: ./components/business-resource-related/business-image-grid-slider.module.scss
var business_image_grid_slider_module = __webpack_require__(8068);
var business_image_grid_slider_module_default = /*#__PURE__*/__webpack_require__.n(business_image_grid_slider_module);
;// CONCATENATED MODULE: ./components/business-resource-related/business-image-grid-slider.tsx









core_class/* default.use */.Z.use([
    lazy/* default */.Z,
    navigation/* default */.Z
]);
const ImageGridSlider = (props)=>{
    const { title , description , list  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_image_grid_slider_module_default()).businessResourceRelatedContainer,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedDescription,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedCarousel,
                children: [
                    !!(list === null || list === void 0 ? void 0 : list.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: nextRef,
                                className: (business_image_grid_slider_module_default()).carouselButtonNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: prevRef,
                                className: (business_image_grid_slider_module_default()).carouselButtonPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                        navigation: {
                            prevEl: prevRef.current ? prevRef.current : undefined,
                            nextEl: nextRef.current ? nextRef.current : undefined
                        },
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: 4,
                        breakpoints: {
                            768: {
                                spaceBetween: 24
                            }
                        },
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 1
                        },
                        updateOnWindowResize: true,
                        draggable: true,
                        grabCursor: true,
                        onSwiper: (sw)=>{
                            setSwiper(sw);
                        },
                        init: false,
                        children: list === null || list === void 0 ? void 0 : list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_image_grid_slider_item, {
                                    ...item
                                })
                            }, "".concat(index)))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_image_grid_slider = (ImageGridSlider);

;// CONCATENATED MODULE: ./components/business-resource-related/business-image-grid-slider.builder-component.ts

const ImageGridSliderBuilderConfig = {
    name: "Grid Image Slider With Link",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "",
            required: true
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "image",
                    type: "file",
                    required: true
                },
                {
                    name: "title",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "url",
                    type: "url",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_image_grid_slider_builder_component_builderConfig = {
    component: business_image_grid_slider,
    config: ImageGridSliderBuilderConfig
};
/* harmony default export */ var business_image_grid_slider_builder_component = (business_image_grid_slider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-super-text/business-resource-super-text.module.scss
var business_resource_super_text_module = __webpack_require__(7417);
var business_resource_super_text_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_super_text_module);
;// CONCATENATED MODULE: ./components/business-resource-super-text/business-resource-super-text.tsx



const BusinessResourceSuperText = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_super_text_module_default()).root,
        children: text
    });
};
/* harmony default export */ var business_resource_super_text = (BusinessResourceSuperText);

;// CONCATENATED MODULE: ./components/business-resource-super-text/business-resource-super-text.builder-component.ts

const BusinessResourceTextHighlightBuilderConfig = {
    name: "Resource Super Text",
    inputs: [
        {
            name: "text",
            type: "string"
        }
    ]
};
const business_resource_super_text_builder_component_builderConfig = {
    component: business_resource_super_text,
    config: BusinessResourceTextHighlightBuilderConfig
};
/* harmony default export */ var business_resource_super_text_builder_component = (business_resource_super_text_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.module.scss
var business_resource_text_highlight_module = __webpack_require__(6690);
var business_resource_text_highlight_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_highlight_module);
;// CONCATENATED MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.tsx




const BusinessResourceTextHighlight = (param)=>{
    let { headline , text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_text_highlight_module_default()).root),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_highlight_module_default()).headline,
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_highlight_module_default()).text,
                children: text
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_highlight = (BusinessResourceTextHighlight);

;// CONCATENATED MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.builder-component.ts

const business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig = {
    name: "Resource Text Highlight",
    inputs: [
        {
            name: "headline",
            type: "string",
            defaultValue: ""
        },
        {
            name: "text",
            type: "string",
            defaultValue: ""
        }
    ]
};
const business_resource_text_highlight_builder_component_builderConfig = {
    component: business_resource_text_highlight,
    config: business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig
};
/* harmony default export */ var business_resource_text_highlight_builder_component = (business_resource_text_highlight_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-list/business-resource-text-list.module.scss
var business_resource_text_list_module = __webpack_require__(6503);
var business_resource_text_list_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_list_module);
;// CONCATENATED MODULE: ./components/business-resource-text-list/business-resource-text-list.tsx


const BusinessResourceTextList = (props)=>{
    const { title , items  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_text_list_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_list_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_list_module_default()).items,
                children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_text_list_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_text_list_module_default()).number,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_text_list_module_default()).content,
                                dangerouslySetInnerHTML: {
                                    __html: item.content
                                }
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_list = (BusinessResourceTextList);

;// CONCATENATED MODULE: ./components/business-resource-text-list/business-resource-text-list.builder-component.ts

const BusinessResourceTextListBuilderConfig = {
    name: "Resource Text List",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "content",
                    type: "richText"
                }
            ]
        }
    ]
};
const business_resource_text_list_builder_component_builderConfig = {
    component: business_resource_text_list,
    config: BusinessResourceTextListBuilderConfig
};
/* harmony default export */ var business_resource_text_list_builder_component = (business_resource_text_list_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.builder-component.ts

const BusinessResourceTextWrapBuilderConfig = {
    name: "Resource Text Wrap",
    inputs: [
        {
            name: "caption",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "content",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "row",
            type: "boolean",
            defaultValue: false
        }
    ]
};
const business_resource_text_wrap_builder_component_builderConfig = {
    component: business_resource_text_wrap,
    config: BusinessResourceTextWrapBuilderConfig
};
/* harmony default export */ var business_resource_text_wrap_builder_component = (business_resource_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-top-strips/business-resource-top-strips.module.scss
var business_resource_top_strips_module = __webpack_require__(877);
var business_resource_top_strips_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_top_strips_module);
;// CONCATENATED MODULE: ./components/business-resource-top-strips/business-resource-top-strips.tsx






const BusinessResourceTopStrips = (param)=>{
    let { assets =[]  } = param;
    var ref, ref1;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((assets === null || assets === void 0 ? void 0 : assets[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_top_strips_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: assets,
                rootContainerName: "top-strips",
                children: [
                    "Download All Strips ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_top_strips_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_top_strips_module_default()).leftBlock,
                        children: assets.map((asset, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                                clickable: true,
                                asset: asset,
                                onClick: (asset)=>setSelectedAsset(asset)
                            }, index);
                        })
                    }),
                    selectedAsset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_top_strips_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (business_resource_top_strips_module_default()).image,
                            src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref = selectedAsset.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.pagePreviewImage,
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_top_strips = (BusinessResourceTopStrips);

;// CONCATENATED MODULE: ./components/business-resource-top-strips/business-resource-top-strips.builder-component.ts

const BusinessResourceTopStripsBuilderConfig = {
    name: "Resource Top Strips",
    inputs: [
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "pagePreviewImage",
                            type: "file"
                        },
                        {
                            name: "extension",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_top_strips_builder_component_builderConfig = {
    component: business_resource_top_strips,
    config: BusinessResourceTopStripsBuilderConfig
};
/* harmony default export */ var business_resource_top_strips_builder_component = (business_resource_top_strips_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-training-block/business-resource-training-block-item/business-resource-training-block-item.module.scss
var business_resource_training_block_item_module = __webpack_require__(5288);
var business_resource_training_block_item_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_training_block_item_module);
;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block-item/business-resource-training-block-item.tsx




const ResourceTraningBlockItem = (props)=>{
    const { title , description , image , ctaText , ctaIcon , url , openLinkInNewTab  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_training_block_item_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).contentTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).contentDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_training_block_item_module_default()).contentCTA,
                        rel: "noreferrer",
                        target: openLinkInNewTab ? "_blank" : "_self",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaText !== null && ctaText !== void 0 ? ctaText : "Download"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.Download */.T.Download
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_training_block_item = (ResourceTraningBlockItem);

// EXTERNAL MODULE: ./components/business-resource-training-block/business-resource-training-block.module.scss
var business_resource_training_block_module = __webpack_require__(689);
var business_resource_training_block_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_training_block_module);
;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block.tsx




const ResourceTraningBlock = (props)=>{
    const { title , description , list  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_training_block_module_default()).businessResourceTrainingBlockContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockDescription,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockItems,
                children: list === null || list === void 0 ? void 0 : list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_training_block_item, {
                        ...item
                    }, "".concat(index)))
            })
        ]
    });
};
/* harmony default export */ var business_resource_training_block = (ResourceTraningBlock);

;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block.builder-component.ts


const ResourceTrainingBlockBuilderConfig = {
    name: "Resource Training Block",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "",
            required: true
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: "",
                    required: true
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                },
                {
                    name: "ctaText",
                    type: "text"
                },
                {
                    name: "ctaIcon",
                    type: "text",
                    enum: [
                        icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                        icons/* IconType.Download */.T.Download
                    ],
                    default: icons/* IconType.Download */.T.Download
                },
                {
                    name: "url",
                    type: "url",
                    defaultValue: ""
                },
                {
                    name: "openLinkInNewTab",
                    type: "boolean",
                    defaultValue: true
                }
            ]
        }
    ]
};
const business_resource_training_block_builder_component_builderConfig = {
    component: business_resource_training_block,
    config: ResourceTrainingBlockBuilderConfig
};
/* harmony default export */ var business_resource_training_block_builder_component = (business_resource_training_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-typography-review/business-resource-typography-review.module.scss
var business_resource_typography_review_module = __webpack_require__(2618);
var business_resource_typography_review_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_typography_review_module);
// EXTERNAL MODULE: ./components/business-resource-typography-review/typography-review-card/typography-review-card.module.scss
var typography_review_card_module = __webpack_require__(6082);
var typography_review_card_module_default = /*#__PURE__*/__webpack_require__.n(typography_review_card_module);
;// CONCATENATED MODULE: ./components/business-resource-typography-review/typography-review-card/typography-review-card.tsx







const TypographyReviewCard = (props)=>{
    const { name , fontWeight ="light" , fontStyle ="normal" , downloadInfo , showDownloadButton =true  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const onClick = async (variant)=>{
        setLoading(true);
        try {
            const name = "afterpay-fonts";
            let asset = {
                name,
                variants: variant === "ALL" ? downloadInfo : [
                    variant
                ]
            };
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    const fontClasses = classnames_default()((typography_review_card_module_default())["font-".concat(fontWeight)], (typography_review_card_module_default())["font-".concat(fontStyle)]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (typography_review_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (typography_review_card_module_default()).headline,
                children: [
                    showDownloadButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                        disabled: loading,
                        onVariantClick: onClick,
                        type: "icon",
                        item: {
                            variants: downloadInfo || []
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: fontClasses,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((typography_review_card_module_default()).preview, fontClasses),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (typography_review_card_module_default()).left,
                        children: "AaBb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (typography_review_card_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "abcdefghijklmnopqrstuvwxyz"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "0123456789 {[(&)]}*,.:;\xbf\xa1?!/|\\•\xb6@\xae\xa9TM"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "$\xa2\xa3\xa5€\xa7#%‰"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var typography_review_card = (TypographyReviewCard);

;// CONCATENATED MODULE: ./components/business-resource-typography-review/business-resource-typography-review.tsx








const BusinessResourceTypographyReview = (props)=>{
    const { fonts , showDownloadButton =true  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const variants = [];
    fonts.forEach((font)=>{
        if (Array.isArray(font.downloadInfo)) {
            variants.push(...font.downloadInfo);
        }
    });
    const onDownload = async (variant)=>{
        setLoading(true);
        try {
            const name = "afterpay-fonts";
            let asset = {
                name,
                variants: variant === "ALL" ? variants : [
                    variant
                ]
            };
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_typography_review_module_default()).container,
        children: [
            showDownloadButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_typography_review_module_default()).downloadButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                    disabled: loading,
                    item: {
                        variants
                    },
                    onVariantClick: onDownload,
                    allOption: false,
                    children: [
                        "Download Typeface Familly ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    ]
                })
            }),
            fonts === null || fonts === void 0 ? void 0 : fonts.map((font, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_review_card, {
                            ...font,
                            showDownloadButton: showDownloadButton
                        }),
                        index !== fonts.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var business_resource_typography_review = (BusinessResourceTypographyReview);

;// CONCATENATED MODULE: ./components/business-resource-typography-review/business-resource-typography-review.builder-component.ts

const BusinessResourceTypographyReviewBuilderConfig = {
    name: "Resource Typography Review",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "fonts",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "fontWeight",
                    type: "string",
                    defaultValue: "light",
                    enum: [
                        "light",
                        "regular",
                        "demibold",
                        "bold"
                    ]
                },
                {
                    name: "fontStyle",
                    type: "string",
                    defaultValue: "normal",
                    enum: [
                        "normal",
                        "italic"
                    ]
                },
                {
                    name: "downloadInfo",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "downloadUrl",
                            type: "url",
                            required: true
                        },
                        {
                            name: "extension",
                            type: "string",
                            required: true
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_typography_review_builder_component_builderConfig = {
    component: business_resource_typography_review,
    config: BusinessResourceTypographyReviewBuilderConfig
};
/* harmony default export */ var business_resource_typography_review_builder_component = (business_resource_typography_review_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-value-block/business-resource-value-block.module.scss
var business_resource_value_block_module = __webpack_require__(9689);
var business_resource_value_block_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_value_block_module);
;// CONCATENATED MODULE: ./components/business-resource-value-block/business-resource-value-block.tsx


const BusinessResourceValueBlock = (props)=>{
    const { title , items  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_value_block_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_value_block_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_value_block_module_default()).items,
                children: items === null || items === void 0 ? void 0 : items.map((item)=>{
                    const { title , description , image  } = item;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_value_block_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).backgroundWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_resource_value_block_module_default()).backgroundBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_resource_value_block_module_default()).background,
                                        style: {
                                            backgroundImage: "url(".concat(image, ")")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemMask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemDescription,
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            })
                        ]
                    }, "item_".concat(title || Math.random()));
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_value_block = (BusinessResourceValueBlock);

;// CONCATENATED MODULE: ./components/business-resource-value-block/business-resource-value-block.builder-component.ts

const BusinessResourceValueBlockBuilderConfig = {
    name: "Resource Value Block",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "items",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: "",
                    required: true
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_value_block_builder_component_builderConfig = {
    component: business_resource_value_block,
    config: BusinessResourceValueBlockBuilderConfig
};
/* harmony default export */ var business_resource_value_block_builder_component = (business_resource_value_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(8771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/video-card-selected/video-card-selected.module.scss
var video_card_selected_module = __webpack_require__(6833);
var video_card_selected_module_default = /*#__PURE__*/__webpack_require__.n(video_card_selected_module);
;// CONCATENATED MODULE: ./components/video-card-selected/video-card-selected.tsx
/* eslint-disable @next/next/no-img-element */ 






const VideoCardSelected = (props)=>{
    const { video  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        345
    ] : [
        720,
        638
    ];
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_selected_module_default()).videoWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_selected_module_default()).videoWrapButtonPlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.Triangle */.T.Triangle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                ratio: ratioImage,
                src: (ref = video === null || video === void 0 ? void 0 : video.leadImage) !== null && ref !== void 0 ? ref : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_selected_module_default()).videoOverlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_selected_module_default()).videoContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (video_card_selected_module_default()).videoItemImageBrand,
                        src: (ref1 = video === null || video === void 0 ? void 0 : video.imageBrandUrl) !== null && ref1 !== void 0 ? ref1 : "",
                        alt: "",
                        priority: false,
                        loading: "lazy",
                        width: 160,
                        height: 32,
                        fill: false,
                        style: {
                            objectFit: "scale-down",
                            objectPosition: "left"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (video_card_selected_module_default()).videoContainerTitle,
                        children: video === null || video === void 0 ? void 0 : video.title
                    }),
                    (video === null || video === void 0 ? void 0 : video.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (video_card_selected_module_default()).videoContainerDescription,
                        children: video === null || video === void 0 ? void 0 : video.description
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (video_card_selected_module_default()).videoContainerWatchNow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Watch Now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: video === null || video === void 0 ? void 0 : video.videoUrl,
                className: (video_card_selected_module_default()).videoLink
            })
        ]
    });
};
/* harmony default export */ var video_card_selected = (VideoCardSelected);

// EXTERNAL MODULE: ./components/business-resource-video-list/business-resource-video-list.module.scss
var business_resource_video_list_module = __webpack_require__(4734);
var business_resource_video_list_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_video_list_module);
;// CONCATENATED MODULE: ./components/business-resource-video-list/business-resource-video-list.tsx






const BusinessResourceVideoList = (props)=>{
    const { videoList , watchAllUrl , description , title , ctaText  } = props;
    const [videoSelected, setVideoSelected] = (0,react.useState)(videoList === null || videoList === void 0 ? void 0 : videoList[0]);
    (0,react.useEffect)(()=>{
        if (videoList && (videoList === null || videoList === void 0 ? void 0 : videoList.length) > 0) {
            setVideoSelected(videoList[0]);
        }
    }, [
        videoList
    ]);
    if (!videoList || (videoList === null || videoList === void 0 ? void 0 : videoList.length) === 0) {
        return null;
    }
    const renderVideoItem = (video)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_video_list_module_default()).videoItem,
            onMouseEnter: ()=>setVideoSelected(video),
            onClick: ()=>setVideoSelected(video),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (business_resource_video_list_module_default()).videoItemImageBrand,
                    src: video.imageBrandUrl,
                    alt: "",
                    priority: false,
                    loading: "lazy",
                    width: 160,
                    height: 32,
                    fill: false,
                    style: {
                        objectFit: "scale-down",
                        objectPosition: "left"
                    },
                    loader: (param)=>{
                        let { src , width , quality  } = param;
                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_resource_video_list_module_default()).videoItemContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_resource_video_list_module_default()).videoItemTitle,
                            children: video.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: video.videoUrl,
                    className: (business_resource_video_list_module_default()).videoItemLink
                })
            ]
        }, "video_item_".concat(video.leadImage));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_video_list_module_default()).videoList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_video_list_module_default()).videoListHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (business_resource_video_list_module_default()).videoListHeaderText,
                                children: title
                            }),
                            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (business_resource_video_list_module_default()).videoListDescriptionText,
                                children: description
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_video_list_module_default()).videoListHeaderTextWatchAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_video_list_module_default()).businessButtonText,
                                children: ctaText !== null && ctaText !== void 0 ? ctaText : "Learn More"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: watchAllUrl,
                                className: (business_resource_video_list_module_default()).linkWatchAllVideo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_video_list_module_default()).videoBlock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_selected, {
                    video: videoSelected
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_video_list_module_default()).videoListContainer,
                children: videoList === null || videoList === void 0 ? void 0 : videoList.map((video)=>renderVideoItem(video))
            })
        ]
    });
};
/* harmony default export */ var business_resource_video_list = (BusinessResourceVideoList);

;// CONCATENATED MODULE: ./components/business-resource-video-list/business-resource-video-list.builder-component.ts

const BusinessVideoListBuilderConfig = {
    name: "Video List",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Make it your Way"
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: "Learn More"
        },
        {
            name: "videoList",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "leadImage",
                    type: "file"
                },
                {
                    name: "imageBrandUrl",
                    type: "file"
                },
                {
                    name: "videoUrl",
                    type: "string"
                }
            ]
        },
        {
            name: "watchAllUrl",
            type: "string"
        }
    ]
};
const business_resource_video_list_builder_component_builderConfig = {
    component: business_resource_video_list,
    config: BusinessVideoListBuilderConfig
};
/* harmony default export */ var business_resource_video_list_builder_component = (business_resource_video_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-text-caption/business-text-caption.module.scss
var business_text_caption_module = __webpack_require__(3633);
var business_text_caption_module_default = /*#__PURE__*/__webpack_require__.n(business_text_caption_module);
;// CONCATENATED MODULE: ./components/business-text-caption/business-text-caption.tsx



const BusinessTextCaption = (props)=>{
    const { text  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_text_caption_module_default()).businessTextCaptionContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_text_caption_module_default()).businessTextCaption,
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_text_caption = (BusinessTextCaption);

;// CONCATENATED MODULE: ./components/business-text-caption/business-text-caption.builder-component.ts

const BusinessTextWrapBuilderConfig = {
    name: "Text Caption",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        }
    ]
};
const business_text_caption_builder_component_builderConfig = {
    component: business_text_caption,
    config: BusinessTextWrapBuilderConfig
};
/* harmony default export */ var business_text_caption_builder_component = (business_text_caption_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-text-wrap/business-text-wrap.module.scss
var business_text_wrap_module = __webpack_require__(6151);
var business_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_text_wrap_module);
;// CONCATENATED MODULE: ./components/business-text-wrap/business-text-wrap.tsx





const BusinessTextWrap = (props)=>{
    const { text  } = props;
    const defaultLayoutContext = (0,react.useContext)(DefaultLayoutContext/* DefaultLayoutContext */.V);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_text_wrap_module_default()).businessTextWrapContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((business_text_wrap_module_default()).businessTextWrap, (business_text_wrap_module_default())[defaultLayoutContext.type || ""]),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_text_wrap = (BusinessTextWrap);

;// CONCATENATED MODULE: ./components/business-text-wrap/business-text-wrap.builder-component.ts

const business_text_wrap_builder_component_BusinessTextWrapBuilderConfig = {
    name: "Text Wrap",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        }
    ]
};
const business_text_wrap_builder_component_builderConfig = {
    component: business_text_wrap,
    config: business_text_wrap_builder_component_BusinessTextWrapBuilderConfig
};
/* harmony default export */ var business_text_wrap_builder_component = (business_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-trending-topics/business-treding-topic-item/business-trending-topic-item.module.scss
var business_trending_topic_item_module = __webpack_require__(8790);
var business_trending_topic_item_module_default = /*#__PURE__*/__webpack_require__.n(business_trending_topic_item_module);
;// CONCATENATED MODULE: ./components/business-trending-topics/business-treding-topic-item/business-trending-topic-item.tsx





const BusinessTrendingTopicItem = (param)=>{
    let { category  } = param;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { image , name  } = category;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(category.categoryUrl), locale),
        className: (business_trending_topic_item_module_default()).businessTrendingTopicsItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topic_item_module_default()).itemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: image !== null && image !== void 0 ? image : "",
                    ratio: [
                        200,
                        200
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topic_item_module_default()).itemDescription,
                children: name
            })
        ]
    });
};
/* harmony default export */ var business_trending_topic_item = (BusinessTrendingTopicItem);

// EXTERNAL MODULE: ./components/business-trending-topics/business-trending-topics.module.scss
var business_trending_topics_module = __webpack_require__(4753);
var business_trending_topics_module_default = /*#__PURE__*/__webpack_require__.n(business_trending_topics_module);
;// CONCATENATED MODULE: ./components/business-trending-topics/business-trending-topics.tsx









core_class/* default.use */.Z.use([
    lazy/* default */.Z,
    navigation/* default */.Z
]);
const BusinessTrendingTopics = (props)=>{
    var _categoryData;
    const [categories, setCategories] = (0,react.useState)((_categoryData = props.categoryData) !== null && _categoryData !== void 0 ? _categoryData : []);
    const { title , description  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_trending_topics_module_default()).businessTrendingTopicsWrapper,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsDescription,
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsCarousel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: nextRef,
                        className: (business_trending_topics_module_default()).carouselButtonNext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: prevRef,
                        className: (business_trending_topics_module_default()).carouselButtonPrev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                        grabCursor: true,
                        navigation: {
                            prevEl: prevRef.current ? prevRef.current : undefined,
                            nextEl: nextRef.current ? nextRef.current : undefined
                        },
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: 4,
                        breakpoints: {
                            768: {
                                spaceBetween: 24
                            },
                            1440: {
                                spaceBetween: 24
                            }
                        },
                        centeredSlides: false,
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 1
                        },
                        updateOnWindowResize: true,
                        onSwiper: (sw)=>{
                            setSwiper(sw);
                        },
                        children: categories.map((category, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                className: (business_trending_topics_module_default()).relatedArticleSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_trending_topic_item, {
                                    category: category
                                })
                            }, "".concat(index, "_").concat(category.categorySlug));
                        })
                    }, title)
                ]
            })
        ]
    });
};
/* harmony default export */ var business_trending_topics = (BusinessTrendingTopics);

;// CONCATENATED MODULE: ./components/business-trending-topics/business-trending-topics.builder-component.ts

const business_trending_topics_builder_component_BusinessTrendingTopicsBuilderConfig = {
    name: "Trending topics",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "string",
            required: true
        },
        {
            name: "categories",
            type: "list",
            required: true,
            subFields: [
                {
                    name: "categoryId",
                    type: "string"
                }
            ]
        }
    ]
};
const business_trending_topics_builder_component_builderConfig = {
    component: business_trending_topics,
    config: business_trending_topics_builder_component_BusinessTrendingTopicsBuilderConfig
};
/* harmony default export */ var business_trending_topics_builder_component = (business_trending_topics_builder_component_builderConfig);

// EXTERNAL MODULE: ./types/Media.ts
var Media = __webpack_require__(9289);
// EXTERNAL MODULE: ./components/business-vimeo-embed/business-vimeo-embed.tsx
var business_vimeo_embed = __webpack_require__(8096);
;// CONCATENATED MODULE: ./components/business-vimeo-embed/business-vimeo-embed-wrap.builder-component.ts


const BusinessVimeoEmbedWrapBuilderConfig = {
    name: "Vimeo Embed",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "ratio",
            type: "string",
            enum: Object.keys(Media/* MEDIA_RATIO */.r),
            defaultValue: Object.keys(Media/* MEDIA_RATIO */.r)[0]
        },
        {
            name: "controls",
            type: "boolean"
        },
        {
            name: "backgroundTransform",
            type: "boolean",
            required: true
        },
        {
            name: "containerMaxWidth",
            type: "string"
        },
        {
            name: "isHero",
            type: "boolean"
        }
    ]
};
const business_vimeo_embed_wrap_builder_component_builderConfig = {
    component: business_vimeo_embed/* default */.Z,
    config: BusinessVimeoEmbedWrapBuilderConfig
};
/* harmony default export */ var business_vimeo_embed_wrap_builder_component = (business_vimeo_embed_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-youtube-embed/business-youtube-embed.module.scss
var business_youtube_embed_module = __webpack_require__(6242);
var business_youtube_embed_module_default = /*#__PURE__*/__webpack_require__.n(business_youtube_embed_module);
;// CONCATENATED MODULE: ./components/business-youtube-embed/business-youtube-embed.tsx




const BusinessYoutubeEmbed = (props)=>{
    const { videoUrl , ratio ="1:1"  } = props;
    const renderVidPlayer = ()=>{
        const [width, height] = Media/* MEDIA_RATIO */.r[ratio];
        const youtubeVideoPaddingTop = height / width * 100;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_youtube_embed_module_default()).youtubeVideo,
            style: {
                paddingTop: "".concat(youtubeVideoPaddingTop, "%")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                width: "872",
                height: "872",
                src: videoUrl,
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_youtube_embed_module_default()).businessYoutubeEmbedContainer,
        children: renderVidPlayer()
    });
};
/* harmony default export */ var business_youtube_embed = (BusinessYoutubeEmbed);

;// CONCATENATED MODULE: ./components/business-youtube-embed/business-youtube-embed.builder-component.ts


const BusinessYoutubeEmbedWrapBuilderConfig = {
    name: "Youtube Embed",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "ratio",
            type: "string",
            enum: Object.keys(Media/* MEDIA_RATIO */.r),
            defaultValue: Object.keys(Media/* MEDIA_RATIO */.r)[0]
        }
    ]
};
const business_youtube_embed_builder_component_builderConfig = {
    component: business_youtube_embed,
    config: BusinessYoutubeEmbedWrapBuilderConfig
};
/* harmony default export */ var business_youtube_embed_builder_component = (business_youtube_embed_builder_component_builderConfig);

// EXTERNAL MODULE: ./hook/useBackgroundTransform.ts
var useBackgroundTransform = __webpack_require__(2479);
// EXTERNAL MODULE: ./components/bussines-video-player/business-video-player.module.scss
var business_video_player_module = __webpack_require__(1635);
var business_video_player_module_default = /*#__PURE__*/__webpack_require__.n(business_video_player_module);
;// CONCATENATED MODULE: ./components/bussines-video-player/business-video-player.tsx






const VideoPLayer = (param)=>{
    let { src , className , onClick =()=>{} , loop =false , controls =false , muted =true , backgroundTransform =false  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const [isPlayVideo, setPlayVideo] = (0,react.useState)(true);
    const refVideo = (0,react.useRef)(null);
    const elemRef = (0,react.useRef)(null);
    (0,useBackgroundTransform/* useBackgroundTransform */.L)(elemRef);
    const [isShowVideoControls, setShowVideoControls] = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 768;
    (0,react.useEffect)(()=>{
        window.addEventListener("focus", onFocusTab);
        window.addEventListener("blur", onLeaveTab);
        return ()=>{
            window.removeEventListener("focus", onFocusTab);
            window.removeEventListener("blur", onLeaveTab);
        };
    }, []);
    const handleLoadStart = ()=>{
        setLoading(true);
    };
    const handleCanPlay = ()=>{
        setLoading(false);
    };
    const togglePlayVideo = ()=>{
        var ref;
        if (refVideo === null || refVideo === void 0 ? void 0 : (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.paused) {
            var ref1;
            setPlayVideo(true);
            refVideo === null || refVideo === void 0 ? void 0 : (ref1 = refVideo.current) === null || ref1 === void 0 ? void 0 : ref1.play();
        } else {
            var ref2;
            setPlayVideo(false);
            refVideo === null || refVideo === void 0 ? void 0 : (ref2 = refVideo.current) === null || ref2 === void 0 ? void 0 : ref2.pause();
        }
    };
    const onFocusTab = ()=>{
        var ref;
        setPlayVideo(false);
        (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.pause();
    };
    const onLeaveTab = ()=>{
        var ref;
        setPlayVideo(false);
        (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.pause();
    };
    const renderPlayPauseBtn = ()=>{
        if (isPlayVideo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default()).buttonPlay
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default()).buttonPause
            });
        }
    };
    const toggleMuteVideo = ()=>{
        var ref;
        if (refVideo === null || refVideo === void 0 ? void 0 : (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.muted) {
            refVideo.current.muted = false;
        } else {
            var ref1;
            var ref2;
            (ref2 = (ref1 = refVideo.current) === null || ref1 === void 0 ? void 0 : ref1.muted) !== null && ref2 !== void 0 ? ref2 : true;
        }
    };
    const classNameVideoPlayer = classnames_default()((business_video_player_module_default())["c-video-container"], loading && (business_video_player_module_default())["c-video-loading"], className);
    const classNameVideoControl = classnames_default()((business_video_player_module_default())["video-controls"], !isPlayVideo || isShowVideoControls ? (business_video_player_module_default()).show : (business_video_player_module_default()).hide);
    const classNameOverlay = classnames_default()((business_video_player_module_default()).controlOverLay, !isPlayVideo || isShowVideoControls ? (business_video_player_module_default()).show : (business_video_player_module_default()).hide);
    const handleClickVideoM = ()=>{
        if (isMobile) {
            setShowVideoControls(true);
            setTimeout(()=>{
                setShowVideoControls(false);
            }, 2000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: backgroundTransform ? elemRef : null,
        className: classNameVideoPlayer,
        onClick: handleClickVideoM,
        onMouseEnter: ()=>setShowVideoControls(true),
        onMouseLeave: ()=>setShowVideoControls(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: refVideo,
                onLoadStart: handleLoadStart,
                onCanPlay: handleCanPlay,
                onClick: onClick,
                className: (business_video_player_module_default())["c-video"],
                loop: loop,
                autoPlay: false,
                muted: muted,
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                })
            }),
            controls && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classNameVideoControl,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: togglePlayVideo,
                                className: classnames_default()((business_video_player_module_default())["video-controls__btnPlayPause"], {
                                    [(business_video_player_module_default()).play]: isPlayVideo,
                                    [(business_video_player_module_default()).pause]: !isPlayVideo
                                }),
                                children: renderPlayPauseBtn()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_video_player_module_default())["video-controls__btnMuted"],
                                onClick: toggleMuteVideo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classNameOverlay
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default())["c-video-loader"]
            })
        ]
    });
};
/* harmony default export */ var business_video_player = (VideoPLayer);

;// CONCATENATED MODULE: ./components/bussines-video-player/business-video-player.builder-component.ts

const BusinessVideoPlayerWrapBuilderConfig = {
    name: "Video Player",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "controls",
            type: "boolean"
        },
        {
            name: "loop",
            type: "boolean"
        },
        {
            name: "muted",
            type: "boolean"
        },
        {
            name: "backgroundTransform",
            type: "boolean",
            required: true
        }
    ]
};
const business_video_player_builder_component_builderConfig = {
    component: business_video_player,
    config: BusinessVideoPlayerWrapBuilderConfig
};
/* harmony default export */ var business_video_player_builder_component = (business_video_player_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/categories/categories.tsx
var categories = __webpack_require__(8324);
// EXTERNAL MODULE: ./components/community-card/community-card.module.scss
var community_card_module = __webpack_require__(4997);
var community_card_module_default = /*#__PURE__*/__webpack_require__.n(community_card_module);
;// CONCATENATED MODULE: ./components/community-card/community-card.tsx









const CommunityCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { article  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        345
    ] : [
        720,
        638
    ];
    if (!article) {
        return null;
    }
    const articleUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(article.articleUrl), locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (community_card_module_default()).communityCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (community_card_module_default()).communityCardWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: article.leadImage || "",
                    ratio: ratioImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (community_card_module_default()).infoArticle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(categories/* default */.Z, {
                        categories: article.categories,
                        type: "SMALL",
                        color: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).articleTitle,
                        children: article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).articleDescription,
                        children: article.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).readMoreBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            icon: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                            buttonText: "Read more",
                            link: articleUrl,
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (community_card_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: articleUrl,
                className: (community_card_module_default()).articleUrl
            })
        ]
    });
};
/* harmony default export */ var community_card = (CommunityCard);

// EXTERNAL MODULE: ./components/category-feature/category-feature.module.scss
var category_feature_module = __webpack_require__(4474);
var category_feature_module_default = /*#__PURE__*/__webpack_require__.n(category_feature_module);
;// CONCATENATED MODULE: ./components/category-feature/category-feature.tsx








const CategoryFeature = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _categoryArticles;
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)((_categoryArticles = props.categoryArticles) !== null && _categoryArticles !== void 0 ? _categoryArticles : []);
    const [articleSelected, setArticleSelected] = (0,react.useState)(featuredArticles[0]);
    const [category, setCategory] = (0,react.useState)();
    const linkReadAll = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale) + (category === null || category === void 0 ? void 0 : category.categoryUrl), locale);
    const categoryName = category === null || category === void 0 ? void 0 : category.name;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (typeof props.category === "string") {
            (0,BuilderHelper/* getCategoryFromID */.s$)(props.category).then((foundCategory)=>{
                if (!cancelled && foundCategory) {
                    setCategory(foundCategory);
                }
            });
        } else {
            setCategory(props.category);
        }
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (category && !props.categoryArticles) {
            (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                locale,
                limit: 3,
                categoryIds: [
                    category === null || category === void 0 ? void 0 : category.id
                ]
            }).then((articles)=>{
                if (!cancelled) {
                    setFeaturedArticles(articles);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category
    ]);
    (0,react.useEffect)(()=>{
        if (!articleSelected) {
            setArticleSelected(featuredArticles[0]);
        }
    }, [
        featuredArticles
    ]);
    if (!featuredArticles || featuredArticles.length === 0) {
        return null;
    }
    const renderArticleItem = (article)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (category_feature_module_default()).articleItem,
            onMouseEnter: ()=>setArticleSelected(article),
            onClick: ()=>setArticleSelected(article),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(categories/* default */.Z, {
                    categories: article.categories,
                    type: "SMALL"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (category_feature_module_default()).articleContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_feature_module_default()).articleTitle,
                            children: article.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                        })
                    ]
                })
            ]
        }, "article_feature_".concat(article.articleUrl));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_feature_module_default()).categoryFeature,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_feature_module_default()).categoryFeatureContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (category_feature_module_default()).categoryHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (category_feature_module_default()).headerText,
                                children: categoryName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_feature_module_default()).articleCardButtonReadAll,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (category_feature_module_default()).businessButtonText,
                                        children: "Read all"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: linkReadAll,
                                        className: (category_feature_module_default()).linkReadAllArticle
                                    })
                                ]
                            })
                        ]
                    }),
                    featuredArticles === null || featuredArticles === void 0 ? void 0 : featuredArticles.map((article)=>renderArticleItem(article))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_feature_module_default()).articlesFeature,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_card, {
                    article: articleSelected
                })
            })
        ]
    });
};
/* harmony default export */ var category_feature = (CategoryFeature);

;// CONCATENATED MODULE: ./components/category-feature/category-feature.builder-component.ts

const category_feature_builder_component_CategoryFeatureBuilderConfig = {
    name: "Category Feature",
    inputs: [
        {
            name: "category",
            type: "text"
        }
    ]
};
const category_feature_builder_component_builderConfig = {
    component: category_feature,
    config: category_feature_builder_component_CategoryFeatureBuilderConfig
};
/* harmony default export */ var category_feature_builder_component = (category_feature_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/category-hero/category-hero.tsx + 1 modules
var category_hero = __webpack_require__(8816);
;// CONCATENATED MODULE: ./components/category-hero/category-hero.builder-component.ts

const CategoryHeroBuilderConfig = {
    name: "Category Hero",
    inputs: [
        {
            name: "breadcrumbs",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "categoryHeroTitle",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "categoryHeroDescription",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "backgroundColor",
            type: "string",
            defaultValue: "Orca Pastel",
            enum: [
                "Blum",
                "Orca Pastel"
            ]
        },
        {
            name: "backgroundCoverContent",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showFilter",
            type: "boolean",
            defaultValue: true
        }
    ]
};
const category_hero_builder_component_builderConfig = {
    component: category_hero/* default */.Z,
    config: CategoryHeroBuilderConfig
};
/* harmony default export */ var category_hero_builder_component = (category_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(9771);
;// CONCATENATED MODULE: ./helpers/CategoryHelper.ts

const GET_ALL_CATEGORY = "https://cdn.builder.io/api/v1/query/".concat(env/* BUILDER_API_KEY */.uT, "/category%3A3c5b3b30?omit=meta.componentsUsed&apiKey=").concat(env/* BUILDER_API_KEY */.uT, "&options.category:3c5b3b30.limit=30&options.category:3c5b3b30.query={%22data.isSeries%22:{%22$eq%22:true}}");

// EXTERNAL MODULE: ./components/learning-series-block/learning-series-block.module.scss
var learning_series_block_module = __webpack_require__(6314);
var learning_series_block_module_default = /*#__PURE__*/__webpack_require__.n(learning_series_block_module);
;// CONCATENATED MODULE: ./components/learning-series-block/learning-series-block.tsx







const LearningSeriesBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { titleSeries , descriptionSeries , viewAllText , backgroundColor ="" , category1 , category2 , category3 , viewAllUrl  } = props;
    var _seriesData;
    const [series, setSeries] = (0,react.useState)((_seriesData = props.seriesData) !== null && _seriesData !== void 0 ? _seriesData : []);
    const viewAllUrlLocale = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(viewAllUrl), locale);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!category1 && !category2 && !category3) return;
        // Don't re-fetch the category data if it's already presented
        if (props.seriesData) return;
        const categories = [
            category1 || "",
            category2 || "",
            category3 || ""
        ].filter((category)=>!!category);
        if (categories && categories.length) {
            (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categories).then((data)=>{
                if (!cancelled) {
                    setSeries(data.map((category)=>{
                        return {
                            category
                        };
                    }));
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category1,
        category2,
        category3,
        props.seriesData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (learning_series_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (learning_series_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (learning_series_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_series_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (learning_series_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (learning_series_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    viewAllUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: viewAllUrlLocale,
                        className: (learning_series_block_module_default()).btnViewAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewAllText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
                cardData: series,
                typeOfCard: "learning",
                showSignupCard: false
            })
        ]
    });
};
/* harmony default export */ var learning_series_block = (LearningSeriesBlock);

;// CONCATENATED MODULE: ./components/learning-series-block/learning-series-block.builder-component.ts


const learning_series_block_builder_component_LearningSeriesBlockPropsBuilderConfig = {
    name: "Learning series block",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category1",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category2",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category3",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "Orca Pastel"
            ]
        }
    ]
};
const learning_series_block_builder_component_builderConfig = {
    component: learning_series_block,
    config: learning_series_block_builder_component_LearningSeriesBlockPropsBuilderConfig
};
/* harmony default export */ var learning_series_block_builder_component = (learning_series_block_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.constants.ts
const numerical_highlight_list_constants_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum"
};

// EXTERNAL MODULE: ./components/numerical-highlight-list/numerical-highlight-list.module.scss
var numerical_highlight_list_module = __webpack_require__(6154);
var numerical_highlight_list_module_default = /*#__PURE__*/__webpack_require__.n(numerical_highlight_list_module);
;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.tsx




const NumericalList = (props)=>{
    const { heading , list , backgroundColor =numerical_highlight_list_constants_BACKGROUND_COLORS.MINT  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [numerical_highlight_list_constants_BACKGROUND_COLORS.MINT]: "#b2fce4",
            [numerical_highlight_list_constants_BACKGROUND_COLORS.PLUM]: "#EADDF2"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: getBackgroundColor()
        },
        className: (numerical_highlight_list_module_default()).numericalListContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (numerical_highlight_list_module_default()).numericalHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (numerical_highlight_list_module_default()).numericalList,
                children: list.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (numerical_highlight_list_module_default()).numericalItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (numerical_highlight_list_module_default()).numericalWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (numerical_highlight_list_module_default()).numericalTitle,
                                    dangerouslySetInnerHTML: {
                                        __html: item.title
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (numerical_highlight_list_module_default()).numericalDescription,
                                    dangerouslySetInnerHTML: {
                                        __html: item.description
                                    }
                                })
                            ]
                        })
                    }, item.title + "" + index);
                })
            })
        ]
    });
};
/* harmony default export */ var numerical_highlight_list = (NumericalList);

;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.builder-component.ts


const NumericalHighlightListBuilderConfig = {
    name: "Numerical Highlight List",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Heading"
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(numerical_highlight_list_constants_BACKGROUND_COLORS),
            defaultValue: numerical_highlight_list_constants_BACKGROUND_COLORS.PLUM
        }
    ]
};
const numerical_highlight_list_builder_component_builderConfig = {
    component: numerical_highlight_list,
    config: NumericalHighlightListBuilderConfig
};
/* harmony default export */ var numerical_highlight_list_builder_component = (numerical_highlight_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/series-collection-article-block/series-collection-articles-block.module.scss
var series_collection_articles_block_module = __webpack_require__(4448);
var series_collection_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(series_collection_articles_block_module);
;// CONCATENATED MODULE: ./components/series-collection-article-block/series-collection-articles-block.tsx






const SeriesCollectionArticles = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { titleSeries , descriptionSeries , viewAllText , typeOfCard , categoryObject , articles , includeLargeCard , backgroundColor =""  } = props;
    let viewAllUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(categoryObject === null || categoryObject === void 0 ? void 0 : categoryObject.categoryUrl), locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (series_collection_articles_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (series_collection_articles_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (series_collection_articles_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (series_collection_articles_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (series_collection_articles_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (series_collection_articles_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: viewAllUrl,
                        className: (series_collection_articles_block_module_default()).btnViewAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewAllText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
                cardData: articles,
                typeOfCard: typeOfCard,
                showSignupCard: false,
                includeLargeCard: includeLargeCard,
                debounce: true
            })
        ]
    });
};
/* harmony default export */ var series_collection_articles_block = (SeriesCollectionArticles);

;// CONCATENATED MODULE: ./components/series-collection-article-block/series-collection-articles-block.builder-component.ts



const series_collection_articles_block_builder_component_SeriesCollectionArticlesBuilderConfig = {
    name: "Series Collection Articles",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "typeOfCard",
            type: "string",
            defaultValue: TYPES_OF_CARD.ARTICLE,
            enum: Object.values(TYPES_OF_CARD)
        },
        {
            name: "includeLargeCard",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "Orca Pastel"
            ]
        }
    ]
};
const series_collection_articles_block_builder_component_builderConfig = {
    component: series_collection_articles_block,
    config: series_collection_articles_block_builder_component_SeriesCollectionArticlesBuilderConfig
};
/* harmony default export */ var series_collection_articles_block_builder_component = (series_collection_articles_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(2132);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/trustpilot-widget/trustpilot-widget.module.scss
var trustpilot_widget_module = __webpack_require__(3253);
var trustpilot_widget_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_widget_module);
;// CONCATENATED MODULE: ./components/trustpilot-widget/trustpilot-widget.tsx





const TRUSTPILOT_CONFIG = {
    afterpay: {
        businessunitId: "56c5d65b0000ff0005891636",
        href: "https://www.trustpilot.com/review/afterpay.com"
    },
    clearpay: {
        businessunitId: "59e8a1f50000ff0005ae12db",
        href: "https://www.trustpilot.com/review/www.clearpay.co.uk"
    }
};
const TrustpilotWidget = (param)=>{
    let { id ="afterpay"  } = param;
    const config = TRUSTPILOT_CONFIG[id];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "text/javascript",
                    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    async: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("trustpilot-widget", (trustpilot_widget_module_default())["trustpilot-widget-container"]),
                "data-locale": "en-US",
                "data-template-id": "5406e65db0d04a09e042d5fc",
                "data-businessunit-id": config.businessunitId,
                "data-style-height": "28px",
                "data-style-width": "100%",
                "data-theme": "light",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: config.href,
                    target: "_blank",
                    rel: "noopener",
                    children: "Trustpilot"
                })
            })
        ]
    });
};
/* harmony default export */ var trustpilot_widget = (TrustpilotWidget);

;// CONCATENATED MODULE: ./components/trustpilot-widget/trustpilot-widget.builder-component.ts

const TrustpilotWidgetBuilderConfig = {
    name: "Trustpilot Widget",
    inputs: [
        {
            name: "id",
            type: "string",
            defaultValue: "afterpay",
            enum: [
                "afterpay",
                "clearpay"
            ]
        }
    ]
};
const trustpilot_widget_builder_component_builderConfig = {
    component: trustpilot_widget,
    config: TrustpilotWidgetBuilderConfig
};
/* harmony default export */ var trustpilot_widget_builder_component = (trustpilot_widget_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.constants.ts
const unordered_highlight_list_constants_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum"
};

// EXTERNAL MODULE: ./components/unordered-highlight-list/unordered-highlight-list.module.scss
var unordered_highlight_list_module = __webpack_require__(715);
var unordered_highlight_list_module_default = /*#__PURE__*/__webpack_require__.n(unordered_highlight_list_module);
;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.tsx




const UnorderedHighlightList = (props)=>{
    const { heading , list , backgroundColor =unordered_highlight_list_constants_BACKGROUND_COLORS.MINT  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [unordered_highlight_list_constants_BACKGROUND_COLORS.MINT]: "#b2fce4",
            [unordered_highlight_list_constants_BACKGROUND_COLORS.PLUM]: "#EADDF2"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: getBackgroundColor()
        },
        className: (unordered_highlight_list_module_default()).unorderedHighlightListContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (unordered_highlight_list_module_default()).unorderedHighlightHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (unordered_highlight_list_module_default()).unorderedHighlightList,
                children: list.map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (unordered_highlight_list_module_default()).unorderedHighlightItem,
                        dangerouslySetInnerHTML: {
                            __html: item.content
                        }
                    }, item.content);
                })
            })
        ]
    });
};
/* harmony default export */ var unordered_highlight_list = (UnorderedHighlightList);

;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.builder-component.ts


const UnorderedHighlightListBuilderConfig = {
    name: "Unordered Highlight List",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Heading"
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "content",
                    type: "richText",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(unordered_highlight_list_constants_BACKGROUND_COLORS),
            defaultValue: unordered_highlight_list_constants_BACKGROUND_COLORS.MINT
        }
    ]
};
const unordered_highlight_list_builder_component_builderConfig = {
    component: unordered_highlight_list,
    config: UnorderedHighlightListBuilderConfig
};
/* harmony default export */ var unordered_highlight_list_builder_component = (unordered_highlight_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/video-card-section/video-card-section.module.scss
var video_card_section_module = __webpack_require__(393);
var video_card_section_module_default = /*#__PURE__*/__webpack_require__.n(video_card_section_module);
;// CONCATENATED MODULE: ./components/video-card-section/video-card-section.tsx



const VideoCardSection = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (video_card_section_module_default()).videoCardSection,
        children: children
    });
};
/* harmony default export */ var video_card_section = (VideoCardSection);

;// CONCATENATED MODULE: ./components/video-card-section/video-card-section.builder-component.ts


const VideoCardSectionWithChildren = (0,builder_react_es5/* withChildren */.u7)(video_card_section);
const VideoCardSectionBuilderConfig = {
    name: "Video Card Section"
};
const video_card_section_builder_component_builderConfig = {
    component: VideoCardSectionWithChildren,
    config: VideoCardSectionBuilderConfig
};
/* harmony default export */ var video_card_section_builder_component = (video_card_section_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-item/video-card-item.constants.ts
const VIDEO_CARD_ITEM_TYPES = {
    DISCOUNT: "discount",
    IMAGE: "image",
    QUOTE: "quote",
    IMAGE_BRAND: "imageBrand",
    CTA_BLOCK: "CTABlock"
};

// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(409);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(6130);
// EXTERNAL MODULE: ./components/video-card-list-item/video-card-item/video-card-item.module.scss
var video_card_item_module = __webpack_require__(9871);
var video_card_item_module_default = /*#__PURE__*/__webpack_require__.n(video_card_item_module);
;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-item/video-card-item.tsx
/* eslint-disable @next/next/no-img-element */ 






const VideoCardItem = (props)=>{
    const { typeOfItem , discountContent ="" , discountText ="" , imageBrandUrl ="" , imageUrl ="" , authorName ="" , quote ="" , ctaContent ="" , ctaUrl ="" , discountPercentImage =""  } = props.item;
    const { isSingleBlock  } = props;
    const { ratio =[
        256,
        256
    ]  } = props;
    switch(typeOfItem){
        case VIDEO_CARD_ITEM_TYPES.IMAGE_BRAND:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemImageBrand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrandUrl,
                    alt: ""
                })
            });
        case VIDEO_CARD_ITEM_TYPES.IMAGE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: imageUrl
                })
            });
        case VIDEO_CARD_ITEM_TYPES.QUOTE:
            let quoteClassName = classnames_default()((video_card_item_module_default()).discountCarouselItemQuote);
            if (isSingleBlock) {
                quoteClassName = classnames_default()((video_card_item_module_default()).discountCarouselItemQuote, (video_card_item_module_default()).singleBlock);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: quoteClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                        className: (video_card_item_module_default()).discountCarouselItemQuoteContent,
                        children: quote
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (video_card_item_module_default()).discountCarouselItemQuoteAuthorName,
                        children: [
                            "- ",
                            authorName
                        ]
                    })
                ]
            });
        case VIDEO_CARD_ITEM_TYPES.DISCOUNT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemDiscount,
                children: discountPercentImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: discountPercentImage,
                    className: "image-discount"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (video_card_item_module_default()).discountCarouselItemDiscountPercent,
                            children: discountContent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (video_card_item_module_default()).discountCarouselItemDiscountText,
                            children: discountText
                        })
                    ]
                })
            });
        case VIDEO_CARD_ITEM_TYPES.CTA_BLOCK:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_item_module_default()).discountCarouselItemCTABlock,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockContent,
                        children: [
                            ctaContent,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Click here"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockUrl,
                        href: ctaUrl,
                        target: "_self"
                    })
                ]
            });
        default:
            return null;
    }
};
/* harmony default export */ var video_card_item = (VideoCardItem);

// EXTERNAL MODULE: ./components/video-card-list-item/video-card-list-item.module.scss
var video_card_list_item_module = __webpack_require__(5957);
var video_card_list_item_module_default = /*#__PURE__*/__webpack_require__.n(video_card_list_item_module);
;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-list-item.tsx












const VideoCardListItem = (props)=>{
    const { items  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    const animationOption = (type)=>{
        if (type === "slider" && windowWidth < 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        if (type === "slideItem" && windowWidth > 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        return null;
    };
    const countImageInItems = (items)=>{
        const imagesItem = items.filter((item)=>item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE);
        var ref;
        const secondImage = (ref = imagesItem[1]) !== null && ref !== void 0 ? ref : null;
        const indexOfSecondImage = items.indexOf(secondImage);
        return {
            count: imagesItem.length,
            secondImageIndex: indexOfSecondImage
        };
    };
    const handleSliderItemClassName = (item, index)=>{
        let slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
        let ratio = [
            256,
            256
        ];
        let isSingleBlock = false;
        const numberOfItems = items.length;
        const imageAmount = countImageInItems(items).count;
        const secondImage = countImageInItems(items).secondImageIndex;
        if (numberOfItems % 5 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpanQuote);
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 4 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            ratio = [
                256,
                256
            ];
        }
        if (item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE && index === secondImage) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpanQuote);
            isSingleBlock = false;
        }
        return {
            slideClassName: slideClassName,
            ratio: ratio,
            isSingleBlock: isSingleBlock
        };
    };
    const renderSliderItem = (item, index)=>{
        const className = handleSliderItemClassName(item, index).slideClassName;
        const ratio = handleSliderItemClassName(item, index).ratio;
        const isSingleBlock = handleSliderItemClassName(item, index).isSingleBlock;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            className: className,
            ...animationOption("slideItem"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_item, {
                item: item,
                ratio: ratio,
                isSingleBlock: isSingleBlock
            })
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_list_item_module_default()).discountCarousel,
        ...animationOption("slider"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (video_card_list_item_module_default()).discountCarouselButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (video_card_list_item_module_default()).discountCarouselButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                className: (video_card_list_item_module_default()).discountCarouselSlider,
                grabCursor: true,
                navigation: {
                    prevEl: prevRef.current ? prevRef.current : undefined,
                    nextEl: nextRef.current ? nextRef.current : undefined
                },
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.update();
                },
                slidesPerView: "auto",
                spaceBetween: 24,
                breakpoints: {
                    320: {
                        centeredSlides: true,
                        spaceBetween: 15
                    },
                    768: {
                        spaceBetween: 24,
                        centeredSlides: false
                    }
                },
                centeredSlides: false,
                centeredSlidesBounds: true,
                watchOverflow: true,
                updateOnWindowResize: true,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                children: items.map((item, index)=>renderSliderItem(item, index))
            })
        ]
    });
};
/* harmony default export */ var video_card_list_item = (VideoCardListItem);

;// CONCATENATED MODULE: ./components/video-card/video-card.constants.ts
const VIDEO_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/video-card/video-card.module.scss
var video_card_module = __webpack_require__(6775);
var video_card_module_default = /*#__PURE__*/__webpack_require__.n(video_card_module);
;// CONCATENATED MODULE: ./components/video-card/video-card.tsx
/* eslint-disable @next/next/no-img-element */ 











const VideoCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { borderColor =DEFAULT_BACKGROUND_COLORS.MINT , leadImage , title , description , mediaPosition ="left" , ctaText , ctaIcon , imageBrand , videoCardItems , sectionId  } = props;
    var _href;
    const url = (0,LangHelper/* replaceOrAddLocale */.yM)((_href = props.href) !== null && _href !== void 0 ? _href : "", locale);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    console.log("locale", locale);
    console.log("url", url);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    const animationOption = function(type) {
        let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "300";
        const handleDataAos = (type, mediaPosition)=>{
            if (type === "media" && mediaPosition === "left") {
                return "right";
            }
            if (type === "media" && mediaPosition === "right") {
                return "left";
            }
            return mediaPosition;
        };
        return {
            "data-aos": "fade-" + handleDataAos(type, mediaPosition),
            "data-aos-delay": delay
        };
    };
    const renderMediaContent = ()=>{
        const imageRatio = windowWidth < 786 ? [
            313,
            311
        ] : [
            424,
            552
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (video_card_module_default()).mediaImageContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).mediaImageContainerButtonPlay,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Triangle */.T.Triangle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: leadImage,
                    ratio: imageRatio
                })
            ]
        });
    };
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((video_card_module_default()).videoCardMediaContainer, " ").concat((video_card_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_module_default()).videoCardMedia,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((video_card_module_default()).mediaImageWrapper, " ").concat((video_card_module_default())[mediaPosition]),
                        ...animationOption("media", "300"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (video_card_module_default()).mediaImageBox,
                            children: [
                                renderMediaContent(),
                                console.log("mediaBlock", url),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: url,
                                    target: "_self",
                                    className: (video_card_module_default()).mediaImageLink
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((video_card_module_default()).mediaBackground, " ").concat((video_card_module_default())[mediaPosition]),
                        style: {
                            borderColor: mapNameToColour(borderColor)
                        },
                        "data-aos": "fade-up",
                        "data-aos-easing": "linear",
                        "data-aos-anchor-placement": "top-center",
                        "data-aos-duration": "500"
                    })
                ]
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((video_card_module_default()).videoCardInfo, " ").concat((video_card_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrand,
                    alt: "",
                    className: (video_card_module_default()).infoImageBrand,
                    ...animationOption("info", "250")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).infoTitle,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    ...animationOption("info", "300")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).infoDescription,
                    dangerouslySetInnerHTML: {
                        __html: description
                    },
                    ...animationOption("info", "350")
                }),
                console.log("infoBlock", url),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: url,
                    target: "_self",
                    className: (video_card_module_default()).infoCTA,
                    ...animationOption("info", "350"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: ctaText !== null && ctaText !== void 0 ? ctaText : "Watch Now"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_module_default()).videoCard,
        id: sectionId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_module_default()).videoCardContainer,
                children: [
                    mediaPosition === VIDEO_POSITIONS.LEFT ? mediaBlock() : null,
                    infoBlock(),
                    mediaPosition === VIDEO_POSITIONS.RIGHT ? mediaBlock() : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_list_item, {
                items: videoCardItems
            })
        ]
    });
};
/* harmony default export */ var video_card = (VideoCard);

;// CONCATENATED MODULE: ./components/video-card/video-card.builder-component.ts





const VideoCardBuilderConfig = {
    name: "VideoCard",
    inputs: [
        {
            name: "leadImage",
            type: "file",
            defaultValue: ""
        },
        {
            name: "imageBrand",
            type: "file"
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "href",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(VIDEO_POSITIONS),
            defaultValue: VIDEO_POSITIONS.LEFT
        },
        {
            name: "videoCardItems",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "typeOfItem",
                    type: "string",
                    enum: Object.values(VIDEO_CARD_ITEM_TYPES),
                    defaultValue: VIDEO_CARD_ITEM_TYPES.DISCOUNT
                },
                {
                    name: "imageBrandUrl",
                    type: "file",
                    helperText: "Use for item type image brand"
                },
                {
                    name: "discountPercentImage",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountContent",
                    type: "string",
                    defaultValue: "+74%",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountText",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "imageUrl",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type image"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "authorName",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "ctaContent",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                },
                {
                    name: "ctaUrl",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                }
            ]
        },
        {
            name: "borderColor",
            type: "string",
            enum: Object.values(DEFAULT_BACKGROUND_COLORS),
            defaultValue: DEFAULT_BACKGROUND_COLORS.MINT
        },
        {
            name: "sectionId",
            type: "string",
            defaultValue: "",
            helperText: "This field must be the same with sectionId above the carousel Item"
        }
    ]
};
const video_card_builder_component_builderConfig = {
    component: video_card,
    config: VideoCardBuilderConfig
};
/* harmony default export */ var video_card_builder_component = (video_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/scroll-behavior-polyfill/dist/index.js
var scroll_behavior_polyfill_dist = __webpack_require__(281);
;// CONCATENATED MODULE: ./helpers/index.ts

const scrollToById = async function(id) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    if (!("scrollBehavior" in document.documentElement.style)) {
        await Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 281, 23));
    }
    const { detalY =0  } = options;
    setTimeout(()=>{
        const element = document.getElementById(id);
        if (!element) {
            return;
        }
        const y = element.getBoundingClientRect().top + window.pageYOffset + detalY;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }, delay);
};

// EXTERNAL MODULE: ./components/video-carousel/video-carousel.module.scss
var video_carousel_module = __webpack_require__(6223);
var video_carousel_module_default = /*#__PURE__*/__webpack_require__.n(video_carousel_module);
;// CONCATENATED MODULE: ./components/video-carousel/video-carousel.tsx
/* eslint-disable @next/next/no-img-element */ 









core_class/* default.use */.Z.use([
    lazy/* default */.Z,
    navigation/* default */.Z
]);
const VideoCarousel = (props)=>{
    const { videoCarouselItems , onItemChange  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    if (!videoCarouselItems || videoCarouselItems.length <= 0) {
        return null;
    }
    const spaceWhenScroll = windowWidth > 786 ? -150 : -30;
    const renderVideoCarouselItem = (item)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
            className: (video_carousel_module_default()).videoItem,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_carousel_module_default()).videoItemContainer,
                onClick: ()=>scrollToById(item.sectionId, {
                        detalY: spaceWhenScroll
                    }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: item.thumbnailUrl,
                    ratio: [
                        424,
                        424
                    ],
                    className: (video_carousel_module_default()).videoItemThumbnailUrl
                })
            })
        }, item.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_module_default()).videoCarousel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (video_carousel_module_default()).videoCarouselButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (video_carousel_module_default()).videoCarouselButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                grabCursor: true,
                navigation: {
                    prevEl: prevRef.current ? prevRef.current : undefined,
                    nextEl: nextRef.current ? nextRef.current : undefined
                },
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.update();
                },
                slidesPerView: "auto",
                spaceBetween: 24,
                breakpoints: {
                    320: {
                        centeredSlides: true,
                        spaceBetween: 15
                    },
                    768: {
                        spaceBetween: 24,
                        centeredSlides: true
                    }
                },
                onSlideChange: (swiper)=>{
                    if (onItemChange) {
                        onItemChange(swiper.realIndex);
                    }
                },
                loop: true,
                centeredSlides: true,
                watchOverflow: true,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                updateOnWindowResize: true,
                children: videoCarouselItems.map((item)=>renderVideoCarouselItem(item))
            }, "video_carousel")
        ]
    });
};
/* harmony default export */ var video_carousel = (VideoCarousel);

// EXTERNAL MODULE: ./components/video-carousel/video-carousel-quote/video-carousel-quote.module.scss
var video_carousel_quote_module = __webpack_require__(5558);
var video_carousel_quote_module_default = /*#__PURE__*/__webpack_require__.n(video_carousel_quote_module);
;// CONCATENATED MODULE: ./components/video-carousel/video-carousel-quote/video-carousel-quote-item.tsx



const VideoCarouselQuoteItem = (param)=>{
    let { quote , authorQuote  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_quote_module_default()).videoCarouselQuoteItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                className: (video_carousel_quote_module_default()).videoCarouselQuoteItemContent,
                children: quote
            }),
            authorQuote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (video_carousel_quote_module_default()).videoCarouselQuoteItemAuthorName,
                children: [
                    "- ",
                    authorQuote
                ]
            })
        ]
    });
};
/* harmony default export */ var video_carousel_quote_item = (VideoCarouselQuoteItem);

;// CONCATENATED MODULE: ./components/video-carousel/video-carousel-wrapper.tsx
/* eslint-disable @next/next/no-img-element */ 





const VideoCarouselWrapper = (props)=>{
    const { videoCarouselItems  } = props;
    const [swiper, setSwiper] = (0,react.useState)(null);
    const quotes = videoCarouselItems.map((item)=>{
        const quote = {
            quote: item.quote,
            authorQuote: item.authorQuote
        };
        return quote;
    });
    const onItemChange = (index)=>{
        swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(index, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_module_default()).videoCarouselWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_carousel, {
                videoCarouselItems: videoCarouselItems,
                onItemChange: onItemChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_carousel_module_default()).videoCarouselQuoteContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (video_carousel_module_default()).videoCarouselQuoteContainerDivider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swiper/* Swiper */.t, {
                        direction: "vertical",
                        spaceBetween: 40,
                        className: (video_carousel_module_default()).videoCarouselQuote,
                        onSwiper: setSwiper,
                        children: quotes.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_carousel_quote_item, {
                                    quote: item.quote,
                                    authorQuote: item.authorQuote
                                })
                            }, "quote_key_".concat(index)))
                    }, "video_carousel_quote")
                ]
            })
        ]
    });
};
/* harmony default export */ var video_carousel_wrapper = (VideoCarouselWrapper);

;// CONCATENATED MODULE: ./components/video-carousel/video-carousel.builder-component.ts

const VideoCarouselBuilderConfig = {
    name: "Video Carousel",
    inputs: [
        {
            name: "videoCarouselItems",
            type: "list",
            subFields: [
                {
                    name: "thumbnailUrl",
                    type: "file"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "authorQuote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "sectionId",
                    type: "string",
                    defaultValue: "",
                    helperText: "This is id for scroll to section below."
                }
            ]
        }
    ]
};
const video_carousel_builder_component_builderConfig = {
    component: video_carousel_wrapper,
    config: VideoCarouselBuilderConfig
};
/* harmony default export */ var video_carousel_builder_component = (video_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/@u-wave/react-vimeo/dist/react-vimeo.es.js
var react_vimeo_es = __webpack_require__(6804);
;// CONCATENATED MODULE: ./hook/useScroll.ts

const EmptySSRRect = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
};
const useScroll = ()=>{
    const [bodyOffset, setBodyOffset] = (0,react.useState)( false || !window.document ? EmptySSRRect : document.body.getBoundingClientRect());
    const [scrollY, setScrollY] = (0,react.useState)(bodyOffset.top);
    const [scrollX, setScrollX] = (0,react.useState)(bodyOffset.left);
    const [scrollDirection, setScrollDirection] = (0,react.useState)();
    const listener = ()=>{
        setBodyOffset( false || !window.document ? EmptySSRRect : document.body.getBoundingClientRect());
        setScrollY(-bodyOffset.top);
        setScrollX(bodyOffset.left);
        setScrollDirection(scrollY > -bodyOffset.top ? "up" : "down");
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listener);
        return ()=>{
            window.removeEventListener("scroll", listener);
        };
    });
    return {
        scrollY,
        scrollX,
        scrollDirection
    };
};


// EXTERNAL MODULE: ./components/video-hero/video-hero.module.scss
var video_hero_module = __webpack_require__(5719);
var video_hero_module_default = /*#__PURE__*/__webpack_require__.n(video_hero_module);
;// CONCATENATED MODULE: ./components/video-hero/video-hero.tsx






const VideoHero = (props)=>{
    const { vimeoId , videoContent , children  } = props;
    const { scrollY  } = useScroll();
    const [isVimeoPause, setIsVimeoPause] = (0,react.useState)(false);
    const [volume, setVolume] = (0,react.useState)(0);
    const vimeoRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const offsetHeight = (vimeoRef === null || vimeoRef === void 0 ? void 0 : (ref = vimeoRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
        const offsetTop = (vimeoRef === null || vimeoRef === void 0 ? void 0 : (ref1 = vimeoRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetTop) || 0;
        if (scrollY > offsetTop + offsetHeight) {
            setIsVimeoPause(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollY
    ]);
    const [width, height] = Media/* MEDIA_RATIO.16:9 */.r["16:9"];
    const vimeoVideoPaddingTop = height / width * 100;
    const handleOnPlay = ()=>{
        setIsVimeoPause(false);
        setVolume(0.5);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_hero_module_default()).videoHero,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_hero_module_default()).videoHeroContainer,
                ref: vimeoRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_hero_module_default()).vimeoVideo,
                    style: {
                        paddingTop: "".concat(vimeoVideoPaddingTop, "%")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_vimeo_es/* default */.Z, {
                        video: vimeoId,
                        muted: true,
                        paused: isVimeoPause,
                        volume: volume,
                        onPlay: handleOnPlay,
                        onVolumeChange: (e)=>setVolume(e.volume)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_hero_module_default()).videoHeroContent,
                dangerouslySetInnerHTML: {
                    __html: videoContent
                }
            })
        ]
    });
};
/* harmony default export */ var video_hero = (VideoHero);

;// CONCATENATED MODULE: ./components/video-hero/video-hero.builder-component.ts

const VideoHeroBuilderConfig = {
    name: "Video Hero",
    inputs: [
        {
            name: "vimeoId",
            type: "string",
            require: true
        },
        {
            name: "videoContent",
            type: "richText"
        }
    ]
};
const video_hero_builder_component_builderConfig = {
    component: video_hero,
    config: VideoHeroBuilderConfig
};
/* harmony default export */ var video_hero_builder_component = (video_hero_builder_component_builderConfig);

;// CONCATENATED MODULE: ./builder/index.ts


// @ts-ignore - Suppressing "unable to find module" error because webpack preloader will load all matching files




























































let builderComponentConfigs = [
    business_article_grid_builder_component_namespaceObject,
    business_featured_article_hero_builder_component_namespaceObject,
    business_article_image_builder_component_namespaceObject,
    business_article_quote_wrap_builder_component_namespaceObject,
    business_button_wrap_builder_component_namespaceObject,
    business_emphasized_text_builder_component_namespaceObject,
    business_framed_info_block_builder_component_namespaceObject,
    business_headlining_latest_articles_builder_component_namespaceObject,
    business_resource_asset_container_builder_component_namespaceObject,
    business_resource_grid_builder_component_namespaceObject,
    business_resource_asset_library_builder_component_namespaceObject,
    business_resource_background_text_wrap_builder_component_namespaceObject,
    business_resource_asset_builder_component_namespaceObject,
    business_resource_banners_builder_component_namespaceObject,
    business_resource_card_builder_component_namespaceObject,
    business_resource_centre_hero_builder_component_namespaceObject,
    business_resource_colour_palette_builder_component_namespaceObject,
    business_resource_divider_builder_component_namespaceObject,
    business_resource_download_all_button_builder_component_namespaceObject,
    business_resource_download_card_builder_component_namespaceObject,
    business_resource_download_grid_builder_component_namespaceObject,
    business_resource_faq_builder_component_namespaceObject,
    business_resource_hero_sub_builder_component_namespaceObject,
    business_resource_hiws_builder_component_namespaceObject,
    business_resource_image_carousel_builder_component_namespaceObject,
    business_resource_image_comparison_slider_builder_component_namespaceObject,
    business_resource_in_situ_builder_component_namespaceObject,
    business_resource_lightbox_builder_component_namespaceObject,
    business_resource_logo_usage_builder_component_namespaceObject,
    business_resource_logos_builder_component_namespaceObject,
    business_resource_messaging_builder_component_namespaceObject,
    business_resource_page_title_builder_component_namespaceObject,
    business_resource_price_breakdown_builder_component_namespaceObject,
    business_image_grid_slider_builder_component_namespaceObject,
    business_resource_super_text_builder_component_namespaceObject,
    business_resource_text_highlight_builder_component_namespaceObject,
    business_resource_text_list_builder_component_namespaceObject,
    business_resource_text_wrap_builder_component_namespaceObject,
    business_resource_top_strips_builder_component_namespaceObject,
    business_resource_training_block_builder_component_namespaceObject,
    business_resource_typography_review_builder_component_namespaceObject,
    business_resource_value_block_builder_component_namespaceObject,
    business_resource_video_list_builder_component_namespaceObject,
    business_text_caption_builder_component_namespaceObject,
    business_text_wrap_builder_component_namespaceObject,
    business_trending_topics_builder_component_namespaceObject,
    business_vimeo_embed_wrap_builder_component_namespaceObject,
    business_youtube_embed_builder_component_namespaceObject,
    business_video_player_builder_component_namespaceObject,
    category_feature_builder_component_namespaceObject,
    category_hero_builder_component_namespaceObject,
    learning_series_block_builder_component_namespaceObject,
    numerical_highlight_list_builder_component_namespaceObject,
    series_collection_articles_block_builder_component_namespaceObject,
    trustpilot_widget_builder_component_namespaceObject,
    unordered_highlight_list_builder_component_namespaceObject,
    video_card_section_builder_component_namespaceObject,
    video_card_builder_component_namespaceObject,
    video_carousel_builder_component_namespaceObject,
    video_hero_builder_component_namespaceObject
];








index_esm/* builder.init */.fl.init(env/* BUILDER_API_KEY */.uT);
const registerComponents = ()=>{
    for (const exports of builderComponentConfigs){
        if (Object.hasOwnProperty.call(exports, "default")) {
            const { component , config  } = exports.default;
            if (component && config) {
                //     console.log({component});
                index_esm/* Builder.registerComponent */.Ib.registerComponent(component, config);
            }
        }
    }
};
const awaitBuilderData = async (page, lang)=>{
    await getAsyncProps(page, {
        "Full Width Featured Article Hero": async (props)=>{
            const articles = await getLatestArticles({
                locale: lang,
                offset: 0,
                limit: 1
            });
            return {
                article: articles === null || articles === void 0 ? void 0 : articles[0]
            };
        },
        [HeadliningLatestArticlesBuilderConfig.name]: async (props)=>{
            var _offset;
            const articles = await getLatestArticles({
                locale: lang,
                offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
                limit: 3
            });
            return {
                articles
            };
        },
        [LearningSeriesBlockPropsBuilderConfig.name]: async (props)=>{
            const { category1 , category2 , category3  } = props;
            const categories = [
                category1 || "",
                category2 || "",
                category3 || ""
            ].filter((category)=>!!category);
            let seriesData = [];
            if (categories && categories.length) {
                const foundCategories = await getCategoriesFromIDs(categories);
                for (const category of foundCategories){
                    const articles = await getAllArticles(lang, {
                        categoryIds: [
                            category.id
                        ],
                        limit: 30
                    });
                    seriesData.push({
                        category: category,
                        articleCount: articles.length
                    });
                }
            }
            return {
                seriesData
            };
        },
        [BusinessArticleGridBuilderConfig.name]: async (props)=>{
            return {
                initialArticles: await getLatestArticles({
                    locale: lang,
                    offset: 1,
                    limit: 9
                })
            };
        },
        [CategoryFeatureBuilderConfig.name]: async (props)=>{
            let category;
            let articles = [];
            if (typeof props.category === "string") {
                category = await getCategoryFromID(props.category);
            } else {
                category = props.category;
            }
            if (category) {
                articles = await getArticlesByCategory({
                    locale: lang,
                    limit: 3,
                    categoryIds: [
                        category.id
                    ]
                });
            }
            return {
                category,
                categoryArticles: articles
            };
        },
        [BusinessTrendingTopicsBuilderConfig.name]: async (props)=>{
            const categoryIds = props.categories.map((category)=>category.categoryId);
            const fetchedCategories = await getCategoriesFromIDs(categoryIds);
            // Create a temporary key object that's sorted in the way that it comes from Builder
            const keyOrder = {};
            categoryIds.forEach((id)=>{
                keyOrder[id] = undefined;
            });
            // Then loop though the objects we just got to make sure they're in the same order.
            fetchedCategories.forEach((newCategory)=>{
                keyOrder[newCategory.id] = newCategory;
            });
            // and now set the categories to Object.value'd version of the order.
            // Voila - easy sort
            return {
                categoryData: Object.values(keyOrder)
            };
        },
        [SeriesCollectionArticlesBuilderConfig.name]: async (props)=>{
            if (props.category) {
                const [articles, categoryObject] = await Promise.all([
                    getArticlesByCategory({
                        locale: lang,
                        categoryIds: [
                            props.category
                        ]
                    }),
                    getCategoriesFromIDs([
                        props.category
                    ])
                ]);
                return {
                    categoryObject,
                    articles
                };
            }
            return {};
        }
    });
};


/***/ }),

/***/ 3431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
;// CONCATENATED MODULE: ./components/icons/Icons/IconArrowRight.tsx


const IconArrowRight = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "icon-arrow",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_IconArrowRight = (IconArrowRight);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(3964);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
;// CONCATENATED MODULE: ./components/breadcrumb/breadcrumb.tsx





const Breadcrumb = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { breadcrumbs , type  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).breadcrumbContainer + " " + (breadcrumb_module_default())["".concat(type)],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (breadcrumb_module_default()).breadcrumb,
            children: (breadcrumbs || []).map((breadcrumb, index)=>{
                const linkTags = {};
                var _link;
                const linkUrl = (0,LangHelper/* localifyLink */.Bj)((_link = breadcrumb.link) !== null && _link !== void 0 ? _link : "", locale);
                if (linkUrl) {
                    linkTags.href = "/".concat(locale).concat(linkUrl);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).separator,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_IconArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).breadcrumbName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                ...linkTags,
                                target: "_self",
                                className: (breadcrumb_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: "".concat(breadcrumb.name)
                                }
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);


/***/ }),

/***/ 2379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_article_single_hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(8766);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(3431);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./components/categories/categories.tsx
var categories_categories = __webpack_require__(8324);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero-info/business-article-single-hero-info.module.scss
var business_article_single_hero_info_module = __webpack_require__(9702);
var business_article_single_hero_info_module_default = /*#__PURE__*/__webpack_require__.n(business_article_single_hero_info_module);
;// CONCATENATED MODULE: ./components/business-article-single-hero/business-article-single-hero-info/business-article-single-hero-info.tsx








const BusinessArticleHeroInfo = (param)=>{
    let { title , description , categories , articleUrl , isShowReadMore , layout ="default" , theme  } = param;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    const classNameArticleZHeroInfo = classnames_default()((business_article_single_hero_info_module_default()).businessArticleHeroInfo, {
        "article-hero-info": true
    }, (business_article_single_hero_info_module_default())[layout]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNameArticleZHeroInfo,
        children: [
            categories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_info_module_default()).categories,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_categories/* default */.Z, {
                    color: theme !== undefined ? theme === "dark" ? "grey" : "white" : undefined,
                    type: isMobile() ? "SMALL" : "LARGE",
                    categories: categories
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: classnames_default()((business_article_single_hero_info_module_default()).title, (business_article_single_hero_info_module_default())[theme || ""]),
                children: [
                    title,
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_article_single_hero_info_module_default()).description,
                        children: description
                    })
                ]
            }),
            isShowReadMore && articleUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (business_article_single_hero_info_module_default()).readMoreUrl,
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(articleUrl, locale),
                target: "_self",
                rel: "noopener",
                children: [
                    "Read More",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_article_single_hero_info = (BusinessArticleHeroInfo);

// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero.module.scss
var business_article_single_hero_module = __webpack_require__(4099);
var business_article_single_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_article_single_hero_module);
// EXTERNAL MODULE: ./components/business-vimeo-embed/business-vimeo-embed.tsx
var business_vimeo_embed = __webpack_require__(8096);
// EXTERNAL MODULE: ./contexts/DefaultLayoutContext.tsx
var DefaultLayoutContext = __webpack_require__(1683);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(8771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/business-article-single-hero/business-article-single-hero.tsx










const BusinessArticleHero = (props)=>{
    const { title , leadImage , categories , articleUrl , description , leadVideo  } = props.article;
    const { breadcrumbs , isMarginLower =false , isShowReadMore =false , isFeaturedBlock  } = props;
    const isUseLeadVideo = leadVideo && leadVideo.videoUrl;
    const classNameArticleHero = classnames_default()((business_article_single_hero_module_default()).businessArticleHeroContainer, {
        [(business_article_single_hero_module_default()).marginLower]: isMarginLower
    }, {
        [(business_article_single_hero_module_default()).isFeatured]: isFeaturedBlock
    });
    const defaultLayoutContext = (0,react.useContext)(DefaultLayoutContext/* DefaultLayoutContext */.V);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const getBreadcrumbType = ()=>{
        if (isUseLeadVideo && defaultLayoutContext.type) {
            return defaultLayoutContext.type;
        }
        return width > 768 ? "dark" : "light";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNameArticleHero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_module_default()).breadcrumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    breadcrumbs: breadcrumbs,
                    type: getBreadcrumbType()
                })
            }),
            isUseLeadVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_vimeo_embed/* default */.Z, {
                    ...leadVideo
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_article_single_hero_module_default()).businessArticleHeroWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_article_single_hero_module_default()).businessArticleHeroBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: leadImage !== null && leadImage !== void 0 ? leadImage : "",
                            alt: "Headline article image ".concat(title),
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            fill: true,
                            loading: "eager",
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_module_default()).businessArticleHeroInfoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_article_single_hero_info, {
                    title,
                    articleUrl,
                    categories,
                    isShowReadMore,
                    description: isFeaturedBlock ? description : undefined,
                    layout: isUseLeadVideo ? "simple" : undefined,
                    theme: defaultLayoutContext.type
                })
            })
        ]
    });
};
/* harmony default export */ var business_article_single_hero = (BusinessArticleHero);


/***/ }),

/***/ 9892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "UZ": function() { return /* binding */ ICONS; },
/* harmony export */   "Vr": function() { return /* binding */ POSITION; },
/* harmony export */   "zf": function() { return /* binding */ SIZES; }
/* harmony export */ });
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3203);

const ICONS = _icons__WEBPACK_IMPORTED_MODULE_0__/* .IconType */ .T;
const COLORS = {
    MINT: "mint",
    PLUM: "plum",
    BLACK: "black",
    WHITE: "white"
};
var POSITION;
(function(POSITION) {
    POSITION["LEFT"] = "Left";
    POSITION["CENTER"] = "Center";
    POSITION["RIGHT"] = "Right";
})(POSITION || (POSITION = {}));
const SIZES = {
    NORMAL: "normal",
    SMALL: "small"
};


/***/ }),

/***/ 2955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3203);
/* harmony import */ var _business_button_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9892);
/* harmony import */ var _business_button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4977);
/* harmony import */ var _business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);






const BusinessButton = (props)=>{
    var ref, ref1;
    const { buttonText , color =_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.MINT */ .DM.MINT , size =_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .SIZES.NORMAL */ .zf.NORMAL , icon , square , position =_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .POSITION.CENTER */ .Vr.CENTER  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.MINT */ .DM.MINT]: "#b2fce4",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.PLUM */ .DM.PLUM]: "#EADDF2",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.WHITE */ .DM.WHITE]: "#fff",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.BLACK */ .DM.BLACK]: "#000"
        };
        return backgroundColorMap[color];
    };
    const getIconClassNameColor = ()=>{
        const iconClassNameColorMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.MINT */ .DM.MINT]: "mint",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.PLUM */ .DM.PLUM]: "plum",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.WHITE */ .DM.WHITE]: "white",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .COLORS.BLACK */ .DM.BLACK]: "black"
        };
        return iconClassNameColorMap[color];
    };
    const getSize = ()=>{
        const sizeMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .SIZES.NORMAL */ .zf.NORMAL]: "normal",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .SIZES.SMALL */ .zf.SMALL]: "small"
        };
        return sizeMap[size];
    };
    const getPosition = ()=>{
        const positionMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .POSITION.LEFT */ .Vr.LEFT]: "left",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .POSITION.RIGHT */ .Vr.RIGHT]: "right",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_3__/* .POSITION.CENTER */ .Vr.CENTER]: "center"
        };
        return positionMap[position];
    };
    var ref2;
    const link = (ref2 = (ref = props.builderBlock) === null || ref === void 0 ? void 0 : (ref1 = ref.properties) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref2 !== void 0 ? ref2 : props.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: link,
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().businessButtonWrapper), (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getSize()], (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getIconClassNameColor()], (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getPosition()], {
            [(_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().square)]: square
        }),
        style: {
            backgroundColor: getBackgroundColor()
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().businessButtonText) + " " + (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getSize()],
            children: [
                buttonText,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    type: icon
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessButton);


/***/ }),

/***/ 8096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _types_Media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9289);
/* harmony import */ var _vimeo_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1806);
/* harmony import */ var _business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7654);
/* harmony import */ var _business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hook_useBackgroundTransform__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2479);







const BusinessVimeoEmbed = (props)=>{
    const { videoUrl , ratio ="1:1" , controls =false , backgroundTransform , containerMaxWidth , isHero  } = props;
    const playerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [isPlayVideo, setIsPlayVideo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [vimeoControls, setVimeoControls] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { position  } = (0,_hook_useBackgroundTransform__WEBPACK_IMPORTED_MODULE_5__/* .useBackgroundTransform */ .L)(containerRef, isHero);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!videoUrl) return;
        if (!controls) return;
        const url = new URL(videoUrl);
        var ref;
        const controlParam = (ref = url.searchParams.get("controls")) !== null && ref !== void 0 ? ref : true;
        setVimeoControls(controlParam === "1" || controlParam === "true");
    }, [
        videoUrl,
        controls
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!videoUrl) return;
        if (!iframeRef.current) return;
        playerRef.current = null;
        playerRef.current = new _vimeo_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(iframeRef.current);
        playerRef.current.on("play", ()=>{
            var ref;
            setIsPlayVideo(true);
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.setVolume(0.5);
        });
        playerRef.current.on("pause", ()=>setIsPlayVideo(false));
    }, [
        videoUrl,
        iframeRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (position !== "ON_SCREEN") {
            var ref;
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.pause();
        }
    }, [
        position
    ]);
    const togglePlayVideo = ()=>{
        if (isPlayVideo) {
            var ref;
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.pause();
        } else {
            var ref1;
            (ref1 = playerRef.current) === null || ref1 === void 0 ? void 0 : ref1.play();
        }
    };
    const toggleMuteVideo = ()=>{
        playerRef.current;
    };
    const renderPlayPauseBtn = ()=>{
        if (isPlayVideo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonPlay)
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonPause)
            });
        }
    };
    const classNameVideoControl = classnames__WEBPACK_IMPORTED_MODULE_4___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls"]), {
        [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pause)]: !isPlayVideo
    });
    const classNameOverlay = classnames__WEBPACK_IMPORTED_MODULE_4___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().controlOverLay));
    const renderVidPlayer = ()=>{
        const [width, height] = _types_Media__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_RATIO */ .r[ratio];
        const vimeoVideoPaddingTop = height / width * 100;
        var _video;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: backgroundTransform ? containerRef : null,
            className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().vimeoVideo),
            style: {
                paddingTop: "".concat(vimeoVideoPaddingTop, "%")
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    ref: iframeRef,
                    src: (_video = props.video) !== null && _video !== void 0 ? _video : videoUrl,
                    width: "872",
                    height: "872",
                    frameBorder: "0",
                    allow: "autoplay; muted; fullscreen; picture-in-picture",
                    allowFullScreen: true
                }),
                controls && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(classNameVideoControl, {
                                [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["full-iframe"])]: !vimeoControls
                            }),
                            onClick: togglePlayVideo,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls__btnPlayPause"]), {
                                        [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().play)]: isPlayVideo,
                                        [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pause)]: !isPlayVideo
                                    }),
                                    children: renderPlayPauseBtn()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls__btnMuted"]),
                                    onClick: toggleMuteVideo
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classNameOverlay
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessVimeoEmbedContainer),
        style: {
            width: containerMaxWidth
        },
        children: renderVidPlayer()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessVimeoEmbed);


/***/ }),

/***/ 8816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(3431);
// EXTERNAL MODULE: ./shared/sharedContext.tsx
var sharedContext = __webpack_require__(6224);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/category-filter/category-filter.module.scss
var category_filter_module = __webpack_require__(4184);
var category_filter_module_default = /*#__PURE__*/__webpack_require__.n(category_filter_module);
;// CONCATENATED MODULE: ./components/category-filter/category-filter.tsx





const CategoryFilter = (props)=>{
    const [isShownCategories, setIsShownCategories] = (0,react.useState)(false);
    const categoryCtx = (0,react.useContext)(sharedContext/* CategoryCtx */.N);
    const handleCategories = (category)=>{
        if (categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id)) {
            return categoryCtx.setCategoriesToFilter(categoryCtx.categoriesToFilter.filter((_category)=>_category.id !== category.id));
        }
        return categoryCtx.setCategoriesToFilter([
            ...categoryCtx.categoriesToFilter,
            category
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_filter_module_default()).categoryFilter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_filter_module_default()).filterButton + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                onClick: ()=>setIsShownCategories(!isShownCategories),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Filter */.T.Filter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Filter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_filter_module_default()).filterIconDown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_filter_module_default()).categories + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (category_filter_module_default()).categoriesList,
                    children: (categoryCtx.allCategories || []).map((category, index)=>{
                        const isItemChecked = categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_filter_module_default()).categoryName + " " + (category_filter_module_default())[isItemChecked ? "checked" : "unCheck"],
                            onClick: ()=>handleCategories(category),
                            children: category.name
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var category_filter = (CategoryFilter);

// EXTERNAL MODULE: ./components/category-hero/category-hero.module.scss
var category_hero_module = __webpack_require__(9529);
var category_hero_module_default = /*#__PURE__*/__webpack_require__.n(category_hero_module);
;// CONCATENATED MODULE: ./components/category-hero/category-hero.tsx






const CategoryHero = (props)=>{
    const { categoryHeroTitle , breadcrumbs , categoryHeroDescription , backgroundColor ="Orca Pastel" , backgroundCoverContent =true , showFilter =true  } = props;
    const breadcrumbIncluded = breadcrumbs && breadcrumbs.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((category_hero_module_default()).categoryHero, {
            [(category_hero_module_default()).breadcrumb]: breadcrumbIncluded
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((category_hero_module_default()).categoryHeroBackground, (category_hero_module_default())["categoryHeroBackground".concat(backgroundColor.replace(" ", ""))], {
                    [(category_hero_module_default()).categoryHeroBackgroundCover]: backgroundCoverContent
                })
            }),
            breadcrumbIncluded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).breadcrumbs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    type: "dark",
                    breadcrumbs: breadcrumbs
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryName,
                children: categoryHeroTitle
            }),
            categoryHeroDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryDescription,
                children: categoryHeroDescription
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).categoryFilter,
                children: showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(category_filter, {}) : null
            })
        ]
    });
};
/* harmony default export */ var category_hero = (CategoryHero);


/***/ }),

/***/ 7048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7650);
/* harmony import */ var _helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5443);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3203);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const iconArrowRight = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M0.5 8.5H15.5" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M10.5 3.5L15.5 8.5L10.5 13.5" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
const NewsletterSignUpSection = (props)=>{
    const [newsLetterSignUp, setNewsletterSignUp] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isShowMessage, setIsShowMessage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d8)("NewsletterSignUp", "true");
        setIsShowMessage(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const newsletterSignUpCookie = (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsletterSignUp(true);
        }
    }, [
        newsLetterSignUp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://business.afterpay.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//business.afterpay.com", "539-RJA-633", 1064, function(form) {
                form.getFormElem().find("button.mktoButton").html('<div class="button-submit"><div class="button-submit-title">Subscribe Now</div>'.concat(iconArrowRight, "</div>"));
                form.getFormElem().find("input.mktoEmailField").attr("placeholder", "Enter your email here...");
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    if (newsLetterSignUp) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSection),
            ref: ref,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfoBackground),
                    children: " "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionTitle),
                        children: "Get small business advice and insights straight to your inbox."
                    })
                }),
                isShowMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionAfterSubmit),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            type: _icons__WEBPACK_IMPORTED_MODULE_2__/* .IconType.Subscribed */ .T.Subscribed
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "Thanks!",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "You're now subscribed."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                    id: "mktoForm_1064",
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionForm)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsletterSignUpSection);


/***/ }),

/***/ 2479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useBackgroundTransform; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);
/* harmony import */ var _contexts_DefaultLayoutContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1683);


const useBackgroundTransform = (target, preventTopTransform)=>{
    const defaultLayout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_DefaultLayoutContext__WEBPACK_IMPORTED_MODULE_1__/* .DefaultLayoutContext */ .V);
    const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const transformDetector = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (!target || !target.current) return;
        const targetElem = target.current;
        const element_height = targetElem.clientHeight;
        const top_of_element = targetElem.offsetTop;
        const bottom_of_element = targetElem.offsetTop + element_height;
        const top_of_window = window.scrollY;
        const bottom_of_window = top_of_window + window.innerHeight;
        const window_height = window.innerHeight;
        let position = "ON_SCREEN";
        let top_transform_position = Math.max(top_of_element + 100, Math.min(window_height / 3, top_of_element / 3 * 4));
        if (top_transform_position > bottom_of_element) {
            top_transform_position = top_of_element;
        }
        let bottom_transform_position = Math.max(bottom_of_element - 100, Math.min(window_height / 3, top_of_element / 3 * 2));
        if (bottom_transform_position < top_of_element) {
            bottom_transform_position = bottom_of_element;
        }
        if ((bottom_of_window > top_transform_position || preventTopTransform) && top_of_window < bottom_transform_position) {
            document.body.classList.add("dark");
            defaultLayout.setType("light");
            position = "TOP";
        } else {
            document.body.classList.remove("dark");
            defaultLayout.setType("dark");
            position = "BOTTOM";
        }
        if (top_of_window < bottom_transform_position && bottom_of_window > top_transform_position) {
            position = "ON_SCREEN";
        }
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        transformDetector();
        document.addEventListener("scroll", transformDetector);
        return ()=>document.removeEventListener("scroll", transformDetector);
    }, [
        transformDetector
    ]);
    return {
        position
    };
};


/***/ }),

/***/ 9289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MEDIA_RATIO; }
/* harmony export */ });
const MEDIA_RATIO = {
    "1:1": [
        1,
        1
    ],
    "16:9": [
        16,
        9
    ],
    "9:16": [
        9,
        16
    ]
};


/***/ }),

/***/ 4179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"asset-card_root__fSSO_","content":"asset-card_content___ESDt","imageContainer":"asset-card_imageContainer__cAsr9","image":"asset-card_image__2NH5M","checkbox":"asset-card_checkbox__Ly1x_","pagination":"asset-card_pagination___A6tM","swiperContainer":"asset-card_swiperContainer__HQPc2","black":"asset-card_black__IsRdL","mint":"asset-card_mint__WIag5","white":"asset-card_white__SwNF7"};

/***/ }),

/***/ 1773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-asset-card_root__ofxYS"};

/***/ }),

/***/ 3964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"breadcrumb_breadcrumbContainer__PXHE5","light":"breadcrumb_light__eyy6t","separator":"breadcrumb_separator__0KuRL","dark":"breadcrumb_dark__T0QBm","container":"breadcrumb_container__WEljr","breadcrumb":"breadcrumb_breadcrumb__4T6Pp"};

/***/ }),

/***/ 6697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleImageContainer":"business-article-image_businessArticleImageContainer__emV0r","businessArticleImageWrapper":"business-article-image_businessArticleImageWrapper__9vYHf","businessArticleImageBox":"business-article-image_businessArticleImageBox__ipbVI","squared":"business-article-image_squared___dFYo","businessArticleImage":"business-article-image_businessArticleImage__oDpQT"};

/***/ }),

/***/ 9891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleQuoteContainer":"business-article-quote_businessArticleQuoteContainer__McDIe","businessArticleQuoteBackground":"business-article-quote_businessArticleQuoteBackground__rWGmA","small":"business-article-quote_small__5qTK8","medium":"business-article-quote_medium__p7opP","large":"business-article-quote_large__mdKIf","full":"business-article-quote_full__j9L2X","businessArticleQuoteBox":"business-article-quote_businessArticleQuoteBox__fR6xs","light":"business-article-quote_light__G_S35","businessArticleQuote":"business-article-quote_businessArticleQuote__p_mhE","businessArticleAuthorName":"business-article-quote_businessArticleAuthorName__M5qsF"};

/***/ }),

/***/ 9702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleHeroInfo":"business-article-single-hero-info_businessArticleHeroInfo__RbsAs","simple":"business-article-single-hero-info_simple__mdZLA","categories":"business-article-single-hero-info_categories__eU0aW","title":"business-article-single-hero-info_title__pVjc9","light":"business-article-single-hero-info_light__ApBI_","description":"business-article-single-hero-info_description__Z1i4i","readMoreUrl":"business-article-single-hero-info_readMoreUrl__rgayb"};

/***/ }),

/***/ 4099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleHeroContainer":"business-article-single-hero_businessArticleHeroContainer__PxQsb","marginLower":"business-article-single-hero_marginLower__cbvWY","isFeatured":"business-article-single-hero_isFeatured__wh2ic","breadcrumb":"business-article-single-hero_breadcrumb__06ELX","businessArticleHeroInfoWrapper":"business-article-single-hero_businessArticleHeroInfoWrapper__k7lhS","businessArticleHeroWrapper":"business-article-single-hero_businessArticleHeroWrapper__FadIx","businessArticleHeroBox":"business-article-single-hero_businessArticleHeroBox__Rgx4O","video-spin":"business-article-single-hero_video-spin__0sBAl"};

/***/ }),

/***/ 4977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessButtonWrapper":"business-button_businessButtonWrapper__pIUcQ","mint":"business-button_mint__6y4PS","plum":"business-button_plum__At5_e","black":"business-button_black__B6eLH","white":"business-button_white__SiDp9","square":"business-button_square__SRK6Y","left":"business-button_left__RzyA2","right":"business-button_right__fYN7J","businessButtonText":"business-button_businessButtonText__LowYs","normal":"business-button_normal__m78de","small":"business-button_small__2bkxC","video-spin":"business-button_video-spin__2u_TY"};

/***/ }),

/***/ 7926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessEmphasizedTextContainer":"business-emphasized-text_businessEmphasizedTextContainer__q2CWR","businessEmphasizedText":"business-emphasized-text_businessEmphasizedText__GGJGO","light":"business-emphasized-text_light__wU6qh"};

/***/ }),

/***/ 7882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceBlockContainer":"business-framed-info-block_businessResourceBlockContainer__qkdS_","businessResourceBlockInfo":"business-framed-info-block_businessResourceBlockInfo__bBlN7","infoTitle":"business-framed-info-block_infoTitle__3PZEh","infoDescription":"business-framed-info-block_infoDescription__jZiwx","infoCTA":"business-framed-info-block_infoCTA__iMIWh","businessResourceBlockMediaContainer":"business-framed-info-block_businessResourceBlockMediaContainer__ychMr","businessResourceBlockMedia":"business-framed-info-block_businessResourceBlockMedia__rRsIW","mediaImageWrapper":"business-framed-info-block_mediaImageWrapper__HpZsr","box":"business-framed-info-block_box__MKJGo","main":"business-framed-info-block_main__3mDZM","left":"business-framed-info-block_left__dxtBA","right":"business-framed-info-block_right__N_oxX","mediaImageBox":"business-framed-info-block_mediaImageBox__w8M4N","mediaImageMain":"business-framed-info-block_mediaImageMain__1Lqnf","mediaBackground":"business-framed-info-block_mediaBackground__YaFRX"};

/***/ }),

/***/ 6414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-asset-grid_root__OeKHa","showDivider":"business-resource-asset-grid_showDivider__fyY3J","titleContainer":"business-resource-asset-grid_titleContainer__BJere","title":"business-resource-asset-grid_title__Uk5nY","button":"business-resource-asset-grid_button__U8c9A","resourceContainer":"business-resource-asset-grid_resourceContainer__YCt_s","resource":"business-resource-asset-grid_resource__Th0jE","downloadButton":"business-resource-asset-grid_downloadButton__qW9K5","description":"business-resource-asset-grid_description__IBZ28","video-spin":"business-resource-asset-grid_video-spin__9Beda"};

/***/ }),

/***/ 7974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-asset-library_root__SJcYg","tab":"business-resource-asset-library_tab__PUqcq","action":"business-resource-asset-library_action__G9ndZ","buttonResponsive":"business-resource-asset-library_buttonResponsive__4R031","lock":"business-resource-asset-library_lock__DtxcP","buttonContainer":"business-resource-asset-library_buttonContainer___ixBo","leftAction":"business-resource-asset-library_leftAction__8nPYp","dropdownButton":"business-resource-asset-library_dropdownButton__yyD79","chip":"business-resource-asset-library_chip__opwcr"};

/***/ }),

/***/ 3129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"filter-panel-container_title__V33n8","content":"filter-panel-container_content__RxgWL","root":"filter-panel-container_root__75_GS","reset":"filter-panel-container_reset__QSS0G","keyMessages":"filter-panel-container_keyMessages__b_sFq"};

/***/ }),

/***/ 1280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"business-resource-asset-single-variant_image__hPIqo","root":"business-resource-asset-single-variant_root__ImqQo","leftBlock":"business-resource-asset-single-variant_leftBlock__S7Ixo","clickable":"business-resource-asset-single-variant_clickable__Rf5Fj","alignCenter":"business-resource-asset-single-variant_alignCenter__FbdWH"};

/***/ }),

/***/ 8032:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-background-text-wrap_root__mrHV7","text":"business-resource-background-text-wrap_text__KHT5j","copyButton":"business-resource-background-text-wrap_copyButton__fAKBV"};

/***/ }),

/***/ 3202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-banner-carousel_container__LbFFw","withDownloadButton":"business-resource-banner-carousel_withDownloadButton__YVJ2t","content":"business-resource-banner-carousel_content__5PUyC","bannerPreview":"business-resource-banner-carousel_bannerPreview__c_SZq","download":"business-resource-banner-carousel_download__M5o63"};

/***/ }),

/***/ 8328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-banners_root__Zai6q","resourceContainer":"business-resource-banners_resourceContainer__9hISU","pagePreviewImage":"business-resource-banners_pagePreviewImage__tq_yr"};

/***/ }),

/***/ 9890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceCardWrapper":"business-resource-card_businessResourceCardWrapper__Y0H56","businessResourceCardBackgroundWrapper":"business-resource-card_businessResourceCardBackgroundWrapper__b243L","businessResourceCardBackgroundBox":"business-resource-card_businessResourceCardBackgroundBox__4JdHg","businessResourceCardBackground":"business-resource-card_businessResourceCardBackground__m582E","businessResourceCardOverlayWrapper":"business-resource-card_businessResourceCardOverlayWrapper__DL4Pr","businessResourceCardOverlayTitle":"business-resource-card_businessResourceCardOverlayTitle__PcgRW","businessResourceCardOverlayDescription":"business-resource-card_businessResourceCardOverlayDescription__MVQ6_","businessResourceCardOverlayCTA":"business-resource-card_businessResourceCardOverlayCTA__yA5oV"};

/***/ }),

/***/ 7625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-centre-hero_container__0PLY5","background":"business-resource-centre-hero_background__v_qRz","title":"business-resource-centre-hero_title__o86a6","filterTitle":"business-resource-centre-hero_filterTitle__vd0Bw"};

/***/ }),

/***/ 1951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-colour-palette_container__H3skS","primary":"business-resource-colour-palette_primary__0ekr_"};

/***/ }),

/***/ 8315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"colour-card_container__hNLr4","bordered":"colour-card_bordered__8mgl_","content":"colour-card_content__n5uW5","name":"colour-card_name__mnj79","description":"colour-card_description__XLeAa","colorCode":"colour-card_colorCode__qESXC","copied":"colour-card_copied__aJo6C","copyIcon":"colour-card_copyIcon__K3ahT"};

/***/ }),

/***/ 8874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-divider_container__PvmEu"};

/***/ }),

/***/ 762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-download-button_container__blE1D","tooltip":"business-resource-download-button_tooltip__mcqwi","download":"business-resource-download-button_download__xMRHy","icon":"business-resource-download-button_icon__Zmqox","tooltipArrow":"business-resource-download-button_tooltipArrow__hwCI5","visible":"business-resource-download-button_visible__F8f6F","button":"business-resource-download-button_button__bDvS_","mobileFullWidth":"business-resource-download-button_mobileFullWidth___4_cL","buttonDisable":"business-resource-download-button_buttonDisable___NhMP","video-spin":"business-resource-download-button_video-spin__Uwpuy"};

/***/ }),

/***/ 6703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-download-card_container__h163f","bordered":"business-resource-download-card_bordered__iYK6_","large":"business-resource-download-card_large__yE7K1","box":"business-resource-download-card_box__FtsZV","downloadContainer":"business-resource-download-card_downloadContainer__f6rAV","tooltip":"business-resource-download-card_tooltip__rf_vr","tooltipArrow":"business-resource-download-card_tooltipArrow__sXT3G","download":"business-resource-download-card_download__Feae3"};

/***/ }),

/***/ 7820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"business-resource-download-grid_box__GnUTk","downloadButton":"business-resource-download-grid_downloadButton__zAuQP"};

/***/ }),

/***/ 5355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-faq_container__bBVMQ","itemContainer":"business-resource-faq_itemContainer__DYCsE","question":"business-resource-faq_question__PWyr_","answer":"business-resource-faq_answer__x5JG5"};

/***/ }),

/***/ 9218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"business-resource-group-label_header__aIuoO","title":"business-resource-group-label_title__LxrFU"};

/***/ }),

/***/ 3042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceHeroSubWrapper":"business-resource-hero-sub_businessResourceHeroSubWrapper__BM3Co","breadcrumb":"business-resource-hero-sub_breadcrumb__dTCV_","businessResourceHeroSubBreadcrumb":"business-resource-hero-sub_businessResourceHeroSubBreadcrumb__3Uwxs","businessResourceHeroSubBackgroundWrapper":"business-resource-hero-sub_businessResourceHeroSubBackgroundWrapper__wSWoO","box":"business-resource-hero-sub_box__iIvTU","main":"business-resource-hero-sub_main__S2cwn","businessResourceHeroSubOverlayWrapper":"business-resource-hero-sub_businessResourceHeroSubOverlayWrapper__b_KEz","businessResourceHeroSubOverlayTitle":"business-resource-hero-sub_businessResourceHeroSubOverlayTitle__HvTnu","businessResourceHeroSubOverlayDescription":"business-resource-hero-sub_businessResourceHeroSubOverlayDescription__5DT9p"};

/***/ }),

/***/ 5636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-hiws_root__1KS2M","resourceContainer":"business-resource-hiws_resourceContainer__jh7Xn","pagePreviewImage":"business-resource-hiws_pagePreviewImage__elwYE"};

/***/ }),

/***/ 4083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"business-resource-image-carousel_image__Nos02"};

/***/ }),

/***/ 5765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-image-comparison-slider_container__ynDTb","title":"business-resource-image-comparison-slider_title__TtwIk","mask":"business-resource-image-comparison-slider_mask__bQyjt","sliderContainer":"business-resource-image-comparison-slider_sliderContainer__T_aok","do":"business-resource-image-comparison-slider_do__Rsuav","dont":"business-resource-image-comparison-slider_dont__4vzuc","imgCompSlider":"business-resource-image-comparison-slider_imgCompSlider__TQrtw","img":"business-resource-image-comparison-slider_img__ynmPF","imgCompOverlay":"business-resource-image-comparison-slider_imgCompOverlay__PhA8P"};

/***/ }),

/***/ 4993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-in-situ_root__yVTnt","section":"business-resource-in-situ_section__UDhnZ","title":"business-resource-in-situ_title__sLvRs","previewContainer":"business-resource-in-situ_previewContainer__SCYfv","previewTitle":"business-resource-in-situ_previewTitle__HcGGb","previewImage":"business-resource-in-situ_previewImage__ANBr7","action":"business-resource-in-situ_action__8a0Vf","mobileFullWidth":"business-resource-in-situ_mobileFullWidth__suqcH"};

/***/ }),

/***/ 4405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-lightbox_root__Iv4Bs","resourceContainer":"business-resource-lightbox_resourceContainer__lt8Wt","pagePreviewImage":"business-resource-lightbox_pagePreviewImage__YjHIN"};

/***/ }),

/***/ 9901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-link-button_root__2TE3_","disabled":"business-resource-link-button_disabled__A4w15","text":"business-resource-link-button_text__Nz1FS","strong":"business-resource-link-button_strong__hAFyW","icon":"business-resource-link-button_icon__HXms3"};

/***/ }),

/***/ 1073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-logo-usage_container__3mV5p"};

/***/ }),

/***/ 955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"logo-usage-card_container__sMUqR","title":"logo-usage-card_title__TD8_V","image":"logo-usage-card_image__8HtlH"};

/***/ }),

/***/ 7080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"business-resource-logos_downloadButton__tyvrD"};

/***/ }),

/***/ 8861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-messaging_container__FlGVv","copyIcon":"business-resource-messaging_copyIcon__yK5hx","tooltip":"business-resource-messaging_tooltip__iydZb","visible":"business-resource-messaging_visible__Gey5v","tooltipArrow":"business-resource-messaging_tooltipArrow__CQUuV"};

/***/ }),

/***/ 7739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-page-title_root__LAaxP","title":"business-resource-page-title_title__6iMBJ","introduction":"business-resource-page-title_introduction__c5kxi","responsive":"business-resource-page-title_responsive__KIrOp"};

/***/ }),

/***/ 9421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-price-breakdown_container__kBB_c","priceText":"business-resource-price-breakdown_priceText__jhEdt","badge":"business-resource-price-breakdown_badge__M_Egz","reversed":"business-resource-price-breakdown_reversed__ef5sq"};

/***/ }),

/***/ 8068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceRelatedContainer":"business-image-grid-slider_businessResourceRelatedContainer__mCMbP","businessResourceRelatedTitle":"business-image-grid-slider_businessResourceRelatedTitle__TCpKL","businessResourceRelatedDescription":"business-image-grid-slider_businessResourceRelatedDescription__YQn5q","businessResourceRelatedCarousel":"business-image-grid-slider_businessResourceRelatedCarousel__48vqt","carouselButtonNext":"business-image-grid-slider_carouselButtonNext__uS05c","carouselButtonPrev":"business-image-grid-slider_carouselButtonPrev__GHh3H"};

/***/ }),

/***/ 7663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceRelatedItemContainer":"business-resource-related-item_businessResourceRelatedItemContainer__vorSJ","businessResourceRelatedItemBackground":"business-resource-related-item_businessResourceRelatedItemBackground__NnceB","box":"business-resource-related-item_box__FZ2IM","main":"business-resource-related-item_main__rlcyn","businessResourceRelatedItemContent":"business-resource-related-item_businessResourceRelatedItemContent__AxbGu","contentTitle":"business-resource-related-item_contentTitle__zVw6J","contentCTA":"business-resource-related-item_contentCTA__aWFlk","video-spin":"business-resource-related-item_video-spin__i2LLQ"};

/***/ }),

/***/ 7417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-super-text_root__fkd50"};

/***/ }),

/***/ 6690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-text-highlight_root__DUUP6","headline":"business-resource-text-highlight_headline__U2U9r","text":"business-resource-text-highlight_text__nVAYZ"};

/***/ }),

/***/ 6503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-text-list_container___Ho28","title":"business-resource-text-list_title__lZK19","item":"business-resource-text-list_item__zYeX5","number":"business-resource-text-list_number__5qQDG","content":"business-resource-text-list_content__KuUrb"};

/***/ }),

/***/ 4709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-text-wrap_root__8rOyg","row":"business-resource-text-wrap_row__XdN2z","caption":"business-resource-text-wrap_caption__oLy4a","content":"business-resource-text-wrap_content__ysUP5"};

/***/ }),

/***/ 877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-top-strips_root__h_FKa","container":"business-resource-top-strips_container__nNP1_","item":"business-resource-top-strips_item__DDcmJ","image":"business-resource-top-strips_image__KP5Oi","variant":"business-resource-top-strips_variant__6v9pF","leftBlock":"business-resource-top-strips_leftBlock__qvp4k","variantImage":"business-resource-top-strips_variantImage__efW9v"};

/***/ }),

/***/ 5288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceTrainingBlockItemContainer":"business-resource-training-block-item_businessResourceTrainingBlockItemContainer__oU3ug","businessResourceTrainingBlockItemBackground":"business-resource-training-block-item_businessResourceTrainingBlockItemBackground__RDqXi","box":"business-resource-training-block-item_box__tMk51","main":"business-resource-training-block-item_main__XhHRL","businessResourceTrainingBlockItemContent":"business-resource-training-block-item_businessResourceTrainingBlockItemContent__6yfOd","contentTitle":"business-resource-training-block-item_contentTitle__lmHP1","contentDescription":"business-resource-training-block-item_contentDescription__KksPc","contentCTA":"business-resource-training-block-item_contentCTA__zgOj2"};

/***/ }),

/***/ 689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceTrainingBlockContainer":"business-resource-training-block_businessResourceTrainingBlockContainer__HKoxS","businessResourceTrainingBlockTitle":"business-resource-training-block_businessResourceTrainingBlockTitle__ZjkgP","businessResourceTrainingBlockDescription":"business-resource-training-block_businessResourceTrainingBlockDescription__jaWEA","businessResourceTrainingBlockItems":"business-resource-training-block_businessResourceTrainingBlockItems__8W13t"};

/***/ }),

/***/ 2618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-typography-review_container__6dKeO","downloadButton":"business-resource-typography-review_downloadButton__rHCTR"};

/***/ }),

/***/ 6082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"typography-review-card_container__YKvqA","headline":"typography-review-card_headline__VB92J","preview":"typography-review-card_preview__t2ov3","left":"typography-review-card_left__Dt2Lj","right":"typography-review-card_right__0m8aq","font-italic":"typography-review-card_font-italic__hxS_H","font-light":"typography-review-card_font-light___nhdF","font-regular":"typography-review-card_font-regular__4yxxe","font-demibold":"typography-review-card_font-demibold__HzJ6k","font-bold":"typography-review-card_font-bold__OvKr5"};

/***/ }),

/***/ 9689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-value-block_container__MZ6hr","title":"business-resource-value-block_title__Zr6rE","items":"business-resource-value-block_items__0bxxj","item":"business-resource-value-block_item__wMwgn","backgroundWrapper":"business-resource-value-block_backgroundWrapper__FiBNB","backgroundBox":"business-resource-value-block_backgroundBox__OYnYK","background":"business-resource-value-block_background__w6MxI","itemMask":"business-resource-value-block_itemMask__K6S0E","itemTitle":"business-resource-value-block_itemTitle__vDlfz","itemDescription":"business-resource-value-block_itemDescription__Axh34"};

/***/ }),

/***/ 4734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoList":"business-resource-video-list_videoList__cz5rq","videoListContainer":"business-resource-video-list_videoListContainer__OOWr5","videoListHeader":"business-resource-video-list_videoListHeader__k3jEh","videoListDescriptionText":"business-resource-video-list_videoListDescriptionText__nOLy4","videoListHeaderText":"business-resource-video-list_videoListHeaderText__F7chy","videoListHeaderTextWatchAll":"business-resource-video-list_videoListHeaderTextWatchAll__x2LPR","linkWatchAllVideo":"business-resource-video-list_linkWatchAllVideo__AO_sR","videoItem":"business-resource-video-list_videoItem__8KEIU","videoItemLink":"business-resource-video-list_videoItemLink__w6nKo","videoItemContainer":"business-resource-video-list_videoItemContainer__4LRmg","videoItemImageBrand":"business-resource-video-list_videoItemImageBrand__Am28a","videoItemTitle":"business-resource-video-list_videoItemTitle__Lq9If","videoBlock":"business-resource-video-list_videoBlock__zHIzV","video-spin":"business-resource-video-list_video-spin__qJKeH"};

/***/ }),

/***/ 3633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTextCaptionContainer":"business-text-caption_businessTextCaptionContainer__91a1S","businessTextCaption":"business-text-caption_businessTextCaption__PYuih"};

/***/ }),

/***/ 6151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTextWrapContainer":"business-text-wrap_businessTextWrapContainer__sc5Wj","businessTextWrap":"business-text-wrap_businessTextWrap__HYfjO","light":"business-text-wrap_light__Dez9U"};

/***/ }),

/***/ 8790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsItem":"business-trending-topic-item_businessTrendingTopicsItem__DzHWe","itemBackground":"business-trending-topic-item_itemBackground__JdANv","itemDescription":"business-trending-topic-item_itemDescription__u0CoN"};

/***/ }),

/***/ 4753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsWrapper":"business-trending-topics_businessTrendingTopicsWrapper__sjPKq","businessTrendingTopicsTitle":"business-trending-topics_businessTrendingTopicsTitle__HrWFI","businessTrendingTopicsDescription":"business-trending-topics_businessTrendingTopicsDescription__fuPp_","businessTrendingTopicsCarousel":"business-trending-topics_businessTrendingTopicsCarousel__qCf68","carouselButtonNext":"business-trending-topics_carouselButtonNext__kWk7t","carouselButtonPrev":"business-trending-topics_carouselButtonPrev__YA8H6"};

/***/ }),

/***/ 7654:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessVimeoEmbedContainer":"business-vimeo-embed_businessVimeoEmbedContainer__nrNJL","vimeoVideo":"business-vimeo-embed_vimeoVideo__t5ZgB","video-controls":"business-vimeo-embed_video-controls__7U__8","full-iframe":"business-vimeo-embed_full-iframe__e3qGV","pause":"business-vimeo-embed_pause__mKjLv","video-controls__btnPlayPause":"business-vimeo-embed_video-controls__btnPlayPause__C5sH2","play":"business-vimeo-embed_play__wkcFk","video-controls__btnMuted":"business-vimeo-embed_video-controls__btnMuted__dISnd","video-controls__btnTopRight":"business-vimeo-embed_video-controls__btnTopRight__Zacph","icon-back":"business-vimeo-embed_icon-back__egClp","icon-close":"business-vimeo-embed_icon-close__zXPz7"};

/***/ }),

/***/ 6242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessYoutubeEmbedContainer":"business-youtube-embed_businessYoutubeEmbedContainer__va9Ky","youtubeVideo":"business-youtube-embed_youtubeVideo__7qktS"};

/***/ }),

/***/ 1635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-video-container":"business-video-player_c-video-container__42A6_","c-video":"business-video-player_c-video__D3fet","c-video-loader":"business-video-player_c-video-loader__9Vg2i","video-spin":"business-video-player_video-spin__jT0NK","c-video-loading":"business-video-player_c-video-loading___f27b","video-controls":"business-video-player_video-controls__oVSCr","show":"business-video-player_show__snOSZ","video-controls__btnPlayPause":"business-video-player_video-controls__btnPlayPause__E0n85","play":"business-video-player_play__Umdlf","video-controls__btnMuted":"business-video-player_video-controls__btnMuted__3iVH9","video-controls__btnTopRight":"business-video-player_video-controls__btnTopRight__whtIP","icon-back":"business-video-player_icon-back___1rL3","icon-close":"business-video-player_icon-close__zibQc","buttonPlay":"business-video-player_buttonPlay__2EBPW","controlOverLay":"business-video-player_controlOverLay__VikfG","hide":"business-video-player_hide__EcPEi"};

/***/ }),

/***/ 4474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryFeature":"category-feature_categoryFeature__ajHIo","categoryFeatureContainer":"category-feature_categoryFeatureContainer__KLfNi","categoryHeader":"category-feature_categoryHeader__bw_B1","headerText":"category-feature_headerText__iVj3s","articleCardButtonReadAll":"category-feature_articleCardButtonReadAll__1ujqe","linkReadAllArticle":"category-feature_linkReadAllArticle__zBp9z","articleItem":"category-feature_articleItem__nYjKM","articleContainer":"category-feature_articleContainer__51JRL","articleTitle":"category-feature_articleTitle__EWI13","articlesFeature":"category-feature_articlesFeature__v3Xia","video-spin":"category-feature_video-spin__E1eBq"};

/***/ }),

/***/ 4184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryFilter":"category-filter_categoryFilter__F_OO4","filterButton":"category-filter_filterButton__NHaXZ","filterIconDown":"category-filter_filterIconDown__xk2Wn","close":"category-filter_close__tyvrf","categories":"category-filter_categories__v8HZt","open":"category-filter_open__MIMNv","categoriesList":"category-filter_categoriesList__OG8zb","categoryName":"category-filter_categoryName__irctx","checked":"category-filter_checked__C6PCV"};

/***/ }),

/***/ 9529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryHero":"category-hero_categoryHero__kMcFU","breadcrumb":"category-hero_breadcrumb__1N_HC","categoryHeroBackground":"category-hero_categoryHeroBackground__euo6l","breadcrumbs":"category-hero_breadcrumbs__nSw__","categoryHeroBackgroundCover":"category-hero_categoryHeroBackgroundCover__ufVX0","categoryHeroBackgroundOrcaPastel":"category-hero_categoryHeroBackgroundOrcaPastel__pfx1q","categoryHeroBackgroundBlum":"category-hero_categoryHeroBackgroundBlum__0i4Yg","categoryName":"category-hero_categoryName__IpP6L","categoryDescription":"category-hero_categoryDescription__xo2PS","categoryFilter":"category-hero_categoryFilter__1LjhT"};

/***/ }),

/***/ 2594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__HSVjp","checkbox":"checkbox_checkbox__uXwIZ","checked":"checkbox_checked__zPoMa","inner":"checkbox_inner__mSZRi","antCheckboxEffect":"checkbox_antCheckboxEffect__tX3Xm","input":"checkbox_input__8OHRc"};

/***/ }),

/***/ 2923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"chip_root__rwP_Y","icon":"chip_icon__ncd6E"};

/***/ }),

/***/ 4997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"communityCard":"community-card_communityCard__OLx7x","overlay":"community-card_overlay__d5yN1","infoArticle":"community-card_infoArticle__kQmBS","readMoreBtn":"community-card_readMoreBtn__dWXL5","communityCardWrapper":"community-card_communityCardWrapper__SLuN2","articleTitle":"community-card_articleTitle__7cNg7","articleDescription":"community-card_articleDescription__pHu83","articleUrl":"community-card_articleUrl__nIRA3","video-spin":"community-card_video-spin__NPf6S"};

/***/ }),

/***/ 2876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"copy-button_copyIcon__ewgb5","tooltip":"copy-button_tooltip__g5mbt","visible":"copy-button_visible__o9z4D","tooltipArrow":"copy-button_tooltipArrow__fU5sS"};

/***/ }),

/***/ 8313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headliningArticlesBlock":"headlining-articles-block_headliningArticlesBlock__VhMOT","swiperButtonNext":"headlining-articles-block_swiperButtonNext__ZJJIm","swiperButtonPrev":"headlining-articles-block_swiperButtonPrev__dFq_F","headliningArticlesBlockSlideLarge":"headlining-articles-block_headliningArticlesBlockSlideLarge__06vMP"};

/***/ }),

/***/ 8278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-background-zoom":"image-zoom_c-background-zoom__Jqb_5","image-box":"image-zoom_image-box__U95yM","image-main":"image-zoom_image-main__OIogD"};

/***/ }),

/***/ 2016:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__ymWO5","selected":"button_selected__KFyxU"};

/***/ }),

/***/ 4722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"inlined-multi-select_swiperContainer__Wu8dw","root":"inlined-multi-select_root__v8adK"};

/***/ }),

/***/ 853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"learningCard":"learning-card_learningCard__S8n5M","learningCardContainer":"learning-card_learningCardContainer__J_KMd","overlay":"learning-card_overlay__CwHY1","quantity":"learning-card_quantity__4sHU9","title":"learning-card_title__Dj2MU","description":"learning-card_description__jUWza","threeLinesLimit":"learning-card_threeLinesLimit__YF7W_","btnReadAll":"learning-card_btnReadAll__LnQ6c","learningUrl":"learning-card_learningUrl__nKSmo","video-spin":"learning-card_video-spin__tVe81"};

/***/ }),

/***/ 6314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"learning-series-block_seriesCollectionBlock__TlNkB","seriesCollectionBlockOrcaPastel":"learning-series-block_seriesCollectionBlockOrcaPastel__HSEer","seriesHeader":"learning-series-block_seriesHeader___SyiO","title":"learning-series-block_title__4GAPw","description":"learning-series-block_description___5BNs","btnViewAll":"learning-series-block_btnViewAll__lq1iH","video-spin":"learning-series-block_video-spin__X25cp"};

/***/ }),

/***/ 3171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__CPpAi","content":"modal_content__byEdw","header":"modal_header__t094_","title":"modal_title__qc2iA","closeButton":"modal_closeButton__AIwjt","footer":"modal_footer__uEHce"};

/***/ }),

/***/ 425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsletterSignUpSection":"newsletter-signup-section_newsletterSignUpSection__HDAV0","newsletterSignUpSectionInfo":"newsletter-signup-section_newsletterSignUpSectionInfo__QmDXv","newsletterSignUpSectionTitle":"newsletter-signup-section_newsletterSignUpSectionTitle__z_Vcu","newsletterSignUpSectionDescription":"newsletter-signup-section_newsletterSignUpSectionDescription__xkN5J","newsletterSignUpSectionForm":"newsletter-signup-section_newsletterSignUpSectionForm__TmS4Y","newsletterSignUpSectionFormInput":"newsletter-signup-section_newsletterSignUpSectionFormInput__xkKkF","newsletterSignUpSectionAfterSubmit":"newsletter-signup-section_newsletterSignUpSectionAfterSubmit__9Eqeo","fade-in":"newsletter-signup-section_fade-in__f9__6","newsletterSignUpSectionFormBtnSubmit":"newsletter-signup-section_newsletterSignUpSectionFormBtnSubmit__xyl1K","newsletterSignUpSectionInfoBackground":"newsletter-signup-section_newsletterSignUpSectionInfoBackground__5_ixx","video-spin":"newsletter-signup-section_video-spin__1wgzd"};

/***/ }),

/***/ 6154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"numericalListContainer":"numerical-highlight-list_numericalListContainer__E9RlT","numericalHeading":"numerical-highlight-list_numericalHeading__VbkcE","numericalList":"numerical-highlight-list_numericalList__TLawN","numericalWrapper":"numerical-highlight-list_numericalWrapper__NC635","numericalTitle":"numerical-highlight-list_numericalTitle__w4q4m","numericalDescription":"numerical-highlight-list_numericalDescription__crZ1C","numericalItem":"numerical-highlight-list_numericalItem__hvrs9"};

/***/ }),

/***/ 8133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"outlined-button_root__FoVZ3"};

/***/ }),

/***/ 7270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ratio-image_root__lp_z8","imageContainer":"ratio-image_imageContainer__QWedH","image":"ratio-image_image__AJGSH"};

/***/ }),

/***/ 4448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"series-collection-articles-block_seriesCollectionBlock__62AUu","seriesCollectionBlockOrcaPastel":"series-collection-articles-block_seriesCollectionBlockOrcaPastel__hykKZ","seriesHeader":"series-collection-articles-block_seriesHeader__CY27E","title":"series-collection-articles-block_title__JfGSK","description":"series-collection-articles-block_description__e_Wmo","btnViewAll":"series-collection-articles-block_btnViewAll__XJD3K","video-spin":"series-collection-articles-block_video-spin__OtpDv"};

/***/ }),

/***/ 3253:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilot-widget-container":"trustpilot-widget_trustpilot-widget-container__5_bmN"};

/***/ }),

/***/ 715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unorderedHighlightListContainer":"unordered-highlight-list_unorderedHighlightListContainer__Hy8FW","unorderedHighlightHeading":"unordered-highlight-list_unorderedHighlightHeading__e4lvM","unorderedHighlightList":"unordered-highlight-list_unorderedHighlightList__q_cUp","unorderedHighlightItem":"unordered-highlight-list_unorderedHighlightItem__dJOul","PLUM":"unordered-highlight-list_PLUM__eczQL"};

/***/ }),

/***/ 9871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"discountCarouselItemImage":"video-card-item_discountCarouselItemImage__0Mm2x","discountCarouselItemQuote":"video-card-item_discountCarouselItemQuote__xBRti","discountCarouselItemDiscount":"video-card-item_discountCarouselItemDiscount__Nh7AS","discountCarouselItemImageBrand":"video-card-item_discountCarouselItemImageBrand__mbZm9","discountCarouselItemCTABlock":"video-card-item_discountCarouselItemCTABlock__Ysllz","discountCarouselItemQuoteContent":"video-card-item_discountCarouselItemQuoteContent__ivuUC","discountCarouselItemQuoteAuthorName":"video-card-item_discountCarouselItemQuoteAuthorName__pPaA4","singleBlock":"video-card-item_singleBlock__OxXDe","discountCarouselItemDiscountPercent":"video-card-item_discountCarouselItemDiscountPercent__OdELv","discountCarouselItemDiscountText":"video-card-item_discountCarouselItemDiscountText__MQRzp","discountCarouselItemCTABlockContent":"video-card-item_discountCarouselItemCTABlockContent__trnHR","discountCarouselItemCTABlockUrl":"video-card-item_discountCarouselItemCTABlockUrl__HmmAI","discountCarouselItemCTABlockBtn":"video-card-item_discountCarouselItemCTABlockBtn__eVT09"};

/***/ }),

/***/ 5957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"discountCarousel":"video-card-list-item_discountCarousel__kwHiT","discountCarouselButtonNext":"video-card-list-item_discountCarouselButtonNext__4jtiG","discountCarouselButtonPrev":"video-card-list-item_discountCarouselButtonPrev__8vqaq","discountCarouselSlider":"video-card-list-item_discountCarouselSlider__Opxeq","discountCarouselSlide":"video-card-list-item_discountCarouselSlide__zDP_T","columnSpan":"video-card-list-item_columnSpan__ap0tC","columnSpanQuote":"video-card-list-item_columnSpanQuote__Y2zo3"};

/***/ }),

/***/ 393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCardSection":"video-card-section_videoCardSection__94WiR"};

/***/ }),

/***/ 6833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"video-card-selected_videoWrap__lprrk","videoWrapButtonPlay":"video-card-selected_videoWrapButtonPlay___b5GX","videoContainerWatchNow":"video-card-selected_videoContainerWatchNow__GfkFL","videoVideo":"video-card-selected_videoVideo__MiCyh","videoOverlay":"video-card-selected_videoOverlay__IRa1x","videoContainer":"video-card-selected_videoContainer__HFwGN","videoContainerImageBrand":"video-card-selected_videoContainerImageBrand__pmTbb","videoContainerTitle":"video-card-selected_videoContainerTitle__HRMQB","videoContainerDescription":"video-card-selected_videoContainerDescription__qPgyc","videoLink":"video-card-selected_videoLink__vuMHa","video-spin":"video-card-selected_video-spin___IqDe"};

/***/ }),

/***/ 6775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"video-card_videoCard__w2EFs","videoCardContainer":"video-card_videoCardContainer__Nfbuf","videoCardInfo":"video-card_videoCardInfo__aRRxW","right":"video-card_right__b7CKQ","infoImageBrand":"video-card_infoImageBrand__g_QOI","infoTitle":"video-card_infoTitle__A9z_e","infoDescription":"video-card_infoDescription__P5EOI","infoCTA":"video-card_infoCTA__elNwC","videoCardMediaContainer":"video-card_videoCardMediaContainer__Ab4oD","left":"video-card_left__p2607","videoCardMedia":"video-card_videoCardMedia__TI1Pi","mediaImageWrapper":"video-card_mediaImageWrapper__q7oGt","mediaImageBox":"video-card_mediaImageBox__z1Y8d","mediaImageMain":"video-card_mediaImageMain__w0iR4","mediaImageLink":"video-card_mediaImageLink__uldB1","mediaImageContainer":"video-card_mediaImageContainer__97Lag","mediaImageContainerButtonPlay":"video-card_mediaImageContainerButtonPlay__87yR9","mediaBackground":"video-card_mediaBackground__oUmov"};

/***/ }),

/***/ 5558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCarouselQuoteItem":"video-carousel-quote_videoCarouselQuoteItem__upXP7","videoCarouselQuoteItemContent":"video-carousel-quote_videoCarouselQuoteItemContent__M_pF7","videoCarouselQuoteItemAuthorName":"video-carousel-quote_videoCarouselQuoteItemAuthorName__ESigx"};

/***/ }),

/***/ 6223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCarousel":"video-carousel_videoCarousel__nZN5f","videoCarouselContainer":"video-carousel_videoCarouselContainer__kAcg4","videoCarouselButtonNext":"video-carousel_videoCarouselButtonNext__3v0ZC","videoCarouselButtonPrev":"video-carousel_videoCarouselButtonPrev__5AbQM","videoCarouselQuoteContainer":"video-carousel_videoCarouselQuoteContainer__ri83Y","videoCarouselQuoteContainerDivider":"video-carousel_videoCarouselQuoteContainerDivider__5n3LP","videoItem":"video-carousel_videoItem__4Opoa","videoItemContainer":"video-carousel_videoItemContainer__nAXZ_","videoItemThumbnailUrl":"video-carousel_videoItemThumbnailUrl__fyPRN"};

/***/ }),

/***/ 5719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoHero":"video-hero_videoHero__YBa6n","videoHeroTitle":"video-hero_videoHeroTitle__lo_4t","videoHeroTitleColored":"video-hero_videoHeroTitleColored__ZhBb7","videoHeroDescription":"video-hero_videoHeroDescription__UL0ur","videoHeroContainer":"video-hero_videoHeroContainer__V_Iho","videoHeroContent":"video-hero_videoHeroContent__hhfdd","vimeoVideo":"video-hero_vimeoVideo__pRf_H"};

/***/ })

}]);